import { h, Comment, defineComponent, onMounted, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, unref, normalizeClass, createCommentVNode, getCurrentInstance, ref, watch, resolveComponent, createBlock, withCtx, computed, createTextVNode, Fragment, markRaw, reactive, withDirectives, createStaticVNode, resolveDynamicComponent, mergeProps, useAttrs, resolveDirective, onBeforeUnmount, Transition, nextTick, onUnmounted, Teleport, onDeactivated, renderList, toRefs, vModelText, withModifiers, normalizeStyle, onBeforeUpdate, inject, onActivated, useSlots, createSlots, isRef, onBeforeMount, onUpdated, withKeys, toHandlers, renderSlot, normalizeProps, guardReactiveProps, toRaw, createApp } from "vue";
import { localeToFlagCode, useTheming as useTheming$1, Theme, useMessages, useActions, CompanyId, useI18n, getLanguageName, languages, config as config$1, useGoogleAPI, setupMessages } from "@odin/services";
import I18NextVue, { useTranslation } from "i18next-vue";
import { loadFlag, loadIcon, setupLoader } from "@odin/assets";
import VueTippy, { Tippy } from "vue-tippy";
import { get, debounce as debounce$1, throttle as throttle$1, uniq, set } from "lodash-es";
import xss from "xss";
import { redirect } from "@odin/utils";
import axios from "axios";
import { toString } from "qrcode";
import { formatDistanceToNowStrict } from "date-fns";
let counter = 0;
const components = {};
const requestSlot = (componentId, slotName, attrs) => {
  var _a;
  return (_a = components[componentId]) == null ? void 0 : _a.requestSlot(slotName, attrs);
};
const uikitRenderer = {
  mountComponent: (_opts) => {
    notInstalled();
    return { id: "", vm: {} };
  },
  update: (_id, _attrs, _requestSlot) => {
    notInstalled();
  },
  unMountComponent: (_id) => {
    notInstalled();
  }
};
const HyperApp = {
  __isTeleport: true,
  process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
    const { p: patch, mt: mount, um: unmount } = internals;
    uikitRenderer.mountComponent = (opts) => {
      const id = "p" + counter++;
      const vnode = h(
        opts.component,
        { ...opts.attrs, "component-id": id, "portalSlots": opts.slots }
      );
      components[id] = { ...opts, vnode };
      mount(vnode, opts.getContainer(), opts.getAnchor(), parentComponent, null, false, slotScopeIds, false);
      updateCssVars(vnode);
      return { id, vm: vnode };
    };
    uikitRenderer.update = (id, attrs, requestSlot2) => {
      const cmp = components[id];
      cmp.vnode.props = {};
      cmp.attrs = attrs;
      if (requestSlot2) {
        cmp.requestSlot = requestSlot2;
      }
      const newNode = h(cmp.component, { ...cmp.attrs, "component-id": id, "portalSlots": cmp.slots });
      patch(cmp.vnode, newNode, cmp.getContainer(), cmp.getAnchor(), null, null, false, slotScopeIds, false);
      cmp.vnode = newNode;
    };
    uikitRenderer.unMountComponent = (id) => {
      const vnode = components[id].vnode;
      unmount(vnode, parentComponent, parentSuspense, true, !!vnode.dynamicChildren);
      delete components[id];
    };
  },
  // eslint-disable-next-line vue/max-len
  remove(vnode, parent, suspence, optimized, { um: unmount }) {
    unmount(vnode.children[0], parent, suspence, true, !!vnode.children[0].dynamicChildren);
  }
};
function updateCssVars(vnode) {
  const ctx = vnode.ctx;
  if (ctx && ctx.ut) {
    let node = vnode.children[0].el;
    while (node !== vnode.targetAnchor) {
      if (node.nodeType === 1) {
        node.setAttribute("data-v-owner", ctx.uid);
      }
      node = node.nextSibling;
    }
    ctx.ut();
  }
}
function notInstalled() {
  console.log("Components package is not installed");
}
let getVNode = () => h(Comment, "anchor");
const setupPortalSlot = (target2) => {
  if (target2 === "vue2") {
    getVNode = () => h("div", []);
  }
};
const PortalSlot = (props, ctx) => {
  if (props.slot) {
    return props.slot(ctx.attrs);
  }
  const renderCallback = requestSlot(props.componentId, props.name, ctx.attrs);
  if (!renderCallback) {
    return ctx.slots.default ? ctx.slots.default() : [];
  }
  const vNode = getVNode();
  renderCallback({
    name: props.name || "default",
    // @ts-ignore
    getAnchor: () => vNode.el,
    // @ts-ignore
    getContainer: () => vNode.el.parentElement,
    attrs: ctx.attrs
  });
  return vNode;
};
PortalSlot.props = {
  name: {
    type: String,
    default: "default"
  },
  componentId: {
    type: String
  },
  slot: {
    default: () => void 0
  }
};
const _hoisted_1$r = { class: "item" };
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "TestItem",
  props: {
    title: { type: String, default: "" }
  },
  emits: {
    customClick: null,
    renderFinished: null
  },
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    onMounted(() => {
      emit("renderFinished", null);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$r, [
        createElementVNode("span", null, toDisplayString(props.title), 1),
        createVNode(unref(PortalSlot), {
          "component-id": _ctx.$attrs["component-id"],
          name: "default"
        }, null, 8, ["component-id"]),
        createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event) => emit("customClick"))
        }, " Click me ")
      ]);
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target2 = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target2[key] = val;
  }
  return target2;
};
const TestItem = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-21944908"]]);
const _hoisted_1$q = { class: "ws-delimiter" };
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "WsDelimiter",
  props: {
    text: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    lineClass: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$q, [
        createElementVNode("div", {
          class: normalizeClass(["ws-delimiter__line", __props.lineClass])
        }, null, 2),
        __props.text ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["ws-delimiter__text ws-typo-xs", __props.textClass])
        }, toDisplayString(_ctx.$t(__props.text)), 3)) : createCommentVNode("", true),
        __props.text ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["ws-delimiter__line", __props.lineClass])
        }, null, 2)) : createCommentVNode("", true)
      ]);
    };
  }
});
const WsDelimiter = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-01861062"]]);
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "WsTooltip",
  props: {
    placement: {
      type: String,
      default: "top"
    },
    maxWidth: {
      type: [String, Number],
      default: "100%"
    },
    // Only show the tooltip when the parent is overflowing
    onOverflowOnly: {
      type: Boolean,
      default: false
    },
    onDark: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [0, 14]
    },
    modelValue: {
      type: Boolean,
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  setup(__props, { expose: __expose }) {
    var _a;
    const props = __props;
    const instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
    const enabled = ref(true);
    const tippyEl = ref(null);
    watch(() => props.modelValue, (newValue) => {
      if (!tippyEl.value) {
        return;
      }
      newValue ? tippyEl.value.show() : tippyEl.value.hide();
    });
    onMounted(() => {
      if (props.onOverflowOnly) {
        const parent = instance.$el.parentNode;
        if (parent) {
          enabled.value = parent.scrollWidth > parent.clientWidth;
        }
      }
    });
    const show = () => {
      tippyEl.value.show();
    };
    const hide = () => {
      tippyEl.value.hide();
    };
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return enabled.value ? (openBlock(), createBlock(unref(Tippy), {
        key: 0,
        ref_key: "tippyEl",
        ref: tippyEl,
        to: "parent",
        interactive: true,
        duration: [350, 350],
        delay: [__props.delay, __props.hideDelay],
        "max-width": __props.maxWidth,
        placement: __props.placement,
        offset: __props.offset,
        "popper-options": {
          strategy: "fixed"
        },
        theme: "websupport",
        "hide-on-click": typeof __props.modelValue === "undefined",
        trigger: typeof __props.modelValue === "undefined" ? "mouseenter focus" : "manual"
      }, {
        default: withCtx(() => [
          createVNode(_component_portal_slot, {
            slot: _ctx.$slots.default,
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ]),
        _: 1
      }, 8, ["delay", "max-width", "placement", "offset", "hide-on-click", "trigger"])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$p = { key: 0 };
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "WsEllipsisShortener",
  props: {
    modelValue: {
      type: String,
      required: true
    },
    alwaysVisibleSuffix: {
      type: String,
      default: null
    },
    isDomain: {
      type: Boolean,
      default: false
    },
    innerEllipsis: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const isShortened = ref(false);
    const isMasked = ref(false);
    const shortenedElementRef = ref(null);
    const shortenedString = computed(() => {
      if (props.alwaysVisibleSuffix) {
        const suffixLength = props.alwaysVisibleSuffix.length + (props.isDomain ? 1 : 0);
        return props.modelValue.slice(0, -suffixLength);
      } else if (props.innerEllipsis) {
        return getMaskedString(props.modelValue);
      }
      return props.modelValue;
    });
    onMounted(() => {
      const shortenedElement = shortenedElementRef.value;
      const resizeObserver = new ResizeObserver((entries) => {
        const shortableElement = entries[0].target;
        isShortened.value = shortableElement.scrollWidth > shortableElement.clientWidth;
      });
      if (shortenedElement) {
        resizeObserver.observe(shortenedElement);
      }
    });
    const getMaskedString = (value, mask = "...", fromStart = 4, fromEnd = 3) => {
      const trimmedValue = value.trim();
      const length = trimmedValue.length;
      if (length < 12) {
        return trimmedValue;
      }
      const maskedValue = `${trimmedValue.substring(0, fromStart)}${mask}${fromEnd ? trimmedValue.slice(-fromEnd) : ""}`;
      isMasked.value = true;
      return maskedValue;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["ws-ellipsis-shortener", { masked: isMasked.value }])
      }, [
        createElementVNode("span", {
          ref_key: "shortenedElementRef",
          ref: shortenedElementRef,
          class: "ws-ellipsis-shortener__shortened"
        }, toDisplayString(shortenedString.value), 513),
        _cache[0] || (_cache[0] = createTextVNode()),
        __props.alwaysVisibleSuffix ? (openBlock(), createElementBlock("span", _hoisted_1$p, [
          __props.isDomain ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(".")
          ], 64)) : createCommentVNode("", true),
          createTextVNode(toDisplayString(__props.alwaysVisibleSuffix), 1)
        ])) : createCommentVNode("", true),
        isShortened.value || isMasked.value ? (openBlock(), createBlock(_sfc_main$B, {
          key: 1,
          placement: "top"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.modelValue), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const WsEllipsisShortener = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-d0c8524a"]]);
const _sfc_main$z = {};
const _hoisted_1$o = { class: "ws-typography horizontal-divider col-12" };
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$o, _cache[0] || (_cache[0] = [
    createElementVNode("div", { class: "horizontal-line" }, null, -1)
  ]));
}
const WsHorizontalDivider = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$2], ["__scopeId", "data-v-e91930be"]]);
const _sfc_main$y = defineComponent({
  name: "WsHtml",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    element: {
      type: String,
      default: "span"
    }
  },
  setup(props) {
    return () => {
      const sanitizedHtml = xss(props.modelValue);
      return h(props.element, {
        innerHTML: sanitizedHtml
      });
    };
  }
});
const useDarkProps = {
  dark: {
    type: Boolean,
    default: null
  }
};
function useDark(props, $q) {
  return computed(() => props.dark === null ? $q.dark.isActive : props.dark);
}
const useSizeDefaults = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
};
const useSizeProps = {
  size: String
};
function useSize(props, sizes = useSizeDefaults) {
  return computed(() => props.size !== void 0 ? { fontSize: props.size in sizes ? `${sizes[props.size]}px` : props.size } : null);
}
function injectProp(target2, propName, get2, set2) {
  Object.defineProperty(target2, propName, {
    get: get2,
    set: set2,
    enumerable: true
  });
  return target2;
}
function createComponent(raw) {
  return markRaw(defineComponent(raw));
}
function createDirective(raw) {
  return markRaw(raw);
}
const createReactivePlugin = (state, plugin) => {
  const reactiveState = reactive(state);
  for (const name in state) {
    injectProp(
      plugin,
      name,
      () => reactiveState[name],
      (val) => {
        reactiveState[name] = val;
      }
    );
  }
  return plugin;
};
function hSlot(slot, otherwise) {
  return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot(slot, otherwise) {
  if (slot !== void 0) {
    const vnode = slot();
    if (vnode !== void 0 && vnode !== null) {
      return vnode.slice();
    }
  }
  return otherwise;
}
function hMergeSlot(slot, source) {
  return slot !== void 0 ? source.concat(slot()) : source;
}
function hMergeSlotSafely(slot, source) {
  if (slot === void 0) {
    return source;
  }
  return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir(tag, data, children, key, condition, getDirsFn) {
  data.key = key + condition;
  const vnode = h(tag, data, children);
  return condition === true ? withDirectives(vnode, getDirsFn()) : vnode;
}
const defaultSizes$2 = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function width(val, reverse, $q) {
  return {
    transform: reverse === true ? `translateX(${$q.lang.rtl === true ? "-" : ""}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
  };
}
const QLinearProgress = createComponent({
  name: "QLinearProgress",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(props, { slots }) {
    const { proxy } = getCurrentInstance();
    const isDark = useDark(props, proxy.$q);
    const sizeStyle = useSize(props, defaultSizes$2);
    const motion = computed(() => props.indeterminate === true || props.query === true);
    const widthReverse = computed(() => props.reverse !== props.query);
    const style = computed(() => ({
      ...sizeStyle.value !== null ? sizeStyle.value : {},
      "--q-linear-progress-speed": `${props.animationSpeed}ms`
    }));
    const classes = computed(
      () => "q-linear-progress" + (props.color !== void 0 ? ` text-${props.color}` : "") + (props.reverse === true || props.query === true ? " q-linear-progress--reverse" : "") + (props.rounded === true ? " rounded-borders" : "")
    );
    const trackStyle = computed(() => width(props.buffer !== void 0 ? props.buffer : 1, widthReverse.value, proxy.$q));
    const transitionSuffix = computed(() => `with${props.instantFeedback === true ? "out" : ""}-transition`);
    const trackClass = computed(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value === true ? "dark" : "light"}` + (props.trackColor !== void 0 ? ` bg-${props.trackColor}` : "")
    );
    const modelStyle = computed(() => width(motion.value === true ? 1 : props.value, widthReverse.value, proxy.$q));
    const modelClass = computed(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value === true ? "in" : ""}determinate`
    );
    const stripeStyle = computed(() => ({ width: `${props.value * 100}%` }));
    const stripeClass = computed(
      () => `q-linear-progress__stripe absolute-${props.reverse === true ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`
    );
    return () => {
      const child = [
        h("div", {
          class: trackClass.value,
          style: trackStyle.value
        }),
        h("div", {
          class: modelClass.value,
          style: modelStyle.value
        })
      ];
      props.stripe === true && motion.value === false && child.push(
        h("div", {
          class: stripeClass.value,
          style: stripeStyle.value
        })
      );
      return h("div", {
        class: classes.value,
        style: style.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": props.indeterminate === true ? void 0 : props.value
      }, hMergeSlot(slots.default, child));
    };
  }
});
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "WsLinearProgress",
  props: {
    modelValue: { type: Number, default: void 0 },
    size: { type: String, default: "" },
    color: { type: String, default: "" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QLinearProgress), {
        color: __props.color ? __props.color : "focus",
        value: __props.modelValue,
        size: __props.size,
        class: normalizeClass([
          "ws-linear-progress",
          {
            "ws-linear-progress--gradient-green": isNaN(__props.modelValue),
            "ws-linear-progress--gradient-primary": __props.color === "primary" && isNaN(__props.modelValue)
          }
        ])
      }, null, 8, ["color", "value", "size", "class"]);
    };
  }
});
const WsLinearProgress = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-ce164aac"]]);
const _hoisted_1$n = ["innerHTML"];
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "WsQrCode",
  props: {
    content: { type: String, default: "" }
  },
  setup(__props) {
    const props = __props;
    const qrSvg = ref("");
    const updateQrContents = () => toString(
      props.content,
      {
        errorCorrectionLevel: "L",
        // Low
        type: "svg",
        width: 200,
        margin: 0
      },
      (err, url) => {
        qrSvg.value = url;
      }
    );
    watch(
      () => props.content,
      () => {
        updateQrContents();
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "qr-code-wrapper",
        innerHTML: qrSvg.value
      }, null, 8, _hoisted_1$n);
    };
  }
});
const WsQrCode = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-babbd241"]]);
const _hoisted_1$m = ["src", "alt"];
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "WsCountryFlag",
  props: {
    country: { type: String, default: "" },
    size: { type: String, default: "medium" }
  },
  setup(__props) {
    const props = __props;
    const flagImage = ref("");
    async function getImage() {
      try {
        flagImage.value = await loadFlag(localeToFlagCode(props.country).toUpperCase());
      } catch (err) {
        console.error(`Country flag not found (${props.country.toUpperCase()}).`);
        console.error(err);
      }
    }
    getImage();
    return (_ctx, _cache) => {
      return __props.country ? (openBlock(), createElementBlock("img", {
        key: 0,
        class: normalizeClass(["ws-country-flag", __props.size]),
        src: flagImage.value,
        alt: __props.country
      }, null, 10, _hoisted_1$m)) : createCommentVNode("", true);
    };
  }
});
const WsCountryFlag = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-87368271"]]);
const cache = {};
const defaultIcon = '<rect x="20%" y="20%" stroke="#555" fill="none" width="60%" height="60%"/>';
const _sfc_main$u = defineComponent({
  name: "WsIcon",
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: void 0
    },
    size: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: 16
    },
    width: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  emits: ["loaded", "unloaded", "error"],
  // eslint-disable-next-line max-lines-per-function
  setup(props, vm) {
    const svgElSource = ref(null);
    const classes = computed(() => {
      const classes2 = ["ws-icon"];
      if (vm.attrs.class) {
        classes2.push(vm.attrs.class);
      }
      if (props.color) {
        classes2.push("text-" + props.color);
      }
      if (props.circle) {
        classes2.push("ws-icon--circle");
      }
      return classes2.join(" ");
    });
    const styles = computed(() => {
      let height;
      let width2;
      if (props.size) {
        height = props.size.toString();
        width2 = props.size.toString();
      } else {
        height = props.height;
        width2 = props.width;
      }
      return [
        `
      height: ${height}px;
      min-height: ${height}px;
      width: ${width2}px;
      min-width: ${width2}px;
     `,
        vm.attrs.style
      ];
    });
    const filterAttrs = (attrs) => {
      return Object.keys(attrs).reduce((result, key) => {
        if (attrs[key] !== false && attrs[key] !== null && attrs[key] !== void 0) {
          result[key] = attrs[key];
        }
        return result;
      }, {});
    };
    const getSvgAttrs = (svgEl) => {
      const svgAttrs = {
        class: classes.value,
        title: props.name,
        style: styles.value,
        "data-test": `ws-icon-${props.name}`
      };
      if (svgEl) {
        const attrs = svgEl.attributes;
        if (!attrs) {
          return svgAttrs;
        }
        for (let i = attrs.length - 1; i >= 0; i--) {
          svgAttrs[attrs[i].name] = attrs[i].value;
        }
      }
      return svgAttrs;
    };
    const download = (name) => {
      return new Promise((resolve, reject) => {
        loadIcon(name).then((icon) => {
          const iconSvg = decodeURIComponent(icon.replace("data:image/svg+xml,", ""));
          try {
            const parser = new DOMParser();
            const result = parser.parseFromString(iconSvg, "text/xml");
            const svgEl = result.getElementsByTagName("svg")[0];
            if (svgEl) {
              resolve(svgEl);
            } else {
              reject(new Error('Loaded file is not valid SVG"'));
            }
          } catch (e) {
            reject(e);
          }
        });
      });
    };
    const getSource = (name) => {
      if (!cache[name]) {
        cache[name] = download(name);
      }
      cache[name].then((svg) => {
        svgElSource.value = svg;
      }).catch((err) => {
        delete cache[name];
        vm.emit("error", err);
      });
    };
    watch(() => props.name, () => {
      getSource(props.name);
    }, { immediate: true });
    return (vm2) => {
      return h(
        "svg",
        Object.assign(
          { innerHTML: svgElSource.value ? svgElSource.value.innerHTML : defaultIcon },
          // component attrs and listeners
          filterAttrs(vm2.$attrs),
          // source attrs
          getSvgAttrs(svgElSource.value)
        )
      );
    };
  }
});
const WsIcon = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-6cad285f"]]);
const useSpinnerProps = {
  size: {
    type: [String, Number],
    default: "1em"
  },
  color: String
};
function useSpinner(props) {
  return {
    cSize: computed(() => props.size in useSizeDefaults ? `${useSizeDefaults[props.size]}px` : props.size),
    classes: computed(
      () => "q-spinner" + (props.color ? ` text-${props.color}` : "")
    )
  };
}
const innerHTML = '<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity=".3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
const QSpinnerDots = createComponent({
  name: "QSpinnerDots",
  props: useSpinnerProps,
  setup(props) {
    const { cSize, classes } = useSpinner(props);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML
    });
  }
});
const QSpinner = createComponent({
  name: "QSpinner",
  props: {
    ...useSpinnerProps,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(props) {
    const { cSize, classes } = useSpinner(props);
    return () => h("svg", {
      class: classes.value + " q-spinner-mat",
      width: cSize.value,
      height: cSize.value,
      viewBox: "25 25 50 50"
    }, [
      h("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": props.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
const COLORS = {
  dark: "dark",
  white: "white"
};
const _hoisted_1$l = ["width", "height"];
const _hoisted_2$h = ["id"];
const _hoisted_3$c = ["fill"];
const _hoisted_4$7 = {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_5$4 = { id: "junglebug" };
const _hoisted_6$2 = { id: "Fill-1-Clipped" };
const _hoisted_7$2 = ["fill"];
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "WsCarySpinner",
  props: {
    color: {
      type: String,
      default: "dark",
      validator: (value) => !!value && value in COLORS
    },
    width: {
      type: String,
      default: "80px"
    },
    height: {
      type: String,
      default: "30px"
    }
  },
  setup(__props) {
    const props = __props;
    const normalizedColor = computed(() => {
      return props.color === "dark" || props.color === "white" ? props.color : "default";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: "ws-cary-spinner",
        width: props.width,
        height: props.height,
        viewBox: "0 0 64 26",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _cache[1] || (_cache[1] = createStaticVNode('<defs data-v-2bfc88f6><linearGradient id="gradient_dark" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(44, 56, 67, 0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:rgba(44, 56, 67, 1);" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(44, 56, 67, 0);" data-v-2bfc88f6></stop></linearGradient><linearGradient id="gradient_white" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(255,255,255,0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:rgba(255,255,255,1);" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(255,255,255,0);" data-v-2bfc88f6></stop></linearGradient><linearGradient id="gradient_default" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(0,250,160,0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:#00FFA0;" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(0,250,160,0);" data-v-2bfc88f6></stop></linearGradient></defs>', 1)),
        createElementVNode("pattern", {
          id: `pattern_${normalizedColor.value}`,
          x: "0",
          y: "0",
          width: "400%",
          height: "100%",
          patternUnits: "userSpaceOnUse"
        }, [
          createElementVNode("rect", {
            x: "-100%",
            y: "0",
            width: "200%",
            height: "100%",
            fill: `url(#gradient_${normalizedColor.value})`,
            transform: "rotate(0)"
          }, _cache[0] || (_cache[0] = [
            createElementVNode("animate", {
              attributeType: "XML",
              attributeName: "x",
              from: "-400%",
              to: "100%",
              dur: "1.25s",
              repeatCount: "indefinite"
            }, null, -1)
          ]), 8, _hoisted_3$c)
        ], 8, _hoisted_2$h),
        createElementVNode("g", _hoisted_4$7, [
          createElementVNode("g", _hoisted_5$4, [
            createElementVNode("g", _hoisted_6$2, [
              createElementVNode("path", {
                id: "Fill-1",
                fill: `url(#pattern_${normalizedColor.value})`,
                "fill-rule": "nonzero",
                d: "M10.6641 20.0838L17.9686 3.22916C18.5365 1.86109 19.8652\n               0.982178 21.3326 0.982178C22.8043 0.982178 24.0821 1.86109\n               24.6998 3.22916L31.9989 20.0838L39.3013 3.22916C39.8713 1.86109\n               41.1978 0.982178 42.6663 0.982178C44.137 0.982178 45.4158\n               1.86109 46.0335 3.22916L53.3315 20.0838L60.636 3.22916C61.2039\n               1.86109 62.5315 0.982178 64 0.982178V6.50359L56.8429\n               22.7227C56.1764 24.188 54.8499 25.0177 53.3315 25.0177C51.8154\n               25.0177 50.4867 24.188 49.8267 22.7227L42.6663 6.50359L35.5092\n               22.7227C34.8427 24.188 33.5151 25.0177 31.9989 25.0177C30.4817\n               25.0177 29.1541 24.188 28.493 22.7227L21.3326 6.50359L14.1755\n               22.7227C13.509 24.188 12.1825 25.0177 10.6641 25.0177C9.14796\n               25.0177 7.82037 24.188 7.1582 22.7227L0 6.50359V0.982178C1.46957\n               0.982178 2.74949 1.86109 3.36614 3.22916L10.6641 20.0838Z"
              }, null, 8, _hoisted_7$2)
            ])
          ])
        ])
      ], 8, _hoisted_1$l);
    };
  }
});
const WsCarySpinner = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-2bfc88f6"]]);
var SpinnerType = /* @__PURE__ */ ((SpinnerType2) => {
  SpinnerType2["CARY"] = "cary";
  SpinnerType2["CIRCULAR"] = "circular";
  SpinnerType2["DOTS"] = "dots";
  SpinnerType2["NONE"] = "";
  return SpinnerType2;
})(SpinnerType || {});
const SpinnerType$1 = SpinnerType;
const _sfc_main$s = defineComponent({
  name: "WsSpinner",
  components: {
    QSpinner,
    QSpinnerDots,
    WsCarySpinner
  },
  props: {
    spinnerType: {
      type: String,
      default: ""
    },
    width: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    height: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    color: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  data(props) {
    const spinnerType = props.spinnerType;
    const { isTheme: isTheme2 } = useTheming$1();
    const spinnerTypes = {
      [SpinnerType.CIRCULAR]: "q-spinner",
      [SpinnerType.CARY]: "ws-cary-spinner",
      [SpinnerType.DOTS]: "q-spinner-dots"
    };
    const currentSpinner = computed(() => {
      if (spinnerType in spinnerTypes) {
        return spinnerTypes[spinnerType];
      } else if (isTheme2(Theme.CARY)) {
        return "ws-cary-spinner";
      } else if (isTheme2(Theme.LOOPIA) || isTheme2(Theme.ACTIVE_24)) {
        return "q-spinner-dots";
      } else {
        return "q-spinner";
      }
    });
    const getSpinnerDefaultSize = computed(() => {
      if (spinnerType && spinnerType === SpinnerType.CIRCULAR || isTheme2(Theme.ADMIN)) {
        return props.width || "24px";
      } else {
        return props.width || "80px";
      }
    });
    const getSpinnerColor = computed(() => {
      if (props.color) {
        return props.color;
      } else if (isTheme2(Theme.CARY)) {
        return "dark";
      } else if (isTheme2(Theme.LOOPIA)) {
        return "white";
      } else {
        return void 0;
      }
    });
    return {
      Theme,
      SpinnerType,
      currentSpinner,
      getSpinnerDefaultSize,
      getSpinnerColor
    };
  }
});
const _hoisted_1$k = { class: "ws-spinner" };
const _hoisted_2$g = {
  key: 0,
  class: "text q-ml-md"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$k, [
    (openBlock(), createBlock(resolveDynamicComponent(_ctx.currentSpinner), mergeProps(_ctx.$attrs, {
      width: _ctx.getSpinnerDefaultSize,
      height: _ctx.height,
      color: _ctx.getSpinnerColor
    }), null, 16, ["width", "height", "color"])),
    _ctx.text ? (openBlock(), createElementBlock("span", _hoisted_2$g, toDisplayString(_ctx.$t(_ctx.text)), 1)) : createCommentVNode("", true)
  ]);
}
const WsSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$1], ["__scopeId", "data-v-a66e7e7a"]]);
var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["PRIMARY"] = "primary";
  ButtonType2["SECONDARY"] = "secondary";
  ButtonType2["SECONDARY_INVERSE"] = "secondary-inverse";
  ButtonType2["GHOST"] = "ghost";
  ButtonType2["GHOST_INVERSE"] = "ghost-inverse";
  ButtonType2["DANGER"] = "danger";
  ButtonType2["AGENT"] = "agent";
  ButtonType2["TERTIARY"] = "tertiary";
  ButtonType2["TERTIARY_AGENT"] = "tertiary-agent";
  ButtonType2["TERTIARY_DANGER"] = "tertiary-danger";
  ButtonType2["TERTIARY_NEUTRAL"] = "tertiary-neutral";
  ButtonType2["TERTIARY_WHITE"] = "tertiary-white";
  return ButtonType2;
})(ButtonType || {});
var ButtonElement = /* @__PURE__ */ ((ButtonElement2) => {
  ButtonElement2["A"] = "a";
  ButtonElement2["BUTTON"] = "button";
  return ButtonElement2;
})(ButtonElement || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["SMALL"] = "small";
  ButtonSize2["MEDIUM"] = "medium";
  ButtonSize2["LARGE"] = "large";
  ButtonSize2["XL"] = "xl";
  return ButtonSize2;
})(ButtonSize || {});
const WsButtonEnum = {
  Type: ButtonType,
  Element: ButtonElement,
  Size: ButtonSize
};
const _theme = ref(Theme.CARY);
const useTheming = () => {
  return {
    theme: _theme,
    isTheme,
    setTheme
  };
};
const isTheme = (theme) => {
  return _theme.value === theme;
};
const setTheme = (theme) => {
  _theme.value = theme;
};
const themingPlugin = {
  install: (app2) => {
    const { theme, onTheme } = useTheming$1();
    _theme.value = theme;
    onTheme((value) => _theme.value = value);
    app2.config.globalProperties.$theme = _theme;
  }
};
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "WsButton",
  props: {
    // Keep these first, so they can be used in default values.
    href: {
      type: String,
      required: false,
      default: void 0
    },
    type: {
      type: String,
      required: false,
      default: ButtonType.GHOST
    },
    element: {
      type: String,
      required: false,
      default: (props) => {
        if (props.submit) {
          return ButtonElement.BUTTON;
        }
        if (props.href && !props.ajax || props.targetBlank) {
          return ButtonElement.A;
        }
        return ButtonElement.BUTTON;
      }
    },
    size: {
      type: String,
      required: false,
      default: (props) => {
        if ([
          ButtonType.TERTIARY,
          ButtonType.TERTIARY_NEUTRAL,
          ButtonType.TERTIARY_AGENT,
          ButtonType.TERTIARY_DANGER
        ].includes(props.type)) {
          return ButtonSize.SMALL;
        }
        return ButtonSize.LARGE;
      }
    },
    icon: {
      type: String,
      required: false,
      default: void 0
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderColor: {
      type: String,
      required: false,
      default: void 0
    },
    // Ajax props
    ajax: {
      type: Boolean,
      required: false,
      default: false
    },
    url: {
      type: String,
      required: false,
      default: void 0
    },
    ajaxMethod: {
      type: String,
      required: false,
      default: "POST"
    },
    ajaxErrorMessagePath: {
      type: String,
      required: false,
      default: "general"
    },
    ajaxParams: {
      type: [Object, Array],
      required: false,
      default: () => {
      }
    },
    onSuccess: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    responseType: {
      type: String,
      required: false,
      default: void 0
    },
    label: {
      type: String,
      required: false,
      default: void 0
    },
    tooltip: {
      type: String,
      required: false,
      default: void 0
    },
    // Flags
    submit: {
      type: Boolean,
      required: false,
      default: void 0
    },
    targetBlank: {
      type: Boolean,
      required: false,
      default: void 0
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: void 0
    },
    noIconType: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    "ajax-action-start",
    "ajax-action-success",
    "ajax-action-failed"
  ],
  setup(__props, { emit: __emit }) {
    const { isTheme: isTheme2 } = useTheming();
    const { handleUnstructuredError } = useMessages();
    const { responseAction } = useActions();
    const attrs = useAttrs();
    const props = __props;
    const emits = __emit;
    const tooltipValue = ref(false);
    const ajaxLoading = ref(false);
    const isLoading = computed(() => props.ajax ? ajaxLoading.value : props.loading);
    const getLoaderColor = () => {
      if (props.loaderColor) {
        return props.loaderColor;
      }
      if (props.disabled) {
        return "dark";
      }
      switch (props.type) {
        case ButtonType.PRIMARY:
          return "button-primary";
        case ButtonType.DANGER:
          return "white";
        case ButtonType.SECONDARY:
          return "dark";
        default:
          return props.loaderColor;
      }
    };
    const iconOnly = () => {
      var _a;
      return !props.noIconType && !props.label && !((_a = attrs.portalSlots) == null ? void 0 : _a.includes("default"));
    };
    const iconSize = computed(() => {
      if ([
        ButtonType.TERTIARY,
        ButtonType.TERTIARY_NEUTRAL,
        ButtonType.TERTIARY_AGENT,
        ButtonType.TERTIARY_DANGER
      ].includes(props.type)) {
        return 16;
      }
      switch (props.size) {
        case ButtonSize.SMALL:
          return 16;
        case ButtonSize.MEDIUM:
        case ButtonSize.LARGE:
        case ButtonSize.XL:
        default:
          return 24;
      }
    });
    const getExtraAttrs = () => {
      let extraAttrs = {};
      if (props.element === ButtonElement.A) {
        extraAttrs["role"] = "button";
        if (!props.disabled) {
          extraAttrs["href"] = props.href;
        }
        if (props.targetBlank) {
          extraAttrs["target"] = "_blank";
        }
      } else if (props.submit ?? props.type === ButtonType.PRIMARY) {
        extraAttrs = {
          type: "submit"
        };
      } else {
        extraAttrs = {
          type: "button"
        };
      }
      return { ...attrs, ...extraAttrs };
    };
    const requestHeaders = () => {
      var _a, _b;
      const headers = {};
      if (!((_a = props.onSuccess) == null ? void 0 : _a.reload) && !((_b = props.onSuccess) == null ? void 0 : _b.redirect)) {
        headers["X-WITH-FLASH-MESSAGES"] = "1";
      }
      return headers;
    };
    const buttonAjaxCall = async () => {
      if (props.disabled || isLoading.value) {
        return false;
      }
      if (!props.ajax) {
        return true;
      }
      try {
        emits("ajax-action-start");
        ajaxLoading.value = true;
        const { data, headers } = await axios({
          url: props.url,
          data: props.ajaxParams,
          method: props.ajaxMethod,
          headers: requestHeaders(),
          responseType: props.responseType
        });
        const actionResponse = await responseAction(data, headers, props.onSuccess);
        emits("ajax-action-success", data);
        ajaxLoading.value = await actionResponse.actionPromise;
      } catch (error) {
        console.error(error);
        handleUnstructuredError(props.ajaxErrorMessagePath, error);
        emits("ajax-action-failed", error);
        ajaxLoading.value = false;
      }
    };
    const wsAnalyticsValue = computed(() => {
      return attrs["ws-analytics"] || attrs["v-ws-analytics"];
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      const _directive_ws_analytics = resolveDirective("ws-analytics");
      return openBlock(), createElementBlock(Fragment, null, [
        __props.tooltip ? (openBlock(), createBlock(_sfc_main$B, {
          key: 0,
          placement: "top",
          "model-value": tooltipValue.value
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.tooltip), 1)
          ]),
          _: 1
        }, 8, ["model-value"])) : createCommentVNode("", true),
        withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.element), mergeProps({
          class: [
            "ws-button",
            `type-` + __props.type,
            `size-` + __props.size,
            {
              "icon-only": iconOnly(),
              "icon-right": __props.iconRight,
              "full-width": __props.fullWidth,
              "state-loading": isLoading.value
            }
          ],
          disabled: __props.disabled ? true : null
        }, getExtraAttrs(), {
          onClick: buttonAjaxCall,
          onMouseenter: _cache[0] || (_cache[0] = ($event) => tooltipValue.value = true),
          onFocusin: _cache[1] || (_cache[1] = ($event) => tooltipValue.value = true),
          onMouseleave: _cache[2] || (_cache[2] = ($event) => tooltipValue.value = false),
          onFocusout: _cache[3] || (_cache[3] = ($event) => tooltipValue.value = false)
        }), {
          default: withCtx(() => [
            isLoading.value ? (openBlock(), createBlock(WsSpinner, {
              key: 0,
              color: getLoaderColor(),
              width: unref(isTheme2)(unref(Theme).ACTIVE_24) ? "50px" : void 0
            }, null, 8, ["color", "width"])) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass(["ws-button__content", { "loading": isLoading.value }])
            }, [
              __props.icon ? (openBlock(), createBlock(WsIcon, {
                key: 0,
                name: __props.icon,
                size: iconSize.value
              }, null, 8, ["name", "size"])) : createCommentVNode("", true),
              __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.label), 1)
              ], 64)) : (openBlock(), createBlock(_component_portal_slot, {
                key: 2,
                slot: _ctx.$slots.default,
                "component-id": _ctx.$attrs["component-id"],
                name: "default"
              }, null, 8, ["slot", "component-id"]))
            ], 2)
          ]),
          _: 1
        }, 16, ["class", "disabled"])), [
          [_directive_ws_analytics, wsAnalyticsValue.value]
        ])
      ], 64);
    };
  }
});
const WsButton = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-33e378df"]]);
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "WsBack",
  props: {
    callback: { type: Function, required: false, default: null },
    url: { type: String, required: false, default: "" },
    icon: { type: String, required: false, default: "arrow_left" },
    isCancel: Boolean
  },
  setup(__props) {
    const props = __props;
    const goBack = () => {
      if (props.callback) {
        props.callback();
      } else if (props.url) {
        redirect(props.url);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(WsButton, mergeProps({
        class: "ws-back",
        icon: __props.isCancel ? void 0 : __props.icon,
        label: _ctx.$t(__props.isCancel ? "uikit:general.cancel" : "uikit:general.back"),
        type: unref(ButtonType).SECONDARY
      }, _ctx.$attrs, { onClick: goBack }), null, 16, ["icon", "label", "type"]);
    };
  }
});
let config;
const wsBase = "https://websupport";
const websupport = {
  help: {
    se: `${wsBase}.se/support`,
    hu: `${wsBase}.hu/tamogatas`,
    sk: `${wsBase}.sk/podpora`,
    cs: `${wsBase}.cz/podpora`,
    en_se: `${wsBase}.se/en/support`,
    en: `${wsBase}.se/en/support`
  },
  contact: {
    se: `${wsBase}.se/support`,
    hu: `${wsBase}.hu/kapcsolat`,
    sk: `${wsBase}.sk/kontakt`,
    cs: `${wsBase}.cz/kontakt`,
    en_se: `${wsBase}.se/en/support`,
    en: `${wsBase}.se/en/support`
  },
  terms: {
    se: `${wsBase}.se/om-websupport/avtalsvillkor`,
    hu: `${wsBase}.hu/aszf`,
    sk: `${wsBase}.sk/obchodne-podmienky`,
    cs: `${wsBase}.cz/obchodni-podminky`,
    en_se: `${wsBase}.se/en/about-websupport/terms-and-conditions`,
    en: `${wsBase}.se/en/about-websupport/terms-and-conditions`
  },
  privacy: {
    se: `${wsBase}.se/om-websupport/dataskyddspolicy`,
    hu: `${wsBase}.hu/adatvedelem`,
    sk: `${wsBase}.sk/sukromie`,
    cs: `${wsBase}.cz/soukromi`,
    en_se: `${wsBase}.se/en/about-websupport/terms-and-conditions`,
    en: `${wsBase}.se/en/about-websupport/data-protection`
  },
  webadmin: {
    se: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=standard",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=standard",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=standard",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=standard",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard"
  },
  webadmin_email: {
    se: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=email",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=email",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=email",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=email",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email"
  }
};
const loopiaBase = "https://loopia";
const loopia = {
  help: {
    sv: `${loopiaBase}.se/support`,
    en_se: `${loopiaBase}.com/support`
  },
  contact: {
    sv: `${loopiaBase}.se/support`,
    en_se: `${loopiaBase}.com/support`
  },
  terms: {
    sv: `${loopiaBase}.se/avtalsvillkor`,
    en_se: `${loopiaBase}.com/terms-and-conditions/`
  },
  privacy: {
    sv: `${loopiaBase}.se/omloopia/dataskydd/`,
    en_se: `${loopiaBase}.com/aboutloopia/data-protection/`
  },
  webadmin: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  },
  webadmin_email: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  }
};
const googleTermsOfServiceBaseUrl = "https://policies.google.com/terms?hl=";
const googlePrivacyBaseUrl = "https://policies.google.com/privacy?hl=";
let adminBase = "https://admin.websupport";
const globalUrls = () => {
  return {
    // Maybe needs to be moved to the company specific part
    admin: {
      se: `${adminBase}.se`,
      hu: `${adminBase}.hu`,
      sk: `${adminBase}.sk`,
      cs: `${adminBase}.cz`,
      en_se: `${adminBase}.se/en`,
      en: `${adminBase}.se/en`
    },
    googleTermsOfService: {
      se: `${googleTermsOfServiceBaseUrl}sv`,
      hu: `${googleTermsOfServiceBaseUrl}hu`,
      sk: `${googleTermsOfServiceBaseUrl}sk`,
      cs: `${googleTermsOfServiceBaseUrl}cs`,
      en_se: `${googleTermsOfServiceBaseUrl}en`,
      en: `${googleTermsOfServiceBaseUrl}en`
    },
    googlePrivacy: {
      se: `${googlePrivacyBaseUrl}sv`,
      hu: `${googlePrivacyBaseUrl}hu`,
      sk: `${googlePrivacyBaseUrl}sk`,
      cs: `${googlePrivacyBaseUrl}cs`,
      en_se: `${googlePrivacyBaseUrl}en`,
      en: `${googlePrivacyBaseUrl}en`
    }
  };
};
const company = {
  ws: websupport,
  lp: loopia,
  global: globalUrls()
};
const getLangCode = (lang) => {
  let urlLang = lang.split("-").shift() || "";
  if ([CompanyId.WEBSUPPORT_SE, CompanyId.LOOPIA_SE].includes(config.company) && urlLang === "en") {
    urlLang += "_se";
  }
  return urlLang;
};
const getTLD = (url) => {
  return new URL(url).hostname.split(".").pop() || "";
};
const replaceLanguage = (key, currentLanguage) => {
  const tld = getTLD(window.location.href);
  const locale = currentLanguage === "en_se" ? "en" : currentLanguage;
  const adminUrl = get(company, [config.company, key, tld]);
  if (!adminUrl) {
    return void 0;
  }
  const url = new URL(adminUrl);
  url.searchParams.set("l", locale);
  return url.toString();
};
function setupUrls(_config) {
  config = _config;
  adminBase = [CompanyId.LOOPIA_SE, CompanyId.LOOPIA_NO].includes(config.company) ? "https://admin.loopia" : "https://admin.websupport";
}
function getUrl(key, lang) {
  var _a, _b;
  const currentLanguage = getLangCode(lang);
  const companyCode = ((_b = (_a = config == null ? void 0 : config.company) == null ? void 0 : _a.id) == null ? void 0 : _b.split("-").pop()) || "";
  const companySpecific = get(company, [companyCode, key, currentLanguage]);
  if (key === "webadmin" || key === "webadmin_email") {
    const adminUrl = replaceLanguage(key, currentLanguage);
    if (adminUrl) {
      return adminUrl;
    }
  }
  if (companySpecific) {
    return companySpecific;
  }
  const generic = get(company, ["global", key, currentLanguage]);
  if (!generic) {
    console.error(`Url '${key}' not defined!`);
  }
  return generic;
}
const _hoisted_1$j = { class: "footer__text" };
const _hoisted_2$f = { class: "q-mb-sm" };
const _hoisted_3$b = ["innerHTML"];
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "WsHelpSection",
  props: {
    config: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    setupUrls(props.config);
    const { getLang, t } = useI18n();
    const { theme, isTheme: isTheme2 } = useTheming();
    const path = `assets/images/${theme.value.toLowerCase()}/logins`;
    const getFooterImage = computed(() => {
      switch (theme.value) {
        case Theme.LOOPIA:
          return {
            "srcset": `${path}/footer@2x.jpg 2x`,
            "src": `${path}/footer.jpg`,
            "width": 141,
            "height": 141
          };
        case Theme.ACTIVE_24:
        case Theme.CARY:
        default:
          return {
            "srcset": `${path}/footer@2x.png 2x`,
            "src": `${path}/footer.png`,
            "width": 143,
            "height": 121
          };
      }
    });
    const getText = (translation) => xss(translation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["footer", {
          "items-center": unref(isTheme2)(unref(Theme).ACTIVE_24) || unref(isTheme2)(unref(Theme).LOOPIA),
          "items-end": unref(isTheme2)(unref(Theme).CARY)
        }])
      }, [
        createElementVNode("div", _hoisted_1$j, [
          createElementVNode("h5", _hoisted_2$f, toDisplayString(unref(t)("uikit:login_pages.help.title")), 1),
          createElementVNode("p", {
            class: "customized-paragraph text-ws-base110 small q-mb-none",
            innerHTML: getText(
              _ctx.$t(
                "uikit:login_pages.help.text",
                { "kb_url": unref(getUrl)("help", unref(getLang)()), "support_url": unref(getUrl)("contact", unref(getLang)()) }
              )
            )
          }, null, 8, _hoisted_3$b)
        ]),
        createElementVNode("img", mergeProps(getFooterImage.value, {
          class: "footer__image q-ml-lg",
          alt: ""
        }), null, 16)
      ], 2);
    };
  }
});
const WsHelpSection = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-65ea84ae"]]);
const QCard = createComponent({
  name: "QCard",
  props: {
    ...useDarkProps,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(props, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = useDark(props, $q);
    const classes = computed(
      () => "q-card" + (isDark.value === true ? " q-card--dark q-dark" : "") + (props.bordered === true ? " q-card--bordered" : "") + (props.square === true ? " q-card--square no-border-radius" : "") + (props.flat === true ? " q-card--flat no-shadow" : "")
    );
    return () => h(props.tag, { class: classes.value }, hSlot(slots.default));
  }
});
const QItemSection = createComponent({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(props, { slots }) {
    const classes = computed(
      () => `q-item__section column q-item__section--${props.avatar === true || props.side === true || props.thumbnail === true ? "side" : "main"}` + (props.top === true ? " q-item__section--top justify-start" : " justify-center") + (props.avatar === true ? " q-item__section--avatar" : "") + (props.thumbnail === true ? " q-item__section--thumbnail" : "") + (props.noWrap === true ? " q-item__section--nowrap" : "")
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
const QItemLabel = createComponent({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(props, { slots }) {
    const parsedLines = computed(() => parseInt(props.lines, 10));
    const classes = computed(
      () => "q-item__label" + (props.overline === true ? " q-item__label--overline text-overline" : "") + (props.caption === true ? " q-item__label--caption text-caption" : "") + (props.header === true ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : "")
    );
    const style = computed(() => {
      return props.lines !== void 0 && parsedLines.value > 1 ? {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": parsedLines.value
      } : null;
    });
    return () => h("div", {
      style: style.value,
      class: classes.value
    }, hSlot(slots.default));
  }
});
function getParentProxy(proxy) {
  if (Object(proxy.$parent) === proxy.$parent) {
    return proxy.$parent;
  }
  let { parent } = proxy.$;
  while (Object(parent) === parent) {
    if (Object(parent.proxy) === parent.proxy) {
      return parent.proxy;
    }
    parent = parent.parent;
  }
}
function vmHasRouter(vm) {
  return vm.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed(vm) {
  return vm.isUnmounted === true || vm.isDeactivated === true;
}
function getOriginalPath(record) {
  return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord(a, b) {
  return (a.aliasOf || a) === (b.aliasOf || b);
}
function includesParams(outer, inner) {
  for (const key in inner) {
    const innerValue = inner[key], outerValue = outer[key];
    if (typeof innerValue === "string") {
      if (innerValue !== outerValue) {
        return false;
      }
    } else if (Array.isArray(outerValue) === false || outerValue.length !== innerValue.length || innerValue.some((value, i) => value !== outerValue[i])) {
      return false;
    }
  }
  return true;
}
function isEquivalentArray(a, b) {
  return Array.isArray(b) === true ? a.length === b.length && a.every((value, i) => value === b[i]) : a.length === 1 && a[0] === b;
}
function isSameRouteLocationParamsValue(a, b) {
  return Array.isArray(a) === true ? isEquivalentArray(a, b) : Array.isArray(b) === true ? isEquivalentArray(b, a) : a === b;
}
function isSameRouteLocationParams(a, b) {
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  for (const key in a) {
    if (isSameRouteLocationParamsValue(a[key], b[key]) === false) {
      return false;
    }
  }
  return true;
}
const useRouterLinkNonMatchingProps = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
const useRouterLinkProps = {
  ...useRouterLinkNonMatchingProps,
  // router-link
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  }
};
function useRouterLink({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
  const vm = getCurrentInstance();
  const { props, proxy, emit } = vm;
  const hasRouter = vmHasRouter(vm);
  const hasHrefLink = computed(() => props.disable !== true && props.href !== void 0);
  const hasRouterLinkProps = useDisableForRouterLinkProps === true ? computed(
    () => hasRouter === true && props.disable !== true && hasHrefLink.value !== true && props.to !== void 0 && props.to !== null && props.to !== ""
  ) : computed(
    () => hasRouter === true && hasHrefLink.value !== true && props.to !== void 0 && props.to !== null && props.to !== ""
  );
  const resolvedLink = computed(() => hasRouterLinkProps.value === true ? getLink(props.to) : null);
  const hasRouterLink = computed(() => resolvedLink.value !== null);
  const hasLink = computed(() => hasHrefLink.value === true || hasRouterLink.value === true);
  const linkTag = computed(() => props.type === "a" || hasLink.value === true ? "a" : props.tag || fallbackTag || "div");
  const linkAttrs = computed(() => hasHrefLink.value === true ? {
    href: props.href,
    target: props.target
  } : hasRouterLink.value === true ? {
    href: resolvedLink.value.href,
    target: props.target
  } : {});
  const linkActiveIndex = computed(() => {
    if (hasRouterLink.value === false) {
      return -1;
    }
    const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
    if (routeMatched === void 0) {
      return -1;
    }
    const currentMatched = proxy.$route.matched;
    if (currentMatched.length === 0) {
      return -1;
    }
    const index = currentMatched.findIndex(
      isSameRouteRecord.bind(null, routeMatched)
    );
    if (index !== -1) {
      return index;
    }
    const parentRecordPath = getOriginalPath(matched[length - 2]);
    return (
      // we are dealing with nested routes
      length > 1 && getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex(
        isSameRouteRecord.bind(null, matched[length - 2])
      ) : index
    );
  });
  const linkIsActive = computed(
    () => hasRouterLink.value === true && linkActiveIndex.value !== -1 && includesParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkIsExactActive = computed(
    () => linkIsActive.value === true && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkClass = computed(() => hasRouterLink.value === true ? linkIsExactActive.value === true ? ` ${props.exactActiveClass} ${props.activeClass}` : props.exact === true ? "" : linkIsActive.value === true ? ` ${props.activeClass}` : "" : "");
  function getLink(to) {
    try {
      return proxy.$router.resolve(to);
    } catch (_) {
    }
    return null;
  }
  function navigateToRouterLink(e, { returnRouterError, to = props.to, replace = props.replace } = {}) {
    if (props.disable === true) {
      e.preventDefault();
      return Promise.resolve(false);
    }
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button !== void 0 && e.button !== 0 || props.target === "_blank"
    ) {
      return Promise.resolve(false);
    }
    e.preventDefault();
    const promise = proxy.$router[replace === true ? "replace" : "push"](to);
    return returnRouterError === true ? promise : promise.then(() => {
    }).catch(() => {
    });
  }
  function navigateOnClick(e) {
    if (hasRouterLink.value === true) {
      const go = (opts) => navigateToRouterLink(e, opts);
      emit("click", e, go);
      e.defaultPrevented !== true && go();
    } else {
      emit("click", e);
    }
  }
  return {
    hasRouterLink,
    hasHrefLink,
    hasLink,
    linkTag,
    resolvedLink,
    linkIsActive,
    linkIsExactActive,
    linkClass,
    linkAttrs,
    getLink,
    navigateToRouterLink,
    navigateOnClick
  };
}
const listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  const opts = Object.defineProperty({}, "passive", {
    get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      });
    }
  });
  window.addEventListener("qtest", null, opts);
  window.removeEventListener("qtest", null, opts);
} catch (_) {
}
function noop() {
}
function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }
  return {
    top: e.clientY,
    left: e.clientX
  };
}
function getEventPath(e) {
  if (e.path) {
    return e.path;
  }
  if (e.composedPath) {
    return e.composedPath();
  }
  const path = [];
  let el = e.target;
  while (el) {
    path.push(el);
    if (el.tagName === "HTML") {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}
function stop(e) {
  e.stopPropagation();
}
function prevent(e) {
  e.cancelable !== false && e.preventDefault();
}
function stopAndPrevent(e) {
  e.cancelable !== false && e.preventDefault();
  e.stopPropagation();
}
function addEvt(ctx, targetName, events) {
  const name = `__q_${targetName}_evt`;
  ctx[name] = ctx[name] !== void 0 ? ctx[name].concat(events) : events;
  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}
function cleanEvt(ctx, targetName) {
  const name = `__q_${targetName}_evt`;
  if (ctx[name] !== void 0) {
    ctx[name].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name] = void 0;
  }
}
let lastKeyCompositionStatus = false;
function onKeyDownComposition(evt) {
  lastKeyCompositionStatus = evt.isComposing === true;
}
function shouldIgnoreKey(evt) {
  return lastKeyCompositionStatus === true || evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode(evt, keyCodes) {
  return shouldIgnoreKey(evt) === true ? false : [].concat(keyCodes).includes(evt.keyCode);
}
const QItem = createComponent({
  name: "QItem",
  props: {
    ...useDarkProps,
    ...useRouterLinkProps,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(props, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = useDark(props, $q);
    const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = useRouterLink();
    const rootRef = ref(null);
    const blurTargetRef = ref(null);
    const isActionable = computed(
      () => props.clickable === true || hasLink.value === true || props.tag === "label"
    );
    const isClickable = computed(
      () => props.disable !== true && isActionable.value === true
    );
    const classes = computed(
      () => "q-item q-item-type row no-wrap" + (props.dense === true ? " q-item--dense" : "") + (isDark.value === true ? " q-item--dark" : "") + (hasLink.value === true && props.active === null ? linkClass.value : props.active === true ? ` q-item--active${props.activeClass !== void 0 ? ` ${props.activeClass}` : ""}` : "") + (props.disable === true ? " disabled" : "") + (isClickable.value === true ? " q-item--clickable q-link cursor-pointer " + (props.manualFocus === true ? "q-manual-focusable" : "q-focusable q-hoverable") + (props.focused === true ? " q-manual-focusable--focused" : "") : "")
    );
    const style = computed(() => {
      if (props.insetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: 16 + props.insetLevel * 56 + "px"
      };
    });
    function onClick(e) {
      if (isClickable.value === true) {
        if (blurTargetRef.value !== null) {
          if (e.qKeyEvent !== true && document.activeElement === rootRef.value) {
            blurTargetRef.value.focus();
          } else if (document.activeElement === blurTargetRef.value) {
            rootRef.value.focus();
          }
        }
        navigateOnClick(e);
      }
    }
    function onKeyup2(e) {
      if (isClickable.value === true && isKeyCode(e, [13, 32]) === true) {
        stopAndPrevent(e);
        e.qKeyEvent = true;
        const evt = new MouseEvent("click", e);
        evt.qKeyEvent = true;
        rootRef.value.dispatchEvent(evt);
      }
      emit("keyup", e);
    }
    function getContent() {
      const child = hUniqueSlot(slots.default, []);
      isClickable.value === true && child.unshift(
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef })
      );
      return child;
    }
    return () => {
      const data = {
        ref: rootRef,
        class: classes.value,
        style: style.value,
        role: "listitem",
        onClick,
        onKeyup: onKeyup2
      };
      if (isClickable.value === true) {
        data.tabindex = props.tabindex || "0";
        Object.assign(data, linkAttrs.value);
      } else if (isActionable.value === true) {
        data["aria-disabled"] = "true";
      }
      return h(
        linkTag.value,
        data,
        getContent()
      );
    };
  }
});
const roleAttrExceptions = ["ul", "ol"];
const QList = createComponent({
  name: "QList",
  props: {
    ...useDarkProps,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(props, { slots }) {
    const vm = getCurrentInstance();
    const isDark = useDark(props, vm.proxy.$q);
    const role = computed(
      () => roleAttrExceptions.includes(props.tag) ? null : "list"
    );
    const classes = computed(
      () => "q-list" + (props.bordered === true ? " q-list--bordered" : "") + (props.dense === true ? " q-list--dense" : "") + (props.separator === true ? " q-list--separator" : "") + (isDark.value === true ? " q-list--dark" : "") + (props.padding === true ? " q-list--padding" : "")
    );
    return () => h(props.tag, { class: classes.value, role: role.value }, hSlot(slots.default));
  }
});
const defaultViewBox = "0 0 24 24";
const sameFn = (i) => i;
const ionFn = (i) => `ionicons ${i}`;
const libMap = {
  "mdi-": (i) => `mdi ${i}`,
  "icon-": sameFn,
  // fontawesome equiv
  "bt-": (i) => `bt ${i}`,
  "eva-": (i) => `eva ${i}`,
  "ion-md": ionFn,
  "ion-ios": ionFn,
  "ion-logo": ionFn,
  "iconfont ": sameFn,
  "ti-": (i) => `themify-icon ${i}`,
  "bi-": (i) => `bootstrap-icons ${i}`
};
const matMap = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
};
const symMap = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
};
const libRE = new RegExp("^(" + Object.keys(libMap).join("|") + ")");
const matRE = new RegExp("^(" + Object.keys(matMap).join("|") + ")");
const symRE = new RegExp("^(" + Object.keys(symMap).join("|") + ")");
const mRE = /^[Mm]\s?[-+]?\.?\d/;
const imgRE = /^img:/;
const svgUseRE = /^svguse:/;
const ionRE = /^ion-/;
const faRE = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
const QIcon = createComponent({
  name: "QIcon",
  props: {
    ...useSizeProps,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(props, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = useSize(props);
    const classes = computed(
      () => "q-icon" + (props.left === true ? " on-left" : "") + (props.right === true ? " on-right" : "") + (props.color !== void 0 ? ` text-${props.color}` : "")
    );
    const type = computed(() => {
      let cls;
      let icon = props.name;
      if (icon === "none" || !icon) {
        return { none: true };
      }
      if ($q.iconMapFn !== null) {
        const res = $q.iconMapFn(icon);
        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
            if (icon === "none" || !icon) {
              return { none: true };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : " "
            };
          }
        }
      }
      if (mRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svg: true,
          viewBox,
          nodes: def.split("&&").map((path) => {
            const [d, style, transform] = path.split("@@");
            return h("path", { style, d, transform });
          })
        };
      }
      if (imgRE.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }
      if (svgUseRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svguse: true,
          src: def.substring(7),
          viewBox
        };
      }
      let content = " ";
      const matches = icon.match(libRE);
      if (matches !== null) {
        cls = libMap[matches[1]](icon);
      } else if (faRE.test(icon) === true) {
        cls = icon;
      } else if (ionRE.test(icon) === true) {
        cls = `ionicons ion-${$q.platform.is.ios === true ? "ios" : "md"}${icon.substring(3)}`;
      } else if (symRE.test(icon) === true) {
        cls = "notranslate material-symbols";
        const matches2 = icon.match(symRE);
        if (matches2 !== null) {
          icon = icon.substring(6);
          cls += symMap[matches2[1]];
        }
        content = icon;
      } else {
        cls = "notranslate material-icons";
        const matches2 = icon.match(matRE);
        if (matches2 !== null) {
          icon = icon.substring(2);
          cls += matMap[matches2[1]];
        }
        content = icon;
      }
      return {
        cls,
        content
      };
    });
    return () => {
      const data = {
        class: classes.value,
        style: sizeStyle.value,
        "aria-hidden": "true",
        role: "presentation"
      };
      if (type.value.none === true) {
        return h(props.tag, data, hSlot(slots.default));
      }
      if (type.value.img === true) {
        return h(props.tag, data, hMergeSlot(slots.default, [
          h("img", { src: type.value.src })
        ]));
      }
      if (type.value.svg === true) {
        return h(props.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type.value.viewBox || "0 0 24 24"
          }, type.value.nodes)
        ]));
      }
      if (type.value.svguse === true) {
        return h(props.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type.value.viewBox
          }, [
            h("use", { "xlink:href": type.value.src })
          ])
        ]));
      }
      if (type.value.cls !== void 0) {
        data.class += " " + type.value.cls;
      }
      return h(props.tag, data, hMergeSlot(slots.default, [
        type.value.content
      ]));
    };
  }
});
function css(element, css2) {
  const style = element.style;
  for (const prop in css2) {
    style[prop] = css2[prop];
  }
}
function getElement(el) {
  if (el === void 0 || el === null) {
    return void 0;
  }
  if (typeof el === "string") {
    try {
      return document.querySelector(el) || void 0;
    } catch (err) {
      return void 0;
    }
  }
  const target2 = unref(el);
  if (target2) {
    return target2.$el || target2;
  }
}
function childHasFocus(el, focusedEl) {
  if (el === void 0 || el === null || el.contains(focusedEl) === true) {
    return true;
  }
  for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) {
    if (next.contains(focusedEl)) {
      return true;
    }
  }
  return false;
}
function throttle(fn, limit = 250) {
  let wait = false, result;
  return function() {
    if (wait === false) {
      wait = true;
      setTimeout(() => {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments);
    }
    return result;
  };
}
function showRipple(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && stop(evt);
  const color = ctx.modifiers.color;
  let center = ctx.modifiers.center;
  center = center === true || forceCenter === true;
  const node = document.createElement("span"), innerNode = document.createElement("span"), pos = position(evt), { left, top, width: width2, height } = el.getBoundingClientRect(), diameter = Math.sqrt(width2 * width2 + height * height), radius = diameter / 2, centerX = `${(width2 - diameter) / 2}px`, x = center ? centerX : `${pos.left - left - radius}px`, centerY = `${(height - diameter) / 2}px`, y = center ? centerY : `${pos.top - top - radius}px`;
  innerNode.className = "q-ripple__inner";
  css(innerNode, {
    height: `${diameter}px`,
    width: `${diameter}px`,
    transform: `translate3d(${x},${y},0) scale3d(.2,.2,1)`,
    opacity: 0
  });
  node.className = `q-ripple${color ? " text-" + color : ""}`;
  node.setAttribute("dir", "ltr");
  node.appendChild(innerNode);
  el.appendChild(node);
  const abort = () => {
    node.remove();
    clearTimeout(timer);
  };
  ctx.abort.push(abort);
  let timer = setTimeout(() => {
    innerNode.classList.add("q-ripple__inner--enter");
    innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    innerNode.style.opacity = 0.2;
    timer = setTimeout(() => {
      innerNode.classList.remove("q-ripple__inner--enter");
      innerNode.classList.add("q-ripple__inner--leave");
      innerNode.style.opacity = 0;
      timer = setTimeout(() => {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}
function updateModifiers(ctx, { modifiers, value, arg }) {
  const cfg = Object.assign({}, ctx.cfg.ripple, modifiers, value);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}
const Ripple = createDirective(
  {
    name: "ripple",
    beforeMount(el, binding) {
      const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
      if (cfg.ripple === false) {
        return;
      }
      const ctx = {
        cfg,
        enabled: binding.value !== false,
        modifiers: {},
        abort: [],
        start(evt) {
          if (ctx.enabled === true && evt.qSkipRipple !== true && evt.type === (ctx.modifiers.early === true ? "pointerdown" : "click")) {
            showRipple(evt, el, ctx, evt.qKeyEvent === true);
          }
        },
        keystart: throttle((evt) => {
          if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? "down" : "up"}`) {
            showRipple(evt, el, ctx, true);
          }
        }, 300)
      };
      updateModifiers(ctx, binding);
      el.__qripple = ctx;
      addEvt(ctx, "main", [
        [el, "pointerdown", "start", "passive"],
        [el, "click", "start", "passive"],
        [el, "keydown", "keystart", "passive"],
        [el, "keyup", "keystart", "passive"]
      ]);
    },
    updated(el, binding) {
      if (binding.oldValue !== binding.value) {
        const ctx = el.__qripple;
        if (ctx !== void 0) {
          ctx.enabled = binding.value !== false;
          if (ctx.enabled === true && Object(binding.value) === binding.value) {
            updateModifiers(ctx, binding);
          }
        }
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qripple;
      if (ctx !== void 0) {
        ctx.abort.forEach((fn) => {
          fn();
        });
        cleanEvt(ctx, "main");
        delete el._qripple;
      }
    }
  }
);
const alignMap = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
};
const alignValues = Object.keys(alignMap);
const useAlignProps = {
  align: {
    type: String,
    validator: (v) => alignValues.includes(v)
  }
};
function useAlign(props) {
  return computed(() => {
    const align = props.align === void 0 ? props.vertical === true ? "stretch" : "left" : props.align;
    return `${props.vertical === true ? "items" : "justify"}-${alignMap[align]}`;
  });
}
const btnPadding = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
const defaultSizes$1 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
const formTypes = ["button", "submit", "reset"];
const mediaTypeRE = /[^\s]\/[^\s]/;
const btnDesignOptions = ["flat", "outline", "push", "unelevated"];
function getBtnDesign(props, defaultValue) {
  if (props.flat === true) return "flat";
  if (props.outline === true) return "outline";
  if (props.push === true) return "push";
  if (props.unelevated === true) return "unelevated";
  return defaultValue;
}
function getBtnDesignAttr(props) {
  const design = getBtnDesign(props);
  return design !== void 0 ? { [design]: true } : {};
}
const nonRoundBtnProps = {
  ...useSizeProps,
  ...useRouterLinkNonMatchingProps,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...btnDesignOptions.reduce(
    (acc, val) => (acc[val] = Boolean) && acc,
    {}
  ),
  square: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  align: {
    ...useAlignProps.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
const useBtnProps = {
  ...nonRoundBtnProps,
  round: Boolean
};
function useBtn(props) {
  const sizeStyle = useSize(props, defaultSizes$1);
  const alignClass = useAlign(props);
  const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = useRouterLink({
    fallbackTag: "button"
  });
  const style = computed(() => {
    const obj = props.fab === false && props.fabMini === false ? sizeStyle.value : {};
    return props.padding !== void 0 ? Object.assign({}, obj, {
      padding: props.padding.split(/\s+/).map((v) => v in btnPadding ? btnPadding[v] + "px" : v).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : obj;
  });
  const isRounded = computed(
    () => props.rounded === true || props.fab === true || props.fabMini === true
  );
  const isActionable = computed(
    () => props.disable !== true && props.loading !== true
  );
  const tabIndex = computed(() => isActionable.value === true ? props.tabindex || 0 : -1);
  const design = computed(() => getBtnDesign(props, "standard"));
  const attributes = computed(() => {
    const acc = { tabindex: tabIndex.value };
    if (hasLink.value === true) {
      Object.assign(acc, linkAttrs.value);
    } else if (formTypes.includes(props.type) === true) {
      acc.type = props.type;
    }
    if (linkTag.value === "a") {
      if (props.disable === true) {
        acc["aria-disabled"] = "true";
      } else if (acc.href === void 0) {
        acc.role = "button";
      }
      if (hasRouterLink.value !== true && mediaTypeRE.test(props.type) === true) {
        acc.type = props.type;
      }
    } else if (props.disable === true) {
      acc.disabled = "";
      acc["aria-disabled"] = "true";
    }
    if (props.loading === true && props.percentage !== void 0) {
      Object.assign(acc, {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": props.percentage
      });
    }
    return acc;
  });
  const classes = computed(() => {
    let colors;
    if (props.color !== void 0) {
      if (props.flat === true || props.outline === true) {
        colors = `text-${props.textColor || props.color}`;
      } else {
        colors = `bg-${props.color} text-${props.textColor || "white"}`;
      }
    } else if (props.textColor) {
      colors = `text-${props.textColor}`;
    }
    const shape = props.round === true ? "round" : `rectangle${isRounded.value === true ? " q-btn--rounded" : props.square === true ? " q-btn--square" : ""}`;
    return `q-btn--${design.value} q-btn--${shape}` + (colors !== void 0 ? " " + colors : "") + (isActionable.value === true ? " q-btn--actionable q-focusable q-hoverable" : props.disable === true ? " disabled" : "") + (props.fab === true ? " q-btn--fab" : props.fabMini === true ? " q-btn--fab-mini" : "") + (props.noCaps === true ? " q-btn--no-uppercase" : "") + (props.dense === true ? " q-btn--dense" : "") + (props.stretch === true ? " no-border-radius self-stretch" : "") + (props.glossy === true ? " glossy" : "") + (props.square ? " q-btn--square" : "");
  });
  const innerClasses = computed(
    () => alignClass.value + (props.stack === true ? " column" : " row") + (props.noWrap === true ? " no-wrap text-no-wrap" : "") + (props.loading === true ? " q-btn__content--hidden" : "")
  );
  return {
    classes,
    style,
    innerClasses,
    attributes,
    hasLink,
    linkTag,
    navigateOnClick,
    isActionable
  };
}
const { passiveCapture } = listenOpts;
let touchTarget = null, keyboardTarget = null, mouseTarget = null;
const QBtn = createComponent({
  name: "QBtn",
  props: {
    ...useBtnProps,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(props, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const {
      classes,
      style,
      innerClasses,
      attributes,
      hasLink,
      linkTag,
      navigateOnClick,
      isActionable
    } = useBtn(props);
    const rootRef = ref(null);
    const blurTargetRef = ref(null);
    let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null;
    const hasLabel = computed(
      () => props.label !== void 0 && props.label !== null && props.label !== ""
    );
    const ripple = computed(() => props.disable === true || props.ripple === false ? false : {
      keyCodes: hasLink.value === true ? [13, 32] : [13],
      ...props.ripple === true ? {} : props.ripple
    });
    const rippleProps = computed(() => ({ center: props.round }));
    const percentageStyle = computed(() => {
      const val = Math.max(0, Math.min(100, props.percentage));
      return val > 0 ? { transition: "transform 0.6s", transform: `translateX(${val - 100}%)` } : {};
    });
    const onEvents = computed(() => {
      if (props.loading === true) {
        return {
          onMousedown: onLoadingEvt,
          onTouchstart: onLoadingEvt,
          onClick: onLoadingEvt,
          onKeydown: onLoadingEvt,
          onKeyup: onLoadingEvt
        };
      }
      if (isActionable.value === true) {
        const acc = {
          onClick,
          onKeydown: onKeydown2,
          onMousedown
        };
        if (proxy.$q.platform.has.touch === true) {
          const suffix = props.onTouchstart !== void 0 ? "" : "Passive";
          acc[`onTouchstart${suffix}`] = onTouchstart;
        }
        return acc;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: stopAndPrevent
      };
    });
    const nodeProps = computed(() => ({
      ref: rootRef,
      class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
      style: style.value,
      ...attributes.value,
      ...onEvents.value
    }));
    function onClick(e) {
      if (rootRef.value === null) return;
      if (e !== void 0) {
        if (e.defaultPrevented === true) {
          return;
        }
        const el = document.activeElement;
        if (props.type === "submit" && el !== document.body && rootRef.value.contains(el) === false && el.contains(rootRef.value) === false) {
          rootRef.value.focus();
          const onClickCleanup = () => {
            document.removeEventListener("keydown", stopAndPrevent, true);
            document.removeEventListener("keyup", onClickCleanup, passiveCapture);
            rootRef.value !== null && rootRef.value.removeEventListener("blur", onClickCleanup, passiveCapture);
          };
          document.addEventListener("keydown", stopAndPrevent, true);
          document.addEventListener("keyup", onClickCleanup, passiveCapture);
          rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture);
        }
      }
      navigateOnClick(e);
    }
    function onKeydown2(e) {
      if (rootRef.value === null) return;
      emit("keydown", e);
      if (isKeyCode(e, [13, 32]) === true && keyboardTarget !== rootRef.value) {
        keyboardTarget !== null && cleanup();
        if (e.defaultPrevented !== true) {
          rootRef.value.focus();
          keyboardTarget = rootRef.value;
          rootRef.value.classList.add("q-btn--active");
          document.addEventListener("keyup", onPressEnd, true);
          rootRef.value.addEventListener("blur", onPressEnd, passiveCapture);
        }
        stopAndPrevent(e);
      }
    }
    function onTouchstart(e) {
      if (rootRef.value === null) return;
      emit("touchstart", e);
      if (e.defaultPrevented === true) return;
      if (touchTarget !== rootRef.value) {
        touchTarget !== null && cleanup();
        touchTarget = rootRef.value;
        localTouchTargetEl = e.target;
        localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture);
        localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture);
      }
      avoidMouseRipple = true;
      mouseTimer !== null && clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        mouseTimer = null;
        avoidMouseRipple = false;
      }, 200);
    }
    function onMousedown(e) {
      if (rootRef.value === null) return;
      e.qSkipRipple = avoidMouseRipple === true;
      emit("mousedown", e);
      if (e.defaultPrevented !== true && mouseTarget !== rootRef.value) {
        mouseTarget !== null && cleanup();
        mouseTarget = rootRef.value;
        rootRef.value.classList.add("q-btn--active");
        document.addEventListener("mouseup", onPressEnd, passiveCapture);
      }
    }
    function onPressEnd(e) {
      if (rootRef.value === null) return;
      if (e !== void 0 && e.type === "blur" && document.activeElement === rootRef.value) {
        return;
      }
      if (e !== void 0 && e.type === "keyup") {
        if (keyboardTarget === rootRef.value && isKeyCode(e, [13, 32]) === true) {
          const evt = new MouseEvent("click", e);
          evt.qKeyEvent = true;
          e.defaultPrevented === true && prevent(evt);
          e.cancelBubble === true && stop(evt);
          rootRef.value.dispatchEvent(evt);
          stopAndPrevent(e);
          e.qKeyEvent = true;
        }
        emit("keyup", e);
      }
      cleanup();
    }
    function cleanup(destroying) {
      const blurTarget = blurTargetRef.value;
      if (destroying !== true && (touchTarget === rootRef.value || mouseTarget === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
        blurTarget.setAttribute("tabindex", -1);
        blurTarget.focus();
      }
      if (touchTarget === rootRef.value) {
        if (localTouchTargetEl !== null) {
          localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture);
          localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture);
        }
        touchTarget = localTouchTargetEl = null;
      }
      if (mouseTarget === rootRef.value) {
        document.removeEventListener("mouseup", onPressEnd, passiveCapture);
        mouseTarget = null;
      }
      if (keyboardTarget === rootRef.value) {
        document.removeEventListener("keyup", onPressEnd, true);
        rootRef.value !== null && rootRef.value.removeEventListener("blur", onPressEnd, passiveCapture);
        keyboardTarget = null;
      }
      rootRef.value !== null && rootRef.value.classList.remove("q-btn--active");
    }
    function onLoadingEvt(evt) {
      stopAndPrevent(evt);
      evt.qSkipRipple = true;
    }
    onBeforeUnmount(() => {
      cleanup(true);
    });
    Object.assign(proxy, {
      click: (e) => {
        if (isActionable.value === true) {
          onClick(e);
        }
      }
    });
    return () => {
      let inner = [];
      props.icon !== void 0 && inner.push(
        h(QIcon, {
          name: props.icon,
          left: props.stack !== true && hasLabel.value === true,
          role: "img"
        })
      );
      hasLabel.value === true && inner.push(
        h("span", { class: "block" }, [props.label])
      );
      inner = hMergeSlot(slots.default, inner);
      if (props.iconRight !== void 0 && props.round === false) {
        inner.push(
          h(QIcon, {
            name: props.iconRight,
            right: props.stack !== true && hasLabel.value === true,
            role: "img"
          })
        );
      }
      const child = [
        h("span", {
          class: "q-focus-helper",
          ref: blurTargetRef
        })
      ];
      if (props.loading === true && props.percentage !== void 0) {
        child.push(
          h("span", {
            class: "q-btn__progress absolute-full overflow-hidden" + (props.darkPercentage === true ? " q-btn__progress--dark" : "")
          }, [
            h("span", {
              class: "q-btn__progress-indicator fit block",
              style: percentageStyle.value
            })
          ])
        );
      }
      child.push(
        h("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value
        }, inner)
      );
      props.loading !== null && child.push(
        h(Transition, {
          name: "q-transition--fade"
        }, () => props.loading === true ? [
          h("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, slots.loading !== void 0 ? slots.loading() : [h(QSpinner)])
        ] : null)
      );
      return withDirectives(
        h(
          linkTag.value,
          nodeProps.value,
          child
        ),
        [[
          Ripple,
          ripple.value,
          void 0,
          rippleProps.value
        ]]
      );
    };
  }
});
const QBtnGroup = createComponent({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(props, { slots }) {
    const classes = computed(() => {
      const cls = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((t) => props[t] === true).map((t) => `q-btn-group--${t}`).join(" ");
      return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props.spread === true ? " q-btn-group--spread" : " inline");
    });
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
const isRuntimeSsrPreHydration = ref(
  false
);
let preHydrationBrowser;
function getMatch(userAgent2, platformMatch) {
  const match2 = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(userAgent2) || /(opr)[\/]([\w.]+)/.exec(userAgent2) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent2) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent2) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+)/.exec(userAgent2) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent2) || [];
  return {
    browser: match2[5] || match2[3] || match2[1] || "",
    version: match2[4] || match2[2] || "0",
    platform: platformMatch[0] || ""
  };
}
function getPlatformMatch(userAgent2) {
  return /(ipad)/.exec(userAgent2) || /(ipod)/.exec(userAgent2) || /(windows phone)/.exec(userAgent2) || /(iphone)/.exec(userAgent2) || /(kindle)/.exec(userAgent2) || /(silk)/.exec(userAgent2) || /(android)/.exec(userAgent2) || /(win)/.exec(userAgent2) || /(mac)/.exec(userAgent2) || /(linux)/.exec(userAgent2) || /(cros)/.exec(userAgent2) || /(playbook)/.exec(userAgent2) || /(bb)/.exec(userAgent2) || /(blackberry)/.exec(userAgent2) || [];
}
const hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform(UA) {
  const userAgent2 = UA.toLowerCase();
  const platformMatch = getPlatformMatch(userAgent2);
  const matched = getMatch(userAgent2, platformMatch);
  const browser = {
    mobile: false,
    desktop: false,
    cordova: false,
    capacitor: false,
    nativeMobile: false,
    // nativeMobileWrapper: void 0,
    electron: false,
    bex: false,
    linux: false,
    mac: false,
    win: false,
    cros: false,
    chrome: false,
    firefox: false,
    opera: false,
    safari: false,
    vivaldi: false,
    edge: false,
    edgeChromium: false,
    ie: false,
    webkit: false,
    android: false,
    ios: false,
    ipad: false,
    iphone: false,
    ipod: false,
    kindle: false,
    winphone: false,
    blackberry: false,
    playbook: false,
    silk: false
  };
  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.version, 10);
  }
  if (matched.platform) {
    browser[matched.platform] = true;
  }
  const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser["windows phone"];
  if (knownMobiles === true || userAgent2.indexOf("mobile") !== -1) {
    browser.mobile = true;
  } else {
    browser.desktop = true;
  }
  if (browser["windows phone"]) {
    browser.winphone = true;
    delete browser["windows phone"];
  }
  if (browser.edga || browser.edgios || browser.edg) {
    browser.edge = true;
    matched.browser = "edge";
  } else if (browser.crios) {
    browser.chrome = true;
    matched.browser = "chrome";
  } else if (browser.fxios) {
    browser.firefox = true;
    matched.browser = "firefox";
  }
  if (browser.ipod || browser.ipad || browser.iphone) {
    browser.ios = true;
  }
  if (browser.vivaldi) {
    matched.browser = "vivaldi";
    browser.vivaldi = true;
  }
  if (
    // Chrome, Opera 15+, Vivaldi and Safari are webkit based browsers
    browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile === true && browser.ios !== true && knownMobiles !== true
  ) {
    browser.webkit = true;
  }
  if (browser.opr) {
    matched.browser = "opera";
    browser.opera = true;
  }
  if (browser.safari) {
    if (browser.blackberry || browser.bb) {
      matched.browser = "blackberry";
      browser.blackberry = true;
    } else if (browser.playbook) {
      matched.browser = "playbook";
      browser.playbook = true;
    } else if (browser.android) {
      matched.browser = "android";
      browser.android = true;
    } else if (browser.kindle) {
      matched.browser = "kindle";
      browser.kindle = true;
    } else if (browser.silk) {
      matched.browser = "silk";
      browser.silk = true;
    }
  }
  browser.name = matched.browser;
  browser.platform = matched.platform;
  {
    if (userAgent2.indexOf("electron") !== -1) {
      browser.electron = true;
    } else if (document.location.href.indexOf("-extension://") !== -1) {
      browser.bex = true;
    } else {
      if (window.Capacitor !== void 0) {
        browser.capacitor = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "capacitor";
      } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
        browser.cordova = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "cordova";
      }
      if (isRuntimeSsrPreHydration.value === true) {
        preHydrationBrowser = { is: { ...browser } };
      }
      if (hasTouch === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
        delete browser.mac;
        delete browser.desktop;
        const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
        Object.assign(browser, {
          mobile: true,
          ios: true,
          platform,
          [platform]: true
        });
      }
      if (browser.mobile !== true && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
        delete browser.desktop;
        browser.mobile = true;
      }
    }
  }
  return browser;
}
const userAgent = navigator.userAgent || navigator.vendor || window.opera;
const ssrClient = {
  has: {
    touch: false,
    webStorage: false
  },
  within: { iframe: false }
};
const client = {
  userAgent,
  is: getPlatform(userAgent),
  has: {
    touch: hasTouch
  },
  within: {
    iframe: window.self !== window.top
  }
};
const Platform = {
  install(opts) {
    const { $q } = opts;
    if (isRuntimeSsrPreHydration.value === true) {
      opts.onSSRHydrated.push(() => {
        Object.assign($q.platform, client);
        isRuntimeSsrPreHydration.value = false;
      });
      $q.platform = reactive(this);
    } else {
      $q.platform = this;
    }
  }
};
{
  let hasWebStorage;
  injectProp(client.has, "webStorage", () => {
    if (hasWebStorage !== void 0) {
      return hasWebStorage;
    }
    try {
      if (window.localStorage) {
        hasWebStorage = true;
        return true;
      }
    } catch (_) {
    }
    hasWebStorage = false;
    return false;
  });
  Object.assign(Platform, client);
  if (isRuntimeSsrPreHydration.value === true) {
    Object.assign(Platform, preHydrationBrowser, ssrClient);
    preHydrationBrowser = null;
  }
}
function clearSelection() {
  if (window.getSelection !== void 0) {
    const selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      Platform.is.mobile !== true && selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}
const useAnchorStaticProps = {
  /* SSR does not know about Element */
  target: {
    type: [Boolean, String, Element],
    default: true
  },
  noParentEvent: Boolean
};
const useAnchorProps = {
  ...useAnchorStaticProps,
  contextMenu: Boolean
};
function useAnchor({
  showing,
  avoidEmit,
  // required for QPopupProxy (true)
  configureAnchorEl
  // optional
}) {
  const { props, proxy, emit } = getCurrentInstance();
  const anchorEl = ref(null);
  let touchTimer = null;
  function canShow(evt) {
    return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
  }
  const anchorEvents = {};
  if (configureAnchorEl === void 0) {
    Object.assign(anchorEvents, {
      hide(evt) {
        proxy.hide(evt);
      },
      toggle(evt) {
        proxy.toggle(evt);
        evt.qAnchorHandled = true;
      },
      toggleKey(evt) {
        isKeyCode(evt, 13) === true && anchorEvents.toggle(evt);
      },
      contextClick(evt) {
        proxy.hide(evt);
        prevent(evt);
        nextTick(() => {
          proxy.show(evt);
          evt.qAnchorHandled = true;
        });
      },
      prevent,
      mobileTouch(evt) {
        anchorEvents.mobileCleanup(evt);
        if (canShow(evt) !== true) {
          return;
        }
        proxy.hide(evt);
        anchorEl.value.classList.add("non-selectable");
        const target2 = evt.target;
        addEvt(anchorEvents, "anchor", [
          [target2, "touchmove", "mobileCleanup", "passive"],
          [target2, "touchend", "mobileCleanup", "passive"],
          [target2, "touchcancel", "mobileCleanup", "passive"],
          [anchorEl.value, "contextmenu", "prevent", "notPassive"]
        ]);
        touchTimer = setTimeout(() => {
          touchTimer = null;
          proxy.show(evt);
          evt.qAnchorHandled = true;
        }, 300);
      },
      mobileCleanup(evt) {
        anchorEl.value.classList.remove("non-selectable");
        if (touchTimer !== null) {
          clearTimeout(touchTimer);
          touchTimer = null;
        }
        if (showing.value === true && evt !== void 0) {
          clearSelection();
        }
      }
    });
    configureAnchorEl = function(context = props.contextMenu) {
      if (props.noParentEvent === true || anchorEl.value === null) return;
      let evts;
      if (context === true) {
        if (proxy.$q.platform.is.mobile === true) {
          evts = [
            [anchorEl.value, "touchstart", "mobileTouch", "passive"]
          ];
        } else {
          evts = [
            [anchorEl.value, "mousedown", "hide", "passive"],
            [anchorEl.value, "contextmenu", "contextClick", "notPassive"]
          ];
        }
      } else {
        evts = [
          [anchorEl.value, "click", "toggle", "passive"],
          [anchorEl.value, "keyup", "toggleKey", "passive"]
        ];
      }
      addEvt(anchorEvents, "anchor", evts);
    };
  }
  function unconfigureAnchorEl() {
    cleanEvt(anchorEvents, "anchor");
  }
  function setAnchorEl(el) {
    anchorEl.value = el;
    while (anchorEl.value.classList.contains("q-anchor--skip")) {
      anchorEl.value = anchorEl.value.parentNode;
    }
    configureAnchorEl();
  }
  function pickAnchorEl() {
    if (props.target === false || props.target === "" || proxy.$el.parentNode === null) {
      anchorEl.value = null;
    } else if (props.target === true) {
      setAnchorEl(proxy.$el.parentNode);
    } else {
      let el = props.target;
      if (typeof props.target === "string") {
        try {
          el = document.querySelector(props.target);
        } catch (err) {
          el = void 0;
        }
      }
      if (el !== void 0 && el !== null) {
        anchorEl.value = el.$el || el;
        configureAnchorEl();
      } else {
        anchorEl.value = null;
        console.error(`Anchor: target "${props.target}" not found`);
      }
    }
  }
  watch(() => props.contextMenu, (val) => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
      configureAnchorEl(val);
    }
  });
  watch(() => props.target, () => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
    }
    pickAnchorEl();
  });
  watch(() => props.noParentEvent, (val) => {
    if (anchorEl.value !== null) {
      if (val === true) {
        unconfigureAnchorEl();
      } else {
        configureAnchorEl();
      }
    }
  });
  onMounted(() => {
    pickAnchorEl();
    if (avoidEmit !== true && props.modelValue === true && anchorEl.value === null) {
      emit("update:modelValue", false);
    }
  });
  onBeforeUnmount(() => {
    touchTimer !== null && clearTimeout(touchTimer);
    unconfigureAnchorEl();
  });
  return {
    anchorEl,
    canShow,
    anchorEvents
  };
}
function useScrollTarget(props, configureScrollTarget) {
  const localScrollTarget = ref(null);
  let scrollFn;
  function changeScrollEvent(scrollTarget, fn) {
    const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
    const fnHandler = fn !== void 0 ? fn : scrollFn;
    if (scrollTarget !== window) {
      scrollTarget[fnProp]("scroll", fnHandler, listenOpts.passive);
    }
    window[fnProp]("scroll", fnHandler, listenOpts.passive);
    scrollFn = fn;
  }
  function unconfigureScrollTarget() {
    if (localScrollTarget.value !== null) {
      changeScrollEvent(localScrollTarget.value);
      localScrollTarget.value = null;
    }
  }
  const noParentEventWatcher = watch(() => props.noParentEvent, () => {
    if (localScrollTarget.value !== null) {
      unconfigureScrollTarget();
      configureScrollTarget();
    }
  });
  onBeforeUnmount(noParentEventWatcher);
  return {
    localScrollTarget,
    unconfigureScrollTarget,
    changeScrollEvent
  };
}
const useModelToggleProps = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
};
const useModelToggleEmits = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function useModelToggle({
  showing,
  canShow,
  // optional
  hideOnRouteChange,
  // optional
  handleShow,
  // optional
  handleHide,
  // optional
  processOnMount
  // optional
}) {
  const vm = getCurrentInstance();
  const { props, emit, proxy } = vm;
  let payload;
  function toggle(evt) {
    if (showing.value === true) {
      hide(evt);
    } else {
      show(evt);
    }
  }
  function show(evt) {
    if (props.disable === true || evt !== void 0 && evt.qAnchorHandled === true || canShow !== void 0 && canShow(evt) !== true) {
      return;
    }
    const listener = props["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", true);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props.modelValue === null || listener === false || false) {
      processShow(evt);
    }
  }
  function processShow(evt) {
    if (showing.value === true) {
      return;
    }
    showing.value = true;
    emit("beforeShow", evt);
    if (handleShow !== void 0) {
      handleShow(evt);
    } else {
      emit("show", evt);
    }
  }
  function hide(evt) {
    if (props.disable === true) {
      return;
    }
    const listener = props["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", false);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props.modelValue === null || listener === false || false) {
      processHide(evt);
    }
  }
  function processHide(evt) {
    if (showing.value === false) {
      return;
    }
    showing.value = false;
    emit("beforeHide", evt);
    if (handleHide !== void 0) {
      handleHide(evt);
    } else {
      emit("hide", evt);
    }
  }
  function processModelChange(val) {
    if (props.disable === true && val === true) {
      if (props["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", false);
      }
    } else if (val === true !== showing.value) {
      const fn = val === true ? processShow : processHide;
      fn(payload);
    }
  }
  watch(() => props.modelValue, processModelChange);
  if (hideOnRouteChange !== void 0 && vmHasRouter(vm) === true) {
    watch(() => proxy.$route.fullPath, () => {
      if (hideOnRouteChange.value === true && showing.value === true) {
        hide();
      }
    });
  }
  processOnMount === true && onMounted(() => {
    processModelChange(props.modelValue);
  });
  const publicMethods = { show, hide, toggle };
  Object.assign(proxy, publicMethods);
  return publicMethods;
}
let queue = [];
let waitFlags = [];
function clearFlag(flag) {
  waitFlags = waitFlags.filter((entry) => entry !== flag);
}
function addFocusWaitFlag(flag) {
  clearFlag(flag);
  waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
  clearFlag(flag);
  if (waitFlags.length === 0 && queue.length !== 0) {
    queue[queue.length - 1]();
    queue = [];
  }
}
function addFocusFn(fn) {
  if (waitFlags.length === 0) {
    fn();
  } else {
    queue.push(fn);
  }
}
function removeFocusFn(fn) {
  queue = queue.filter((entry) => entry !== fn);
}
const globalConfig = {};
let globalConfigIsFrozen = false;
function freezeGlobalConfig() {
  globalConfigIsFrozen = true;
}
let portalIndex = 1;
let target = document.body;
function createGlobalNode(id, portalType) {
  const el = document.createElement("div");
  el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex++}` : id;
  if (globalConfig.globalNodes !== void 0) {
    const cls = globalConfig.globalNodes.class;
    if (cls !== void 0) {
      el.className = cls;
    }
  }
  target.appendChild(el);
  return el;
}
function removeGlobalNode(el) {
  el.remove();
}
const portalProxyList = [];
function closePortalMenus(proxy, evt) {
  do {
    if (proxy.$options.name === "QMenu") {
      proxy.hide(evt);
      if (proxy.$props.separateClosePopup === true) {
        return getParentProxy(proxy);
      }
    } else if (proxy.__qPortal === true) {
      const parent = getParentProxy(proxy);
      if (parent !== void 0 && parent.$options.name === "QPopupProxy") {
        proxy.hide(evt);
        return parent;
      } else {
        return proxy;
      }
    }
    proxy = getParentProxy(proxy);
  } while (proxy !== void 0 && proxy !== null);
}
const QPortal = createComponent({
  name: "QPortal",
  setup(_, { slots }) {
    return () => slots.default();
  }
});
function isOnGlobalDialog(vm) {
  vm = vm.parent;
  while (vm !== void 0 && vm !== null) {
    if (vm.type.name === "QGlobalDialog") {
      return true;
    }
    if (vm.type.name === "QDialog" || vm.type.name === "QMenu") {
      return false;
    }
    vm = vm.parent;
  }
  return false;
}
function usePortal(vm, innerRef, renderPortalContent, type) {
  const portalIsActive = ref(false);
  const portalIsAccessible = ref(false);
  let portalEl = null;
  const focusObj = {};
  const onGlobalDialog = type === "dialog" && isOnGlobalDialog(vm);
  function showPortal(isReady) {
    if (isReady === true) {
      removeFocusWaitFlag(focusObj);
      portalIsAccessible.value = true;
      return;
    }
    portalIsAccessible.value = false;
    if (portalIsActive.value === false) {
      if (onGlobalDialog === false && portalEl === null) {
        portalEl = createGlobalNode(false, type);
      }
      portalIsActive.value = true;
      portalProxyList.push(vm.proxy);
      addFocusWaitFlag(focusObj);
    }
  }
  function hidePortal(isReady) {
    portalIsAccessible.value = false;
    if (isReady !== true) return;
    removeFocusWaitFlag(focusObj);
    portalIsActive.value = false;
    const index = portalProxyList.indexOf(vm.proxy);
    if (index !== -1) {
      portalProxyList.splice(index, 1);
    }
    if (portalEl !== null) {
      removeGlobalNode(portalEl);
      portalEl = null;
    }
  }
  onUnmounted(() => {
    hidePortal(true);
  });
  vm.proxy.__qPortal = true;
  injectProp(vm.proxy, "contentEl", () => innerRef.value);
  return {
    showPortal,
    hidePortal,
    portalIsActive,
    portalIsAccessible,
    renderPortal: () => onGlobalDialog === true ? renderPortalContent() : portalIsActive.value === true ? [h(Teleport, { to: portalEl }, h(QPortal, renderPortalContent))] : void 0
  };
}
const useTransitionProps = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function useTransition(props, defaultShowFn = () => {
}, defaultHideFn = () => {
}) {
  return {
    transitionProps: computed(() => {
      const show = `q-transition--${props.transitionShow || defaultShowFn()}`;
      const hide = `q-transition--${props.transitionHide || defaultHideFn()}`;
      return {
        appear: true,
        enterFromClass: `${show}-enter-from`,
        enterActiveClass: `${show}-enter-active`,
        enterToClass: `${show}-enter-to`,
        leaveFromClass: `${hide}-leave-from`,
        leaveActiveClass: `${hide}-leave-active`,
        leaveToClass: `${hide}-leave-to`
      };
    }),
    transitionStyle: computed(() => `--q-transition-duration: ${props.transitionDuration}ms`)
  };
}
function useTick() {
  let tickFn;
  const vm = getCurrentInstance();
  function removeTick() {
    tickFn = void 0;
  }
  onDeactivated(removeTick);
  onBeforeUnmount(removeTick);
  return {
    removeTick,
    registerTick(fn) {
      tickFn = fn;
      nextTick(() => {
        if (tickFn === fn) {
          vmIsDestroyed(vm) === false && tickFn();
          tickFn = void 0;
        }
      });
    }
  };
}
function useTimeout() {
  let timer = null;
  const vm = getCurrentInstance();
  function removeTimeout() {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  }
  onDeactivated(removeTimeout);
  onBeforeUnmount(removeTimeout);
  return {
    removeTimeout,
    registerTimeout(fn, delay) {
      removeTimeout();
      if (vmIsDestroyed(vm) === false) {
        timer = setTimeout(() => {
          timer = null;
          fn();
        }, delay);
      }
    }
  };
}
const scrollTargetProp = [Element, String];
const scrollTargets = [null, document, document.body, document.scrollingElement, document.documentElement];
function getScrollTarget(el, targetEl) {
  let target2 = getElement(targetEl);
  if (target2 === void 0) {
    if (el === void 0 || el === null) {
      return window;
    }
    target2 = el.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return scrollTargets.includes(target2) ? window : target2;
}
function getVerticalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
let size;
function getScrollbarWidth() {
  if (size !== void 0) {
    return size;
  }
  const inner = document.createElement("p"), outer = document.createElement("div");
  css(inner, {
    width: "100%",
    height: "200px"
  });
  css(outer, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  });
  outer.appendChild(inner);
  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = "scroll";
  let w2 = inner.offsetWidth;
  if (w1 === w2) {
    w2 = outer.clientWidth;
  }
  outer.remove();
  size = w1 - w2;
  return size;
}
function hasScrollbar(el, onY = true) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-y"])) : el.scrollWidth > el.clientWidth && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-x"]));
}
const handlers$1 = [];
let escDown;
function onKeydown(evt) {
  escDown = evt.keyCode === 27;
}
function onBlur() {
  if (escDown === true) {
    escDown = false;
  }
}
function onKeyup(evt) {
  if (escDown === true) {
    escDown = false;
    if (isKeyCode(evt, 27) === true) {
      handlers$1[handlers$1.length - 1](evt);
    }
  }
}
function update(action) {
  window[action]("keydown", onKeydown);
  window[action]("blur", onBlur);
  window[action]("keyup", onKeyup);
  escDown = false;
}
function addEscapeKey(fn) {
  if (client.is.desktop === true) {
    handlers$1.push(fn);
    if (handlers$1.length === 1) {
      update("addEventListener");
    }
  }
}
function removeEscapeKey(fn) {
  const index = handlers$1.indexOf(fn);
  if (index !== -1) {
    handlers$1.splice(index, 1);
    if (handlers$1.length === 0) {
      update("removeEventListener");
    }
  }
}
const handlers = [];
function trigger(e) {
  handlers[handlers.length - 1](e);
}
function addFocusout(fn) {
  if (client.is.desktop === true) {
    handlers.push(fn);
    if (handlers.length === 1) {
      document.body.addEventListener("focusin", trigger);
    }
  }
}
function removeFocusout(fn) {
  const index = handlers.indexOf(fn);
  if (index !== -1) {
    handlers.splice(index, 1);
    if (handlers.length === 0) {
      document.body.removeEventListener("focusin", trigger);
    }
  }
}
const { notPassiveCapture } = listenOpts, registeredList = [];
function globalHandler(evt) {
  const target2 = evt.target;
  if (target2 === void 0 || target2.nodeType === 8 || target2.classList.contains("no-pointer-events") === true) {
    return;
  }
  let portalIndex2 = portalProxyList.length - 1;
  while (portalIndex2 >= 0) {
    const proxy = portalProxyList[portalIndex2].$;
    if (proxy.type.name === "QTooltip") {
      portalIndex2--;
      continue;
    }
    if (proxy.type.name !== "QDialog") {
      break;
    }
    if (proxy.props.seamless !== true) {
      return;
    }
    portalIndex2--;
  }
  for (let i = registeredList.length - 1; i >= 0; i--) {
    const state = registeredList[i];
    if ((state.anchorEl.value === null || state.anchorEl.value.contains(target2) === false) && (target2 === document.body || state.innerRef.value !== null && state.innerRef.value.contains(target2) === false)) {
      evt.qClickOutside = true;
      state.onClickOutside(evt);
    } else {
      return;
    }
  }
}
function addClickOutside(clickOutsideProps) {
  registeredList.push(clickOutsideProps);
  if (registeredList.length === 1) {
    document.addEventListener("mousedown", globalHandler, notPassiveCapture);
    document.addEventListener("touchstart", globalHandler, notPassiveCapture);
  }
}
function removeClickOutside(clickOutsideProps) {
  const index = registeredList.findIndex((h2) => h2 === clickOutsideProps);
  if (index !== -1) {
    registeredList.splice(index, 1);
    if (registeredList.length === 0) {
      document.removeEventListener("mousedown", globalHandler, notPassiveCapture);
      document.removeEventListener("touchstart", globalHandler, notPassiveCapture);
    }
  }
}
let vpLeft, vpTop;
function validatePosition(pos) {
  const parts = pos.split(" ");
  if (parts.length !== 2) {
    return false;
  }
  if (["top", "center", "bottom"].includes(parts[0]) !== true) {
    console.error("Anchor/Self position must start with one of top/center/bottom");
    return false;
  }
  if (["left", "middle", "right", "start", "end"].includes(parts[1]) !== true) {
    console.error("Anchor/Self position must end with one of left/middle/right/start/end");
    return false;
  }
  return true;
}
function validateOffset(val) {
  if (!val) {
    return true;
  }
  if (val.length !== 2) {
    return false;
  }
  if (typeof val[0] !== "number" || typeof val[1] !== "number") {
    return false;
  }
  return true;
}
const horizontalPos = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((pos) => {
  horizontalPos[`${pos}#ltr`] = pos;
  horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
  const parts = pos.split(" ");
  return {
    vertical: parts[0],
    horizontal: horizontalPos[`${parts[1]}#${rtl === true ? "rtl" : "ltr"}`]
  };
}
function getAnchorProps(el, offset) {
  let { top, left, right, bottom, width: width2, height } = el.getBoundingClientRect();
  if (offset !== void 0) {
    top -= offset[1];
    left -= offset[0];
    bottom += offset[1];
    right += offset[0];
    width2 += offset[0];
    height += offset[1];
  }
  return {
    top,
    bottom,
    height,
    left,
    right,
    width: width2,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2
  };
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset) {
  let { top, left } = el.getBoundingClientRect();
  top += absoluteOffset.top;
  left += absoluteOffset.left;
  if (offset !== void 0) {
    top += offset[1];
    left += offset[0];
  }
  return {
    top,
    bottom: top + 1,
    height: 1,
    left,
    right: left + 1,
    width: 1,
    middle: left,
    center: top
  };
}
function getTargetProps(width2, height) {
  return {
    top: 0,
    center: height / 2,
    bottom: height,
    left: 0,
    middle: width2 / 2,
    right: width2
  };
}
function getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin) {
  return {
    top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
    left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
  };
}
function setPosition(cfg, retryNumber = 0) {
  if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) {
    return;
  }
  if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
    setTimeout(() => {
      setPosition(cfg, retryNumber + 1);
    }, 10);
    return;
  }
  const {
    targetEl,
    offset,
    anchorEl,
    anchorOrigin,
    selfOrigin,
    absoluteOffset,
    fit,
    cover,
    maxHeight,
    maxWidth
  } = cfg;
  if (client.is.ios === true && window.visualViewport !== void 0) {
    const el = document.body.style;
    const { offsetLeft: left, offsetTop: top } = window.visualViewport;
    if (left !== vpLeft) {
      el.setProperty("--q-pe-left", left + "px");
      vpLeft = left;
    }
    if (top !== vpTop) {
      el.setProperty("--q-pe-top", top + "px");
      vpTop = top;
    }
  }
  const { scrollLeft, scrollTop } = targetEl;
  const anchorProps = absoluteOffset === void 0 ? getAnchorProps(anchorEl, cover === true ? [0, 0] : offset) : getAbsoluteAnchorProps(anchorEl, absoluteOffset, offset);
  Object.assign(targetEl.style, {
    top: 0,
    left: 0,
    minWidth: null,
    minHeight: null,
    maxWidth,
    maxHeight,
    visibility: "visible"
  });
  const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
  const { elWidth, elHeight } = fit === true || cover === true ? { elWidth: Math.max(anchorProps.width, origElWidth), elHeight: cover === true ? Math.max(anchorProps.height, origElHeight) : origElHeight } : { elWidth: origElWidth, elHeight: origElHeight };
  let elStyle = { maxWidth, maxHeight };
  if (fit === true || cover === true) {
    elStyle.minWidth = anchorProps.width + "px";
    if (cover === true) {
      elStyle.minHeight = anchorProps.height + "px";
    }
  }
  Object.assign(targetEl.style, elStyle);
  const targetProps = getTargetProps(elWidth, elHeight);
  let props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
  if (absoluteOffset === void 0 || offset === void 0) {
    applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
  } else {
    const { top, left } = props;
    applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
    let hasChanged = false;
    if (props.top !== top) {
      hasChanged = true;
      const offsetY = 2 * offset[1];
      anchorProps.center = anchorProps.top -= offsetY;
      anchorProps.bottom -= offsetY + 2;
    }
    if (props.left !== left) {
      hasChanged = true;
      const offsetX = 2 * offset[0];
      anchorProps.middle = anchorProps.left -= offsetX;
      anchorProps.right -= offsetX + 2;
    }
    if (hasChanged === true) {
      props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
      applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
    }
  }
  elStyle = {
    top: props.top + "px",
    left: props.left + "px"
  };
  if (props.maxHeight !== void 0) {
    elStyle.maxHeight = props.maxHeight + "px";
    if (anchorProps.height > props.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props.maxWidth !== void 0) {
    elStyle.maxWidth = props.maxWidth + "px";
    if (anchorProps.width > props.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }
  Object.assign(targetEl.style, elStyle);
  if (targetEl.scrollTop !== scrollTop) {
    targetEl.scrollTop = scrollTop;
  }
  if (targetEl.scrollLeft !== scrollLeft) {
    targetEl.scrollLeft = scrollLeft;
  }
}
function applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
  if (props.top < 0 || props.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === "center") {
      props.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
      props.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(
        innerHeight,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top
      );
      props.maxHeight = Math.min(currentHeight, anchorY);
      props.top = Math.max(0, anchorY - currentHeight);
    } else {
      props.top = Math.max(
        0,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom
      );
      props.maxHeight = Math.min(currentHeight, innerHeight - props.top);
    }
  }
  if (props.left < 0 || props.left + currentWidth > innerWidth) {
    props.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === "middle") {
      props.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(
        innerWidth,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left
      );
      props.maxWidth = Math.min(currentWidth, anchorX);
      props.left = Math.max(0, anchorX - props.maxWidth);
    } else {
      props.left = Math.max(
        0,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right
      );
      props.maxWidth = Math.min(currentWidth, innerWidth - props.left);
    }
  }
}
const QMenu = createComponent({
  name: "QMenu",
  inheritAttrs: false,
  props: {
    ...useAnchorProps,
    ...useModelToggleProps,
    ...useDarkProps,
    ...useTransitionProps,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: validatePosition
    },
    self: {
      type: String,
      validator: validatePosition
    },
    offset: {
      type: Array,
      validator: validateOffset
    },
    scrollTarget: scrollTargetProp,
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...useModelToggleEmits,
    "click",
    "escapeKey"
  ],
  setup(props, { slots, emit, attrs }) {
    let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
    const vm = getCurrentInstance();
    const { proxy } = vm;
    const { $q } = proxy;
    const innerRef = ref(null);
    const showing = ref(false);
    const hideOnRouteChange = computed(
      () => props.persistent !== true && props.noRouteDismiss !== true
    );
    const isDark = useDark(props, $q);
    const { registerTick, removeTick } = useTick();
    const { registerTimeout } = useTimeout();
    const { transitionProps, transitionStyle } = useTransition(props);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = useScrollTarget(props, configureScrollTarget);
    const { anchorEl, canShow } = useAnchor({ showing });
    const { hide } = useModelToggle({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    const { showPortal, hidePortal, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "menu");
    const clickOutsideProps = {
      anchorEl,
      innerRef,
      onClickOutside(e) {
        if (props.persistent !== true && showing.value === true) {
          hide(e);
          if (
            // always prevent touch event
            e.type === "touchstart" || e.target.classList.contains("q-dialog__backdrop")
          ) {
            stopAndPrevent(e);
          }
          return true;
        }
      }
    };
    const anchorOrigin = computed(
      () => parsePosition(
        props.anchor || (props.cover === true ? "center middle" : "bottom start"),
        $q.lang.rtl
      )
    );
    const selfOrigin = computed(() => props.cover === true ? anchorOrigin.value : parsePosition(props.self || "top start", $q.lang.rtl));
    const menuClass = computed(
      () => (props.square === true ? " q-menu--square" : "") + (isDark.value === true ? " q-menu--dark q-dark" : "")
    );
    const onEvents = computed(() => props.autoClose === true ? { onClick: onAutoClose } : {});
    const handlesFocus = computed(
      () => showing.value === true && props.persistent !== true
    );
    watch(handlesFocus, (val) => {
      if (val === true) {
        addEscapeKey(onEscapeKey);
        addClickOutside(clickOutsideProps);
      } else {
        removeEscapeKey(onEscapeKey);
        removeClickOutside(clickOutsideProps);
      }
    });
    function focus() {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node && node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function handleShow(evt) {
      refocusTarget = props.noRefocus === false ? document.activeElement : null;
      addFocusout(onFocusout);
      showPortal();
      configureScrollTarget();
      absoluteOffset = void 0;
      if (evt !== void 0 && (props.touchPosition || props.contextMenu)) {
        const pos = position(evt);
        if (pos.left !== void 0) {
          const { top, left } = anchorEl.value.getBoundingClientRect();
          absoluteOffset = { left: pos.left - left, top: pos.top - top };
        }
      }
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props.self + "|" + props.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      if (props.noFocus !== true) {
        document.activeElement.blur();
      }
      registerTick(() => {
        updatePosition();
        props.noFocus !== true && focus();
      });
      registerTimeout(() => {
        if ($q.platform.is.ios === true) {
          avoidAutoClose = props.autoClose;
          innerRef.value.click();
        }
        updatePosition();
        showPortal(true);
        emit("show", evt);
      }, props.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup(true);
      if (refocusTarget !== null && // menu was hidden from code or ESC plugin
      (evt === void 0 || evt.qClickOutside !== true)) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props.transitionDuration);
    }
    function anchorCleanup(hiding) {
      absoluteOffset = void 0;
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      if (hiding === true || showing.value === true) {
        removeFocusout(onFocusout);
        unconfigureScrollTarget();
        removeClickOutside(clickOutsideProps);
        removeEscapeKey(onEscapeKey);
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget(anchorEl.value, props.scrollTarget);
        changeScrollEvent(localScrollTarget.value, updatePosition);
      }
    }
    function onAutoClose(e) {
      if (avoidAutoClose !== true) {
        closePortalMenus(proxy, e);
        emit("click", e);
      } else {
        avoidAutoClose = false;
      }
    }
    function onFocusout(evt) {
      if (handlesFocus.value === true && props.noFocus !== true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus();
      }
    }
    function onEscapeKey(evt) {
      emit("escapeKey");
      hide(evt);
    }
    function updatePosition() {
      setPosition({
        targetEl: innerRef.value,
        offset: props.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        absoluteOffset,
        fit: props.fit,
        cover: props.cover,
        maxHeight: props.maxHeight,
        maxWidth: props.maxWidth
      });
    }
    function renderPortalContent() {
      return h(
        Transition,
        transitionProps.value,
        () => showing.value === true ? h("div", {
          role: "menu",
          ...attrs,
          ref: innerRef,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + menuClass.value,
            attrs.class
          ],
          style: [
            attrs.style,
            transitionStyle.value
          ],
          ...onEvents.value
        }, hSlot(slots.default)) : null
      );
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(proxy, { focus, updatePosition });
    return renderPortal;
  }
});
let buf, bufIdx = 0;
const hexBytes = new Array(256);
for (let i = 0; i < 256; i++) {
  hexBytes[i] = (i + 256).toString(16).substring(1);
}
const randomBytes = (() => {
  const lib = typeof crypto !== "undefined" ? crypto : typeof window !== "undefined" ? window.crypto || window.msCrypto : void 0;
  if (lib !== void 0) {
    if (lib.randomBytes !== void 0) {
      return lib.randomBytes;
    }
    if (lib.getRandomValues !== void 0) {
      return (n) => {
        const bytes = new Uint8Array(n);
        lib.getRandomValues(bytes);
        return bytes;
      };
    }
  }
  return (n) => {
    const r = [];
    for (let i = n; i > 0; i--) {
      r.push(Math.floor(Math.random() * 256));
    }
    return r;
  };
})();
const BUFFER_SIZE = 4096;
function uid() {
  if (buf === void 0 || bufIdx + 16 > BUFFER_SIZE) {
    bufIdx = 0;
    buf = randomBytes(BUFFER_SIZE);
  }
  const b = Array.prototype.slice.call(buf, bufIdx, bufIdx += 16);
  b[6] = b[6] & 15 | 64;
  b[8] = b[8] & 63 | 128;
  return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + "-" + hexBytes[b[4]] + hexBytes[b[5]] + "-" + hexBytes[b[6]] + hexBytes[b[7]] + "-" + hexBytes[b[8]] + hexBytes[b[9]] + "-" + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
}
function parseValue(val) {
  return val === void 0 || val === null ? null : val;
}
function getId(val, required) {
  return val === void 0 || val === null ? required === true ? `f_${uid()}` : null : val;
}
function useId({ getValue, required = true } = {}) {
  if (isRuntimeSsrPreHydration.value === true) {
    const id = getValue !== void 0 ? ref(parseValue(getValue())) : ref(null);
    if (required === true && id.value === null) {
      onMounted(() => {
        id.value = `f_${uid()}`;
      });
    }
    if (getValue !== void 0) {
      watch(getValue, (newId) => {
        id.value = getId(newId, required);
      });
    }
    return id;
  }
  return getValue !== void 0 ? computed(() => getId(getValue(), required)) : ref(`f_${uid()}`);
}
const btnPropsList = Object.keys(nonRoundBtnProps);
function passBtnProps(props) {
  return btnPropsList.reduce((acc, key) => {
    const val = props[key];
    if (val !== void 0) {
      acc[key] = val;
    }
    return acc;
  }, {});
}
const QBtnDropdown = createComponent({
  name: "QBtnDropdown",
  props: {
    ...nonRoundBtnProps,
    ...useTransitionProps,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(props, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const showing = ref(props.modelValue);
    const menuRef = ref(null);
    const targetUid = useId();
    const ariaAttrs = computed(() => {
      const acc = {
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        "aria-label": props.toggleAriaLabel || proxy.$q.lang.label[showing.value === true ? "collapse" : "expand"](props.label)
      };
      if (props.disable === true || (props.split === false && props.disableMainBtn === true || props.disableDropdown === true)) {
        acc["aria-disabled"] = "true";
      }
      return acc;
    });
    const iconClass = computed(
      () => "q-btn-dropdown__arrow" + (showing.value === true && props.noIconAnimation === false ? " rotate-180" : "") + (props.split === false ? " q-btn-dropdown__arrow-container" : "")
    );
    const btnDesignAttr = computed(() => getBtnDesignAttr(props));
    const btnProps = computed(() => passBtnProps(props));
    watch(() => props.modelValue, (val) => {
      menuRef.value !== null && menuRef.value[val ? "show" : "hide"]();
    });
    watch(() => props.split, hide);
    function onBeforeShow(e) {
      showing.value = true;
      emit("beforeShow", e);
    }
    function onShow(e) {
      emit("show", e);
      emit("update:modelValue", true);
    }
    function onBeforeHide(e) {
      showing.value = false;
      emit("beforeHide", e);
    }
    function onHide(e) {
      emit("hide", e);
      emit("update:modelValue", false);
    }
    function onClick(e) {
      emit("click", e);
    }
    function onClickHide(e) {
      stop(e);
      hide();
      emit("click", e);
    }
    function toggle(evt) {
      menuRef.value !== null && menuRef.value.toggle(evt);
    }
    function show(evt) {
      menuRef.value !== null && menuRef.value.show(evt);
    }
    function hide(evt) {
      menuRef.value !== null && menuRef.value.hide(evt);
    }
    Object.assign(proxy, {
      show,
      hide,
      toggle
    });
    onMounted(() => {
      props.modelValue === true && show();
    });
    return () => {
      const Arrow = [
        h(QIcon, {
          class: iconClass.value,
          name: props.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
        })
      ];
      props.disableDropdown !== true && Arrow.push(
        h(QMenu, {
          ref: menuRef,
          id: targetUid.value,
          class: props.contentClass,
          style: props.contentStyle,
          cover: props.cover,
          fit: true,
          persistent: props.persistent,
          noRouteDismiss: props.noRouteDismiss,
          autoClose: props.autoClose,
          anchor: props.menuAnchor,
          self: props.menuSelf,
          offset: props.menuOffset,
          separateClosePopup: true,
          transitionShow: props.transitionShow,
          transitionHide: props.transitionHide,
          transitionDuration: props.transitionDuration,
          onBeforeShow,
          onShow,
          onBeforeHide,
          onHide
        }, slots.default)
      );
      if (props.split === false) {
        return h(QBtn, {
          class: "q-btn-dropdown q-btn-dropdown--simple",
          ...btnProps.value,
          ...ariaAttrs.value,
          disable: props.disable === true || props.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick
        }, {
          default: () => hSlot(slots.label, []).concat(Arrow),
          loading: slots.loading
        });
      }
      return h(QBtnGroup, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: props.rounded,
        square: props.square,
        ...btnDesignAttr.value,
        glossy: props.glossy,
        stretch: props.stretch
      }, () => [
        h(QBtn, {
          class: "q-btn-dropdown--current",
          ...btnProps.value,
          disable: props.disable === true || props.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick: onClickHide
        }, {
          default: slots.label,
          loading: slots.loading
        }),
        h(QBtn, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...ariaAttrs.value,
          ...btnDesignAttr.value,
          disable: props.disable === true || props.disableDropdown === true,
          rounded: props.rounded,
          color: props.color,
          textColor: props.textColor,
          dense: props.dense,
          size: props.size,
          padding: props.padding,
          ripple: props.ripple
        }, () => Arrow)
      ]);
    };
  }
});
const iconArrowDown = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.293%207.293l1.414%201.414L12%2017.414%203.293%208.707l1.414-1.414L12%2014.586z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
const _hoisted_1$i = { class: "row items-center no-wrap" };
const _hoisted_2$e = { class: "ws-color-navy text-center text-capitalize q-px-sm" };
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "WsSelectLanguage",
  setup(__props) {
    const { i18next } = useTranslation();
    const { setLang } = useI18n();
    const language = computed(() => i18next.language);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(QBtnDropdown, {
        "data-test": "select-country",
        class: "q-mt-xs",
        "content-class": "ws-select-language-menu",
        "dropdown-icon": `img:${unref(iconArrowDown)}`
      }, {
        label: withCtx(() => [
          createElementVNode("div", _hoisted_1$i, [
            (openBlock(), createBlock(WsCountryFlag, {
              key: language.value,
              country: language.value,
              class: "q-my-none",
              size: "small"
            }, null, 8, ["country"])),
            createElementVNode("div", _hoisted_2$e, toDisplayString(unref(getLanguageName)(unref(localeToFlagCode)(language.value))), 1)
          ])
        ]),
        default: withCtx(() => [
          createVNode(QList, { class: "footer-dropdown cy-language-selector" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(languages), (country, index) => {
                return openBlock(), createBlock(QItem, {
                  key: index,
                  title: country,
                  clickable: "",
                  "data-test": `set-language-${country}`,
                  onClick: ($event) => unref(setLang)(country)
                }, {
                  default: withCtx(() => [
                    createVNode(QItemSection, { side: "" }, {
                      default: withCtx(() => [
                        createVNode(WsCountryFlag, {
                          size: "small",
                          country: unref(localeToFlagCode)(country)
                        }, null, 8, ["country"])
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(QItemSection, null, {
                      default: withCtx(() => [
                        createVNode(QItemLabel, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(getLanguageName)(unref(localeToFlagCode)(country))), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["title", "data-test", "onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["dropdown-icon"]);
    };
  }
});
const WsSelectLanguage = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-91534740"]]);
const _hoisted_1$h = { class: "ws-typography section-fit" };
const _hoisted_2$d = { class: "row no-wrap justify-between items-center q-mt-md" };
const _hoisted_3$a = { class: "flex justify-center max-w-custom" };
const _hoisted_4$6 = ["href"];
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "WsLoginCard",
  props: {
    config: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const { i18next } = useTranslation();
    const { theme } = useTheming();
    const attrs = useAttrs();
    const links = [
      "help",
      "terms",
      "privacy"
    ];
    setupUrls(props.config);
    const getLogo = computed(() => {
      switch (theme.value) {
        case Theme.LOOPIA:
          return {
            "src": "https://cdn.websupport.eu/companies/loopia/logo-small.svg",
            "alt": "Loopia",
            "height": 31
          };
        case Theme.CARY:
        default:
          return {
            "src": "https://cdn.websupport.eu/companies/ws/logo.svg",
            "alt": "Websupport",
            "height": 40
          };
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1$h, [
        createVNode(QCard, { class: "login-card" }, {
          default: withCtx(() => [
            createElementVNode("img", mergeProps(getLogo.value, { alt: "" }), null, 16),
            createVNode(unref(PortalSlot), {
              "component-id": unref(attrs)["component-id"]
            }, null, 8, ["component-id"]),
            createVNode(WsHelpSection, { config: __props.config }, null, 8, ["config"])
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_2$d, [
          createVNode(WsSelectLanguage, {
            config: __props.config,
            class: "cy-language-btn",
            "aria-controls": "select-language"
          }, null, 8, ["config"]),
          createElementVNode("div", _hoisted_3$a, [
            (openBlock(), createElementBlock(Fragment, null, renderList(links, (link, index) => {
              return createElementVNode("a", {
                key: index,
                class: "anchor-text1 q-mr-lg",
                href: unref(getUrl)(link, unref(i18next).language)
              }, toDisplayString(_ctx.$t(`uikit:login_pages.footer.${link}`)), 9, _hoisted_4$6);
            }), 64))
          ])
        ])
      ]);
    };
  }
});
const WsLoginCard = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-8708c637"]]);
const _hoisted_1$g = { class: "ws-typography row" };
const _hoisted_2$c = ["srcset", "sizes"];
const _hoisted_3$9 = ["srcset", "sizes"];
const _hoisted_4$5 = ["src", "width", "height"];
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "WsLoginAside",
  setup(__props) {
    const { theme } = useTheming();
    const attrs = useAttrs();
    const image = ref({});
    const getImageSizes = () => {
      switch (theme.value) {
        case Theme.LOOPIA:
          return {
            width: 460,
            height: 460
          };
        case Theme.ACTIVE_24:
        case Theme.CARY:
        default:
          return {
            width: 607,
            height: 460
          };
      }
    };
    const loadAssets = async () => {
      var _a;
      const { width: width2, height } = getImageSizes();
      const path = `assets/images/${(_a = theme.value) == null ? void 0 : _a.toLowerCase()}/logins`;
      image.value = {
        src: `${path}/aside.png`,
        src2x: `${path}/aside@2x.png`,
        srcWebp: `${path}/aside.webp`,
        srcWebp2x: `${path}/aside@2x.webp`,
        width: width2,
        height
      };
    };
    watch(theme, () => {
      loadAssets();
    }, { immediate: true });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1$g, [
        createElementVNode("picture", null, [
          createElementVNode("source", {
            type: "image/webp",
            srcset: `${image.value.srcWebp} 1x, ${image.value.srcWebp2x} 2x`,
            sizes: image.value.width + "px"
          }, null, 8, _hoisted_2$c),
          createElementVNode("source", {
            srcset: `${image.value.src2x} 2x`,
            sizes: image.value.width + "px"
          }, null, 8, _hoisted_3$9),
          createElementVNode("img", {
            src: image.value.src,
            width: image.value.width,
            height: image.value.height,
            class: "login-image",
            alt: ""
          }, null, 8, _hoisted_4$5)
        ]),
        createVNode(unref(PortalSlot), {
          "component-id": unref(attrs)["component-id"]
        }, null, 8, ["component-id"])
      ]);
    };
  }
});
const WsLoginAside = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-b4a66bad"]]);
function declensionGroup(scheme, count) {
  if (count === 1 && scheme.one) {
    return scheme.one;
  }
  if (count >= 2 && count <= 4 && scheme.twoFour) {
    return scheme.twoFour;
  }
  return scheme.other;
}
function declension(scheme, count, time) {
  const group = declensionGroup(scheme, count);
  const finalText = group[time];
  return finalText.replace("{{count}}", String(count));
}
function extractPreposition(token) {
  const result = ["lessThan", "about", "over", "almost"].filter(
    function(preposition) {
      return !!token.match(new RegExp("^" + preposition));
    }
  );
  return result[0];
}
function prefixPreposition(preposition) {
  let translation = "";
  if (preposition === "almost") {
    translation = "takmer";
  }
  if (preposition === "about") {
    translation = "približne";
  }
  return translation.length > 0 ? translation + " " : "";
}
function suffixPreposition(preposition) {
  let translation = "";
  if (preposition === "lessThan") {
    translation = "menej než";
  }
  if (preposition === "over") {
    translation = "viac než";
  }
  return translation.length > 0 ? translation + " " : "";
}
function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
const formatDistanceLocale$3 = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
};
const formatDistance$4 = (token, count, options) => {
  const preposition = extractPreposition(token) || "";
  const key = lowercaseFirstLetter(token.substring(preposition.length));
  const scheme = formatDistanceLocale$3[key];
  if (!(options == null ? void 0 : options.addSuffix)) {
    return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, "present");
  }
  if (options.comparison && options.comparison > 0) {
    return prefixPreposition(preposition) + "o " + suffixPreposition(preposition) + declension(scheme, count, "future");
  } else {
    return prefixPreposition(preposition) + "pred " + suffixPreposition(preposition) + declension(scheme, count, "past");
  }
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width2 = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width2] || args.formats[args.defaultWidth];
    return format;
  };
}
const dateFormats$4 = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
};
const timeFormats$4 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
const dateTimeFormats$4 = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong$4 = {
  date: buildFormatLongFn({
    formats: dateFormats$4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$4,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$4,
    defaultWidth: "full"
  })
};
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = startOfWeek(dateLeft, options);
  const dateRightStartOfWeek = startOfWeek(dateRight, options);
  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}
const accusativeWeekdays$2 = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function lastWeek(day) {
  const weekday = accusativeWeekdays$2[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + weekday + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function thisWeek(day) {
  const weekday = accusativeWeekdays$2[day];
  if (day === 4) {
    return "'vo' eeee 'o' p";
  } else {
    return "'v " + weekday + " o' p";
  }
}
function nextWeek(day) {
  const weekday = accusativeWeekdays$2[day];
  switch (day) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + weekday + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const formatRelativeLocale$4 = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: "P"
};
const formatRelative$4 = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$4[token];
  if (typeof format === "function") {
    return format(date, baseDate, options);
  }
  return format;
};
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width2] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width2] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}
const eraValues$4 = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
};
const quarterValues$4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
};
const monthValues$4 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
};
const formattingMonthValues$1 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
};
const dayValues$4 = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
};
const dayPeriodValues$4 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
};
const formattingDayPeriodValues$3 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
};
const ordinalNumber$4 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};
const localize$4 = {
  ordinalNumber: ordinalNumber$4,
  era: buildLocalizeFn({
    values: eraValues$4,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$4,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$4,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$1,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$4,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width2 = options.width;
    const matchPattern = width2 && args.matchPatterns[width2] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width2 && args.parsePatterns[width2] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern$4 = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$4 = /\d+/i;
const matchEraPatterns$4 = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
const parseEraPatterns$4 = {
  any: [/^pr/i, /^(po|n)/i]
};
const matchQuarterPatterns$4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
const parseQuarterPatterns$4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
const parseMonthPatterns$4 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns$4 = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
const parseDayPatterns$4 = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
};
const matchDayPeriodPatterns$4 = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
const parseDayPeriodPatterns$4 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
};
const match$4 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$4,
    parsePattern: parseOrdinalNumberPattern$4,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$4,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$4,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$4,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$4,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$4,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$4,
    defaultParseWidth: "any"
  })
};
const sk = {
  code: "sk",
  formatDistance: formatDistance$4,
  formatLong: formatLong$4,
  formatRelative: formatRelative$4,
  localize: localize$4,
  match: match$4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const formatDistanceLocale$2 = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
};
const formatDistance$3 = (token, count, options) => {
  let pluralResult;
  const tokenValue = formatDistanceLocale$2[token];
  if (tokenValue.type === "other") {
    pluralResult = tokenValue.other;
  } else if (count === 1) {
    pluralResult = tokenValue.one;
  } else if (count > 1 && count < 5) {
    pluralResult = tokenValue.few;
  } else {
    pluralResult = tokenValue.many;
  }
  const suffixExist = (options == null ? void 0 : options.addSuffix) === true;
  const comparison = options == null ? void 0 : options.comparison;
  let timeResult;
  if (suffixExist && comparison === -1) {
    timeResult = pluralResult.past;
  } else if (suffixExist && comparison === 1) {
    timeResult = pluralResult.future;
  } else {
    timeResult = pluralResult.regular;
  }
  return timeResult.replace("{{count}}", String(count));
};
const dateFormats$3 = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
};
const timeFormats$3 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
const dateTimeFormats$3 = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$3 = {
  date: buildFormatLongFn({
    formats: dateFormats$3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$3,
    defaultWidth: "full"
  })
};
const accusativeWeekdays$1 = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu"
];
const formatRelativeLocale$3 = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (date) => {
    const day = date.getDay();
    return "'v " + accusativeWeekdays$1[day] + " o' p";
  },
  other: "P"
};
const formatRelative$3 = (token, date) => {
  const format = formatRelativeLocale$3[token];
  if (typeof format === "function") {
    return format(date);
  }
  return format;
};
const eraValues$3 = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
};
const quarterValues$3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
};
const monthValues$3 = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec"
  ]
};
const formattingMonthValues = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince"
  ]
};
const dayValues$3 = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
};
const dayPeriodValues$3 = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
};
const formattingDayPeriodValues$2 = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
};
const ordinalNumber$3 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};
const localize$3 = {
  ordinalNumber: ordinalNumber$3,
  era: buildLocalizeFn({
    values: eraValues$3,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$3,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$3,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide"
  })
};
const matchOrdinalNumberPattern$3 = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$3 = /\d+/i;
const matchEraPatterns$3 = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
const parseEraPatterns$3 = {
  any: [/^p[řr]/i, /^(po|n)/i]
};
const matchQuarterPatterns$3 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
const parseQuarterPatterns$3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$3 = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
const parseMonthPatterns$3 = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i
  ],
  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i
  ]
};
const matchDayPatterns$3 = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
const parseDayPatterns$3 = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
};
const matchDayPeriodPatterns$3 = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
const parseDayPeriodPatterns$3 = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
};
const match$3 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$3,
    parsePattern: parseOrdinalNumberPattern$3,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$3,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$3,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$3,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$3,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$3,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$3,
    defaultParseWidth: "any"
  })
};
const cs = {
  code: "cs",
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance$2 = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
const dateFormats$2 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats$2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats$2 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$2 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative$2 = (token, _date, _baseDate, _options) => formatRelativeLocale$2[token];
const eraValues$2 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues$2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues$2 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues$2 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues$2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber$2 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize$2 = {
  ordinalNumber: ordinalNumber$2,
  era: buildLocalizeFn({
    values: eraValues$2,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$2,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
const matchOrdinalNumberPattern$2 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$2 = /\d+/i;
const matchEraPatterns$2 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns$2 = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns$2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns$2 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns$2 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns$2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns$2 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns$2 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance: formatDistance$2,
  formatLong: formatLong$2,
  formatRelative: formatRelative$2,
  localize: localize$2,
  match: match$2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
};
const wordMapping = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
];
const formatDistance$1 = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace(
      "{{count}}",
      count < 13 ? wordMapping[count] : String(count)
    );
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result;
    } else {
      return result + " sedan";
    }
  }
  return result;
};
const dateFormats$1 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
};
const timeFormats$1 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$1 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$1 = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
};
const formatRelative$1 = (token, _date, _baseDate, _options) => formatRelativeLocale$1[token];
const eraValues$1 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
};
const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
};
const monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
};
const dayValues$1 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
};
const dayPeriodValues$1 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
};
const ordinalNumber$1 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number + ":a";
    }
  }
  return number + ":e";
};
const localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const matchOrdinalNumberPattern$1 = /^(\d+)(:a|:e)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;
const matchEraPatterns$1 = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
const parseEraPatterns$1 = {
  any: [/^f/i, /^[ev]/i]
};
const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
};
const parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
const parseMonthPatterns$1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns$1 = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
const parseDayPatterns$1 = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
const matchDayPeriodPatterns$1 = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
const match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
const sv = {
  code: "sv",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const translations = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
};
const withoutSuffixes = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
};
const withSuffixes = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
};
const formatDistance = (token, count, options) => {
  const adverb = token.match(/about|over|almost|lessthan/i);
  const unit = adverb ? token.replace(adverb[0], "") : token;
  const addSuffix = (options == null ? void 0 : options.addSuffix) === true;
  const key = unit.toLowerCase();
  const comparison = (options == null ? void 0 : options.comparison) || 0;
  const translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
  let result = key === "halfaminute" ? translated : count + translated;
  if (adverb) {
    const adv = adverb[0].toLowerCase();
    result = translations[adv] + " " + result;
  }
  return result;
};
const dateFormats = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
};
const timeFormats = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
const dateTimeFormats = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const accusativeWeekdays = [
  "vasárnap",
  "hétfőn",
  "kedden",
  "szerdán",
  "csütörtökön",
  "pénteken",
  "szombaton"
];
function week(isFuture) {
  return (date) => {
    const weekday = accusativeWeekdays[date.getDay()];
    const prefix = isFuture ? "" : "'múlt' ";
    return `${prefix}'${weekday}' p'-kor'`;
  };
}
const formatRelativeLocale = {
  lastWeek: week(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week(true),
  other: "P"
};
const formatRelative = (token, date) => {
  const format = formatRelativeLocale[token];
  if (typeof format === "function") {
    return format(date);
  }
  return format;
};
const eraValues = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
};
const quarterValues = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
};
const formattingQuarterValues = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
};
const monthValues = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "febr.",
    "márc.",
    "ápr.",
    "máj.",
    "jún.",
    "júl.",
    "aug.",
    "szept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "január",
    "február",
    "március",
    "április",
    "május",
    "június",
    "július",
    "augusztus",
    "szeptember",
    "október",
    "november",
    "december"
  ]
};
const dayValues = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: [
    "vasárnap",
    "hétfő",
    "kedd",
    "szerda",
    "csütörtök",
    "péntek",
    "szombat"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: "wide"
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide"
  })
};
const matchOrdinalNumberPattern = /^(\d+)\.?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
const parseEraPatterns = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
const parseQuarterPatterns = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a|á/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s|sz/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^már/i,
    /^áp/i,
    /^máj/i,
    /^jún/i,
    /^júl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
const parseDayPatterns = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
};
const matchDayPeriodPatterns = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const hu = {
  code: "hu",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const _hoisted_1$f = { class: "ws-users-list" };
const _hoisted_2$b = ["onClick"];
const _hoisted_3$8 = { class: "ws-users-list__data" };
const _hoisted_4$4 = { class: "ws-users-list__name" };
const _hoisted_5$3 = {
  key: 0,
  class: "ws-users-list__date"
};
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "WsUsersList",
  props: {
    users: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  setup(__props) {
    const { i18next } = useI18n();
    const getCurrentDateLocale = () => {
      const langs = {
        "sk-SK": sk,
        "cs-CZ": cs,
        "en-US": enUS,
        "sv-SE": sv,
        "hu-HU": hu
      };
      return langs[i18next.language];
    };
    const readableDateDiff = (date) => {
      return formatDistanceToNowStrict(date, {
        locale: getCurrentDateLocale(),
        addSuffix: true
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", _hoisted_1$f, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.users, (user) => {
          return openBlock(), createElementBlock("li", {
            key: user.login
          }, [
            createElementVNode("button", {
              class: "ws-users-list__user",
              onClick: ($event) => _ctx.$emit("select", user)
            }, [
              createVNode(WsIcon, {
                name: "account",
                size: 24,
                class: "ws-users-list__icon"
              }),
              createElementVNode("span", _hoisted_3$8, [
                createElementVNode("span", _hoisted_4$4, toDisplayString(user.login), 1),
                user.date ? (openBlock(), createElementBlock("span", _hoisted_5$3, toDisplayString(readableDateDiff(user.date)), 1)) : createCommentVNode("", true)
              ])
            ], 8, _hoisted_2$b)
          ]);
        }), 128))
      ]);
    };
  }
});
const WsUsersList = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-a2a42dbc"]]);
var VatInfoDisplayMode = /* @__PURE__ */ ((VatInfoDisplayMode2) => {
  VatInfoDisplayMode2["NONE"] = "none";
  VatInfoDisplayMode2["INCLUDE"] = "include";
  VatInfoDisplayMode2["EXCLUDE"] = "exclude";
  return VatInfoDisplayMode2;
})(VatInfoDisplayMode || {});
const WsPriceBadgeEnum = {
  VatInfoDisplayMode
};
const _hoisted_1$e = { class: "ws-price-badge grid items-center" };
const _hoisted_2$a = { class: "row items-baseline" };
const _hoisted_3$7 = {
  key: 0,
  class: "q-mr-sm"
};
const _hoisted_4$3 = {
  key: 1,
  class: "q-ml-sm"
};
const _hoisted_5$2 = {
  key: 0,
  class: "row justify-center"
};
const _hoisted_6$1 = { key: 0 };
const _hoisted_7$1 = { key: 1 };
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "WsPriceBadge",
  props: {
    prefix: {
      type: String,
      default: ""
    },
    timeAmount: {
      type: String,
      default: ""
    },
    vatInfoDisplayMode: {
      type: String,
      default: VatInfoDisplayMode.NONE
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", _hoisted_1$e, [
        createElementVNode("div", null, [
          createElementVNode("div", _hoisted_2$a, [
            props.prefix ? (openBlock(), createElementBlock("span", _hoisted_3$7, toDisplayString(props.prefix), 1)) : createCommentVNode("", true),
            createVNode(_component_portal_slot, {
              slot: _ctx.$slots.default,
              "component-id": _ctx.$attrs["component-id"]
            }, null, 8, ["slot", "component-id"]),
            props.timeAmount ? (openBlock(), createElementBlock("span", _hoisted_4$3, "/ " + toDisplayString(props.timeAmount), 1)) : createCommentVNode("", true)
          ]),
          props.vatInfoDisplayMode !== "none" ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
            props.vatInfoDisplayMode === "include" ? (openBlock(), createElementBlock("span", _hoisted_6$1, toDisplayString(_ctx.$t("uikit:price_badge.including_vat")), 1)) : createCommentVNode("", true),
            props.vatInfoDisplayMode === "exclude" ? (openBlock(), createElementBlock("span", _hoisted_7$1, toDisplayString(_ctx.$t("uikit:price_badge.excluding_vat")), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const WsPriceBadge = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["__scopeId", "data-v-2ffc6950"]]);
var UI_VARIANT = /* @__PURE__ */ ((UI_VARIANT2) => {
  UI_VARIANT2["DEFAULT"] = "default";
  UI_VARIANT2["NEUTRAL"] = "neutral";
  UI_VARIANT2["WARNING"] = "warning";
  UI_VARIANT2["ERROR"] = "error";
  UI_VARIANT2["ALERT"] = "alert";
  UI_VARIANT2["SUCCESS"] = "success";
  return UI_VARIANT2;
})(UI_VARIANT || {});
var UI_SIZE = /* @__PURE__ */ ((UI_SIZE2) => {
  UI_SIZE2["LARGE"] = "large";
  UI_SIZE2["MEDIUM"] = "medium";
  UI_SIZE2["SMALL"] = "small";
  return UI_SIZE2;
})(UI_SIZE || {});
const WsStateBannerEnum = {
  Variant: UI_VARIANT,
  Size: UI_SIZE
};
var RESEND_CODE_STATUS = /* @__PURE__ */ ((RESEND_CODE_STATUS2) => {
  RESEND_CODE_STATUS2["READY"] = "ready";
  RESEND_CODE_STATUS2["SENDING"] = "sending";
  RESEND_CODE_STATUS2["ON_COOLDOWN"] = "on_cooldown";
  return RESEND_CODE_STATUS2;
})(RESEND_CODE_STATUS || {});
const WsTwoFactorAuthenticationInputEnum = {
  ResendCodeStatus: RESEND_CODE_STATUS
};
const _hoisted_1$d = { class: "totp-inputs justify-between" };
const _hoisted_2$9 = ["value", "name"];
const _hoisted_3$6 = ["onUpdate:modelValue", "onKeydown", "onInput"];
const _hoisted_4$2 = {
  key: 0,
  class: "flex items-center q-my-lg"
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "WsTwoFactorAuthenticationInput",
  props: {
    numberOfFields: {
      type: Number,
      default: 6
    },
    resendCodeUrl: {
      type: String,
      default: ""
    },
    resendCodeCooldown: {
      type: [Number, String],
      default: 30
    },
    resendCodeMethod: {
      type: String,
      default: "get"
    },
    resendCodeData: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: "code"
    }
  },
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {
    const { t } = useI18n();
    const props = __props;
    const { numberOfFields, resendCodeUrl, resendCodeCooldown, resendCodeMethod, resendCodeData } = toRefs(props);
    const emit = __emit;
    const messageType = ref(UI_VARIANT.ERROR);
    const message = ref("");
    const wrap = ref(null);
    const valueParts = ref(Array(numberOfFields.value).fill(""));
    const focus = (index) => {
      var _a;
      const input = (_a = wrap.value) == null ? void 0 : _a.children[index];
      if (input) {
        input.focus();
      }
    };
    const handleInput = (event, index) => {
      const inputEvent = event;
      const value = inputEvent.data ?? valueParts.value[index];
      valueParts.value[index] = value;
      if (index === numberOfFields.value - 1) {
        nextTick(() => {
          focus(index);
        });
      } else {
        focus(index + 1);
      }
    };
    const handleKeyDown = (event, index) => {
      const key = _sanitizeEventKey(event.key);
      if (!key) {
        return;
      }
      message.value = "";
      switch (key) {
        case "Backspace":
          deleteCharacter(event, index);
          return;
        case "ArrowRight":
        case "Right":
          focus(index + 1);
          return;
        case "ArrowLeft":
        case "Left":
          focus(index - 1);
          return;
      }
      if (event.metaKey || event.ctrlKey || event.altKey) {
        return;
      }
      if (key.length === 1 && !/\d/.test(key)) {
        event.preventDefault();
      }
    };
    const deleteCharacter = (event, index) => {
      event.preventDefault();
      if (valueParts.value[index].trim()) {
        valueParts.value[index] = "";
      }
      if (index === 0) {
        nextTick(() => {
          focus(0);
        });
      } else {
        focus(index - 1);
      }
    };
    function isValidTotpCode(totpCode) {
      return totpCode.length === numberOfFields.value && /^\d+$/.test(totpCode);
    }
    const handlePaste = (event) => {
      const pastedCode = getCodeFromClipboard(event);
      if (pastedCode === void 0) {
        return;
      }
      if (!isValidTotpCode(pastedCode)) {
        focus(0);
        messageType.value = UI_VARIANT.ERROR;
        message.value = t("uikit:ws_two_factor_authentication_input.invalid_code_pasted");
        return;
      }
      valueParts.value = pastedCode.split("");
      nextTick(() => {
        focus(numberOfFields.value - 1);
      });
    };
    const getCodeFromClipboard = (event) => {
      event.preventDefault();
      const clipboardData = event.clipboardData || typeof window !== "undefined" && window.clipboardData;
      if (!clipboardData) {
        return void 0;
      }
      const codeFromClipboard = clipboardData.getData("Text") || clipboardData.getData("text/plain");
      return codeFromClipboard.trim();
    };
    function _sanitizeEventKey(key) {
      return key === "Unidentified" ? void 0 : key;
    }
    const code = computed(() => {
      return valueParts.value.join("");
    });
    const emitInput = () => {
      emit("update:value", code.value);
    };
    watch(valueParts, emitInput, { deep: true });
    const resendCodeStatus = ref(RESEND_CODE_STATUS.READY);
    const resendCodeCountdown = ref(0);
    const resendCodeInterval = ref(void 0);
    const resendCode = () => {
      message.value = "";
      resendCodeStatus.value = RESEND_CODE_STATUS.SENDING;
      axios[resendCodeMethod.value](resendCodeUrl.value, resendCodeData.value).then(function() {
        startResetButtonCooldown();
      }).catch(function(error) {
        messageType.value = UI_VARIANT.ERROR;
        message.value = t("uikit:ws_two_factor_authentication_input.error_sending_code") + error.message;
        resendCodeStatus.value = RESEND_CODE_STATUS.READY;
      });
    };
    function startResetButtonCooldown() {
      messageType.value = UI_VARIANT.SUCCESS;
      message.value = t("uikit:ws_two_factor_authentication_input.code_sent_successfully");
      resendCodeStatus.value = RESEND_CODE_STATUS.ON_COOLDOWN;
      const cooldown = parseInt(resendCodeCooldown.value);
      resendCodeCountdown.value = cooldown;
      startCountdown();
      setTimeout(() => {
        resendCodeStatus.value = RESEND_CODE_STATUS.READY;
      }, cooldown * 1e3);
    }
    function startCountdown() {
      resendCodeInterval.value = setInterval(() => {
        resendCodeCountdown.value -= 1;
        if (resendCodeCountdown.value <= 0) {
          clearInterval(resendCodeInterval.value);
        }
      }, 1e3);
    }
    onUnmounted(() => {
      clearInterval(resendCodeInterval.value);
    });
    return (_ctx, _cache) => {
      const _component_ws_button = resolveComponent("ws-button");
      const _component_ws_tooltip = resolveComponent("ws-tooltip");
      const _component_ws_state_banner = resolveComponent("ws-state-banner");
      return openBlock(), createElementBlock("div", _hoisted_1$d, [
        createElementVNode("input", {
          type: "hidden",
          value: code.value,
          name: __props.name
        }, null, 8, _hoisted_2$9),
        createElementVNode("div", {
          ref_key: "wrap",
          ref: wrap,
          class: "code-input-container self-center"
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(valueParts.value, (val, index) => {
            return withDirectives((openBlock(), createElementBlock("input", {
              key: `wstfa-${val}-${index}`,
              "onUpdate:modelValue": ($event) => valueParts.value[index] = $event,
              class: "code-input",
              autocomplete: "one-time-code",
              "data-test": "totp-input",
              onKeydown: ($event) => {
                handleKeyDown($event, index);
              },
              onInput: ($event) => {
                handleInput($event, index);
              },
              onPaste: handlePaste
            }, null, 40, _hoisted_3$6)), [
              [vModelText, valueParts.value[index]]
            ]);
          }), 128))
        ], 512),
        unref(resendCodeUrl) ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
          createVNode(_component_ws_button, {
            class: "resend-code-button",
            "data-test": "resend-code-button",
            disabled: resendCodeStatus.value !== unref(RESEND_CODE_STATUS).READY,
            type: unref(ButtonType).TERTIARY,
            onClick: resendCode
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.$t("uikit:ws_two_factor_authentication_input.resend_code")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "type"]),
          resendCodeStatus.value !== unref(RESEND_CODE_STATUS).READY ? (openBlock(), createBlock(_component_ws_tooltip, { key: 0 }, {
            default: withCtx(() => [
              resendCodeStatus.value === unref(RESEND_CODE_STATUS).SENDING ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(_ctx.$t("uikit:ws_two_factor_authentication_input.code_being_sent")), 1)
              ], 64)) : resendCodeStatus.value === unref(RESEND_CODE_STATUS).ON_COOLDOWN ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(_ctx.$t("uikit:ws_two_factor_authentication_input.on_cooldown", { count: resendCodeCountdown.value })), 1)
              ], 64)) : createCommentVNode("", true)
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        message.value ? (openBlock(), createBlock(_component_ws_state_banner, {
          key: 1,
          text: _ctx.$t(message.value),
          type: messageType.value
        }, {
          text: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.$t(message.value)), 1)
          ]),
          _: 1
        }, 8, ["text", "type"])) : createCommentVNode("", true)
      ]);
    };
  }
});
const WsTwoFactorAuthenticationInput = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-b67e94a6"]]);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "WsLabelLink",
  props: {
    href: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: "uikit:general.link"
    }
  },
  setup(__props) {
    const props = __props;
    const handleClick = () => window.open(props.href, props.target);
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("a", {
        class: "ws-link",
        href: "javascript:void(0)",
        onClick: withModifiers(handleClick, ["prevent", "stop"])
      }, [
        createVNode(_component_portal_slot, {
          slot: _ctx.$slots.default,
          "component-id": _ctx.$attrs["component-id"]
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.$t(props.label)), 1)
          ]),
          _: 1
        }, 8, ["slot", "component-id"])
      ]);
    };
  }
});
const _hoisted_1$c = { class: "ws-state-banner-inner-wrapper flex row" };
const _hoisted_2$8 = {
  key: 1,
  class: "ws-state-banner__content"
};
const _hoisted_3$5 = {
  key: 0,
  class: "ws-state-banner__title"
};
const _hoisted_4$1 = {
  key: 1,
  class: "ws-state-banner__text"
};
const _hoisted_5$1 = {
  key: 3,
  class: "ws-state-banner__closable justify-end"
};
const _hoisted_6 = {
  key: 0,
  class: "flex justify-end"
};
const _hoisted_7 = ["href"];
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "WsStateBanner",
  props: {
    size: { type: String, default: UI_SIZE.LARGE },
    type: { type: String, default: UI_VARIANT.DEFAULT },
    closable: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    button: { type: String, default: "" },
    headerIcon: { type: String, default: "" },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isClosed = ref(false);
    const getIcon = () => {
      switch (props.type) {
        case UI_VARIANT.NEUTRAL:
          return "success_full";
        case UI_VARIANT.SUCCESS:
          return "success_full";
        case UI_VARIANT.WARNING:
          return "alert_triangle_full";
        case UI_VARIANT.ERROR:
          return "alert_circle_full";
        case UI_VARIANT.DEFAULT:
        default:
          return "info_full";
      }
    };
    const closeBanner = () => {
      isClosed.value = true;
      emit("close");
    };
    const buttonLabel = computed(() => {
      return props.button ? JSON.parse(props.button).label : "";
    });
    const buttonUrl = computed(() => {
      return props.button ? JSON.parse(props.button).url : "";
    });
    const buttonIcon = computed(() => {
      return props.button ? JSON.parse(props.button).icon : "";
    });
    const hasTitleSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("title");
    });
    const hasTextSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("text");
    });
    const hasDefaultSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("default");
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return !isClosed.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref: "banner",
        class: normalizeClass(["ws-state-banner column", `${__props.size} ${__props.type}`])
      }, [
        createElementVNode("div", _hoisted_1$c, [
          props.icon ? (openBlock(), createBlock(WsIcon, {
            key: 0,
            name: getIcon(),
            size: 22,
            wrap: "",
            class: "ws-state-banner__icon"
          }, null, 8, ["name"])) : createCommentVNode("", true),
          !hasDefaultSlot.value ? (openBlock(), createElementBlock("div", _hoisted_2$8, [
            hasTitleSlot.value || props.title ? (openBlock(), createElementBlock("div", _hoisted_3$5, [
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots.title,
                "component-id": _ctx.$attrs["component-id"],
                name: "title"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(props.title), 1)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : createCommentVNode("", true),
            hasTextSlot.value || props.text ? (openBlock(), createElementBlock("p", _hoisted_4$1, [
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots.text,
                "component-id": _ctx.$attrs["component-id"],
                name: "text"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(props.text), 1)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : createCommentVNode("", true)
          ])) : (openBlock(), createBlock(_component_portal_slot, {
            key: 2,
            slot: _ctx.$slots.default,
            "component-id": _ctx.$attrs["component-id"],
            name: "default"
          }, null, 8, ["slot", "component-id"])),
          props.closable ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
            createElementVNode("button", {
              class: "ws-button self-start closable q-px-sm q-py-sm",
              onClick: closeBanner
            }, [
              createVNode(WsIcon, {
                name: "close",
                size: 14
              })
            ])
          ])) : createCommentVNode("", true)
        ]),
        props.button ? (openBlock(), createElementBlock("div", _hoisted_6, [
          createElementVNode("a", {
            class: "q-btn self-end",
            href: buttonUrl.value
          }, [
            createVNode(WsIcon, { name: buttonIcon.value }, null, 8, ["name"]),
            createTextVNode(" " + toDisplayString(buttonLabel.value), 1)
          ], 8, _hoisted_7)
        ])) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const WsStateBanner = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-d92ca275"]]);
var StepStatus = /* @__PURE__ */ ((StepStatus2) => {
  StepStatus2["PAST"] = "past";
  StepStatus2["PRESENT"] = "present";
  StepStatus2["FUTURE"] = "future";
  return StepStatus2;
})(StepStatus || {});
const WsTimelineStepEnum = {
  Status: StepStatus
};
const _hoisted_1$b = { class: "ws-timeline-step flex items-center q-pa-sm" };
const _hoisted_2$7 = { class: "ws-timeline-step__content" };
const _hoisted_3$4 = { class: "flex items-center" };
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "WsTimelineStep",
  props: {
    date: { type: String, default: "" },
    tooltip: { type: String, default: "" },
    description: { type: String, default: "" },
    status: { type: String, default: StepStatus.FUTURE },
    url: { type: String, default: "" }
  },
  setup(__props) {
    const past = computed(() => {
      return __props.status === StepStatus.PAST;
    });
    const present = computed(() => {
      return __props.status === StepStatus.PRESENT;
    });
    const future = computed(() => {
      return __props.status === StepStatus.FUTURE;
    });
    const icon = computed(() => {
      switch (__props.status) {
        case StepStatus.PAST:
          return { name: "success_full", color: "ws-gem-100" };
        case StepStatus.PRESENT:
          return { name: "circle", color: "ws-king-220" };
        case StepStatus.FUTURE:
        default:
          return { name: "circle", color: "ws-navy-70" };
      }
    });
    return (_ctx, _cache) => {
      const _component_ws_icon = resolveComponent("ws-icon");
      const _component_ws_tooltip = resolveComponent("ws-tooltip");
      return openBlock(), createElementBlock("div", _hoisted_1$b, [
        createElementVNode("div", _hoisted_2$7, [
          createElementVNode("div", _hoisted_3$4, [
            createVNode(_component_ws_icon, {
              name: icon.value.name,
              color: icon.value.color
            }, null, 8, ["name", "color"])
          ]),
          createElementVNode("div", null, [
            createElementVNode("div", null, toDisplayString(__props.date), 1),
            (openBlock(), createBlock(resolveDynamicComponent(__props.url ? "a" : "div"), mergeProps(__props.url ? { href: __props.url, target: "_blank" } : {}, {
              class: ["text-weight-bold", {
                "text-ws-navy-100": past.value || present.value,
                "text-ws-navy-70": future.value
              }]
            }), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.description), 1)
              ]),
              _: 1
            }, 16, ["class"]))
          ]),
          __props.tooltip ? (openBlock(), createBlock(_component_ws_tooltip, {
            key: 0,
            color: icon.value.color,
            icon: icon.value.name
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.tooltip), 1)
            ]),
            _: 1
          }, 8, ["color", "icon"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const _sfc_main$f = {};
const _hoisted_1$a = { class: "ws-timeline" };
function _sfc_render(_ctx, _cache) {
  const _component_portal_slot = resolveComponent("portal-slot");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    createVNode(_component_portal_slot, {
      slot: _ctx.$slots.default,
      "component-id": _ctx.$attrs["component-id"],
      name: "default"
    }, null, 8, ["slot", "component-id"])
  ]);
}
const WsTimeline = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render], ["__scopeId", "data-v-3c5d9d7b"]]);
const _hoisted_1$9 = { class: "expandable-text flex items-center no-wrap" };
const _hoisted_2$6 = ["innerHTML"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "WsExpandableText",
  props: {
    expandableLength: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const { content, expandableLength } = toRefs(props);
    const isExpanded = ref(false);
    const maxWidthStyle = computed(() => {
      return isExpanded.value ? "initial" : expandableLength.value + "ch";
    });
    const isExpandable = computed(() => {
      return typeof content.value === "string" && content.value.length > expandableLength.value;
    });
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value;
    };
    const sanitizedContent = computed(() => {
      const sanitized = typeof content.value === "string" ? xss(content.value) : content.value.toString();
      if (isExpandable.value && !isExpanded.value && expandableLength.value) {
        return sanitized.substring(0, expandableLength.value) + "&hellip;";
      }
      return sanitized;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$9, [
        createElementVNode("div", {
          style: normalizeStyle({ "max-width": maxWidthStyle.value }),
          class: normalizeClass(["paragraph", { "paragraph-expanded": isExpanded.value }]),
          innerHTML: unref(xss)(sanitizedContent.value)
        }, null, 14, _hoisted_2$6),
        isExpandable.value ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: "expandable-button remove-button-defaults",
          onClick: toggleExpand
        }, [
          createVNode(WsIcon, {
            name: "arrow_down",
            color: "primary",
            "data-test": "expandable-icon",
            class: normalizeClass({ "expanded": isExpanded.value })
          }, null, 8, ["class"])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const WsExpandableText = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-de29bfe6"]]);
const listenerRE = /^on[A-Z]/;
function useSplitAttrs() {
  const { attrs, vnode } = getCurrentInstance();
  const acc = {
    listeners: ref({}),
    attributes: ref({})
  };
  function update2() {
    const attributes = {};
    const listeners = {};
    for (const key in attrs) {
      if (key !== "class" && key !== "style" && listenerRE.test(key) === false) {
        attributes[key] = attrs[key];
      }
    }
    for (const key in vnode.props) {
      if (listenerRE.test(key) === true) {
        listeners[key] = vnode.props[key];
      }
    }
    acc.attributes.value = attributes;
    acc.listeners.value = listeners;
  }
  onBeforeUpdate(update2);
  update2();
  return acc;
}
const quasarKey = "_q_";
const formKey = "_q_fo_";
function useFormChild({ validate, resetValidation, requiresQForm }) {
  const $form = inject(formKey, false);
  if ($form !== false) {
    const { props, proxy } = getCurrentInstance();
    Object.assign(proxy, { validate, resetValidation });
    watch(() => props.disable, (val) => {
      if (val === true) {
        typeof resetValidation === "function" && resetValidation();
        $form.unbindComponent(proxy);
      } else {
        $form.bindComponent(proxy);
      }
    });
    onMounted(() => {
      props.disable !== true && $form.bindComponent(proxy);
    });
    onBeforeUnmount(() => {
      props.disable !== true && $form.unbindComponent(proxy);
    });
  } else if (requiresQForm === true) {
    console.error("Parent QForm not found on useFormChild()!");
  }
}
const hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
const testPattern = {
  date: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
  time: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
  fulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
  timeOrFulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (v) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
  hexColor: (v) => hex.test(v),
  hexaColor: (v) => hexa.test(v),
  hexOrHexaColor: (v) => hexOrHexa.test(v),
  rgbColor: (v) => rgb.test(v),
  rgbaColor: (v) => rgba.test(v),
  rgbOrRgbaColor: (v) => rgb.test(v) || rgba.test(v),
  hexOrRgbColor: (v) => hex.test(v) || rgb.test(v),
  hexaOrRgbaColor: (v) => hexa.test(v) || rgba.test(v),
  anyColor: (v) => hexOrHexa.test(v) || rgb.test(v) || rgba.test(v)
};
function debounce(fn, wait = 250, immediate) {
  let timer = null;
  function debounced() {
    const args = arguments;
    const later = () => {
      timer = null;
      if (immediate !== true) {
        fn.apply(this, args);
      }
    };
    if (timer !== null) {
      clearTimeout(timer);
    } else if (immediate === true) {
      fn.apply(this, args);
    }
    timer = setTimeout(later, wait);
  }
  debounced.cancel = () => {
    timer !== null && clearTimeout(timer);
  };
  return debounced;
}
const lazyRulesValues = [true, false, "ondemand"];
const useValidateProps = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    default: false,
    // statement unneeded but avoids future vue implementation changes
    validator: (v) => lazyRulesValues.includes(v)
  }
};
function useValidate(focused, innerLoading) {
  const { props, proxy } = getCurrentInstance();
  const innerError = ref(false);
  const innerErrorMessage = ref(null);
  const isDirtyModel = ref(false);
  useFormChild({ validate, resetValidation });
  let validateIndex = 0, unwatchRules;
  const hasRules = computed(
    () => props.rules !== void 0 && props.rules !== null && props.rules.length !== 0
  );
  const canDebounceValidate = computed(() => props.disable !== true && hasRules.value === true && innerLoading.value === false);
  const hasError = computed(
    () => props.error === true || innerError.value === true
  );
  const errorMessage = computed(() => typeof props.errorMessage === "string" && props.errorMessage.length !== 0 ? props.errorMessage : innerErrorMessage.value);
  watch(() => props.modelValue, () => {
    isDirtyModel.value = true;
    if (canDebounceValidate.value === true && props.lazyRules === false) {
      debouncedValidate();
    }
  });
  function onRulesChange() {
    if (props.lazyRules !== "ondemand" && canDebounceValidate.value === true && isDirtyModel.value === true) {
      debouncedValidate();
    }
  }
  watch(() => props.reactiveRules, (val) => {
    if (val === true) {
      if (unwatchRules === void 0) {
        unwatchRules = watch(() => props.rules, onRulesChange, { immediate: true, deep: true });
      }
    } else if (unwatchRules !== void 0) {
      unwatchRules();
      unwatchRules = void 0;
    }
  }, { immediate: true });
  watch(() => props.lazyRules, onRulesChange);
  watch(focused, (val) => {
    if (val === true) {
      isDirtyModel.value = true;
    } else if (canDebounceValidate.value === true && props.lazyRules !== "ondemand") {
      debouncedValidate();
    }
  });
  function resetValidation() {
    validateIndex++;
    innerLoading.value = false;
    isDirtyModel.value = false;
    innerError.value = false;
    innerErrorMessage.value = null;
    debouncedValidate.cancel();
  }
  function validate(val = props.modelValue) {
    if (props.disable === true || hasRules.value === false) {
      return true;
    }
    const index = ++validateIndex;
    const setDirty = innerLoading.value !== true ? () => {
      isDirtyModel.value = true;
    } : () => {
    };
    const update2 = (err, msg) => {
      err === true && setDirty();
      innerError.value = err;
      innerErrorMessage.value = msg || null;
      innerLoading.value = false;
    };
    const promises = [];
    for (let i = 0; i < props.rules.length; i++) {
      const rule = props.rules[i];
      let res;
      if (typeof rule === "function") {
        res = rule(val, testPattern);
      } else if (typeof rule === "string" && testPattern[rule] !== void 0) {
        res = testPattern[rule](val);
      }
      if (res === false || typeof res === "string") {
        update2(true, res);
        return false;
      } else if (res !== true && res !== void 0) {
        promises.push(res);
      }
    }
    if (promises.length === 0) {
      update2(false);
      return true;
    }
    innerLoading.value = true;
    return Promise.all(promises).then(
      (res) => {
        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          index === validateIndex && update2(false);
          return true;
        }
        const msg = res.find((r) => r === false || typeof r === "string");
        index === validateIndex && update2(msg !== void 0, msg);
        return msg === void 0;
      },
      (e) => {
        if (index === validateIndex) {
          console.error(e);
          update2(true);
        }
        return false;
      }
    );
  }
  const debouncedValidate = debounce(validate, 0);
  onBeforeUnmount(() => {
    unwatchRules !== void 0 && unwatchRules();
    debouncedValidate.cancel();
  });
  Object.assign(proxy, { resetValidation, validate });
  injectProp(proxy, "hasError", () => hasError.value);
  return {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    validate,
    resetValidation
  };
}
function fieldValueIsFilled(val) {
  return val !== void 0 && val !== null && ("" + val).length !== 0;
}
const useNonInputFieldProps = {
  ...useDarkProps,
  ...useValidateProps,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String
};
const useFieldProps = {
  ...useNonInputFieldProps,
  maxlength: [Number, String]
};
const useFieldEmits = ["update:modelValue", "clear", "focus", "blur"];
function useFieldState({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
  const { props, proxy } = getCurrentInstance();
  const isDark = useDark(props, proxy.$q);
  const targetUid = useId({
    required: requiredForAttr,
    getValue: () => props.for
  });
  return {
    requiredForAttr,
    changeEvent,
    tag: tagProp === true ? computed(() => props.tag) : { value: "label" },
    isDark,
    editable: computed(
      () => props.disable !== true && props.readonly !== true
    ),
    innerLoading: ref(false),
    focused: ref(false),
    hasPopupOpen: false,
    splitAttrs: useSplitAttrs(),
    targetUid,
    rootRef: ref(null),
    targetRef: ref(null),
    controlRef: ref(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function useField(state) {
  const { props, emit, slots, attrs, proxy } = getCurrentInstance();
  const { $q } = proxy;
  let focusoutTimer = null;
  if (state.hasValue === void 0) {
    state.hasValue = computed(() => fieldValueIsFilled(props.modelValue));
  }
  if (state.emitValue === void 0) {
    state.emitValue = (value) => {
      emit("update:modelValue", value);
    };
  }
  if (state.controlEvents === void 0) {
    state.controlEvents = {
      onFocusin: onControlFocusin,
      onFocusout: onControlFocusout
    };
  }
  Object.assign(state, {
    clearValue,
    onControlFocusin,
    onControlFocusout,
    focus
  });
  if (state.computedCounter === void 0) {
    state.computedCounter = computed(() => {
      if (props.counter !== false) {
        const len = typeof props.modelValue === "string" || typeof props.modelValue === "number" ? ("" + props.modelValue).length : Array.isArray(props.modelValue) === true ? props.modelValue.length : 0;
        const max = props.maxlength !== void 0 ? props.maxlength : props.maxValues;
        return len + (max !== void 0 ? " / " + max : "");
      }
    });
  }
  const {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    resetValidation
  } = useValidate(state.focused, state.innerLoading);
  const floatingLabel = state.floatingLabel !== void 0 ? computed(() => props.stackLabel === true || state.focused.value === true || state.floatingLabel.value === true) : computed(() => props.stackLabel === true || state.focused.value === true || state.hasValue.value === true);
  const shouldRenderBottom = computed(
    () => props.bottomSlots === true || props.hint !== void 0 || hasRules.value === true || props.counter === true || props.error !== null
  );
  const styleType = computed(() => {
    if (props.filled === true) {
      return "filled";
    }
    if (props.outlined === true) {
      return "outlined";
    }
    if (props.borderless === true) {
      return "borderless";
    }
    if (props.standout) {
      return "standout";
    }
    return "standard";
  });
  const classes = computed(
    () => `q-field row no-wrap items-start q-field--${styleType.value}` + (state.fieldClass !== void 0 ? ` ${state.fieldClass.value}` : "") + (props.rounded === true ? " q-field--rounded" : "") + (props.square === true ? " q-field--square" : "") + (floatingLabel.value === true ? " q-field--float" : "") + (hasLabel.value === true ? " q-field--labeled" : "") + (props.dense === true ? " q-field--dense" : "") + (props.itemAligned === true ? " q-field--item-aligned q-item-type" : "") + (state.isDark.value === true ? " q-field--dark" : "") + (state.getControl === void 0 ? " q-field--auto-height" : "") + (state.focused.value === true ? " q-field--focused" : "") + (hasError.value === true ? " q-field--error" : "") + (hasError.value === true || state.focused.value === true ? " q-field--highlighted" : "") + (props.hideBottomSpace !== true && shouldRenderBottom.value === true ? " q-field--with-bottom" : "") + (props.disable === true ? " q-field--disabled" : props.readonly === true ? " q-field--readonly" : "")
  );
  const contentClass = computed(
    () => "q-field__control relative-position row no-wrap" + (props.bgColor !== void 0 ? ` bg-${props.bgColor}` : "") + (hasError.value === true ? " text-negative" : typeof props.standout === "string" && props.standout.length !== 0 && state.focused.value === true ? ` ${props.standout}` : props.color !== void 0 ? ` text-${props.color}` : "")
  );
  const hasLabel = computed(
    () => props.labelSlot === true || props.label !== void 0
  );
  const labelClass = computed(
    () => "q-field__label no-pointer-events absolute ellipsis" + (props.labelColor !== void 0 && hasError.value !== true ? ` text-${props.labelColor}` : "")
  );
  const controlSlotScope = computed(() => ({
    id: state.targetUid.value,
    editable: state.editable.value,
    focused: state.focused.value,
    floatingLabel: floatingLabel.value,
    modelValue: props.modelValue,
    emitValue: state.emitValue
  }));
  const attributes = computed(() => {
    const acc = {};
    if (state.targetUid.value) {
      acc.for = state.targetUid.value;
    }
    if (props.disable === true) {
      acc["aria-disabled"] = "true";
    }
    return acc;
  });
  function focusHandler() {
    const el = document.activeElement;
    let target2 = state.targetRef !== void 0 && state.targetRef.value;
    if (target2 && (el === null || el.id !== state.targetUid.value)) {
      target2.hasAttribute("tabindex") === true || (target2 = target2.querySelector("[tabindex]"));
      if (target2 && target2 !== el) {
        target2.focus({ preventScroll: true });
      }
    }
  }
  function focus() {
    addFocusFn(focusHandler);
  }
  function blur() {
    removeFocusFn(focusHandler);
    const el = document.activeElement;
    if (el !== null && state.rootRef.value.contains(el)) {
      el.blur();
    }
  }
  function onControlFocusin(e) {
    if (focusoutTimer !== null) {
      clearTimeout(focusoutTimer);
      focusoutTimer = null;
    }
    if (state.editable.value === true && state.focused.value === false) {
      state.focused.value = true;
      emit("focus", e);
    }
  }
  function onControlFocusout(e, then) {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
    focusoutTimer = setTimeout(() => {
      focusoutTimer = null;
      if (document.hasFocus() === true && (state.hasPopupOpen === true || state.controlRef === void 0 || state.controlRef.value === null || state.controlRef.value.contains(document.activeElement) !== false)) {
        return;
      }
      if (state.focused.value === true) {
        state.focused.value = false;
        emit("blur", e);
      }
      then !== void 0 && then();
    });
  }
  function clearValue(e) {
    stopAndPrevent(e);
    if ($q.platform.is.mobile !== true) {
      const el = state.targetRef !== void 0 && state.targetRef.value || state.rootRef.value;
      el.focus();
    } else if (state.rootRef.value.contains(document.activeElement) === true) {
      document.activeElement.blur();
    }
    if (props.type === "file") {
      state.inputRef.value.value = null;
    }
    emit("update:modelValue", null);
    state.changeEvent === true && emit("change", null);
    emit("clear", props.modelValue);
    nextTick(() => {
      const isDirty = isDirtyModel.value;
      resetValidation();
      isDirtyModel.value = isDirty;
    });
  }
  function onClearableKeyup(evt) {
    [13, 32].includes(evt.keyCode) && clearValue(evt);
  }
  function getContent() {
    const node = [];
    slots.prepend !== void 0 && node.push(
      h("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: prevent
      }, slots.prepend())
    );
    node.push(
      h("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, getControlContainer())
    );
    hasError.value === true && props.noErrorIcon === false && node.push(
      getInnerAppendNode("error", [
        h(QIcon, { name: $q.iconSet.field.error, color: "negative" })
      ])
    );
    if (props.loading === true || state.innerLoading.value === true) {
      node.push(
        getInnerAppendNode(
          "inner-loading-append",
          slots.loading !== void 0 ? slots.loading() : [h(QSpinner, { color: props.color })]
        )
      );
    } else if (props.clearable === true && state.hasValue.value === true && state.editable.value === true) {
      node.push(
        getInnerAppendNode("inner-clearable-append", [
          h(QIcon, {
            class: "q-field__focusable-action",
            name: props.clearIcon || $q.iconSet.field.clear,
            tabindex: 0,
            role: "button",
            "aria-hidden": "false",
            "aria-label": $q.lang.label.clear,
            onKeyup: onClearableKeyup,
            onClick: clearValue
          })
        ])
      );
    }
    slots.append !== void 0 && node.push(
      h("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: prevent
      }, slots.append())
    );
    state.getInnerAppend !== void 0 && node.push(
      getInnerAppendNode("inner-append", state.getInnerAppend())
    );
    state.getControlChild !== void 0 && node.push(
      state.getControlChild()
    );
    return node;
  }
  function getControlContainer() {
    const node = [];
    props.prefix !== void 0 && props.prefix !== null && node.push(
      h("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, props.prefix)
    );
    if (state.getShadowControl !== void 0 && state.hasShadow.value === true) {
      node.push(
        state.getShadowControl()
      );
    }
    if (state.getControl !== void 0) {
      node.push(state.getControl());
    } else if (slots.rawControl !== void 0) {
      node.push(slots.rawControl());
    } else if (slots.control !== void 0) {
      node.push(
        h("div", {
          ref: state.targetRef,
          class: "q-field__native row",
          tabindex: -1,
          ...state.splitAttrs.attributes.value,
          "data-autofocus": props.autofocus === true || void 0
        }, slots.control(controlSlotScope.value))
      );
    }
    hasLabel.value === true && node.push(
      h("div", {
        class: labelClass.value
      }, hSlot(slots.label, props.label))
    );
    props.suffix !== void 0 && props.suffix !== null && node.push(
      h("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, props.suffix)
    );
    return node.concat(hSlot(slots.default));
  }
  function getBottom() {
    let msg, key;
    if (hasError.value === true) {
      if (errorMessage.value !== null) {
        msg = [h("div", { role: "alert" }, errorMessage.value)];
        key = `q--slot-error-${errorMessage.value}`;
      } else {
        msg = hSlot(slots.error);
        key = "q--slot-error";
      }
    } else if (props.hideHint !== true || state.focused.value === true) {
      if (props.hint !== void 0) {
        msg = [h("div", props.hint)];
        key = `q--slot-hint-${props.hint}`;
      } else {
        msg = hSlot(slots.hint);
        key = "q--slot-hint";
      }
    }
    const hasCounter = props.counter === true || slots.counter !== void 0;
    if (props.hideBottomSpace === true && hasCounter === false && msg === void 0) {
      return;
    }
    const main = h("div", {
      key,
      class: "q-field__messages col"
    }, msg);
    return h("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (props.hideBottomSpace !== true ? "animated" : "stale"),
      onClick: prevent
    }, [
      props.hideBottomSpace === true ? main : h(Transition, { name: "q-transition--field-message" }, () => main),
      hasCounter === true ? h("div", {
        class: "q-field__counter"
      }, slots.counter !== void 0 ? slots.counter() : state.computedCounter.value) : null
    ]);
  }
  function getInnerAppendNode(key, content) {
    return content === null ? null : h("div", {
      key,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, content);
  }
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    shouldActivate === true && props.autofocus === true && proxy.focus();
  });
  props.autofocus === true && onMounted(() => {
    proxy.focus();
  });
  onBeforeUnmount(() => {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
  });
  Object.assign(proxy, { focus, blur });
  return function renderField() {
    const labelAttrs = state.getControl === void 0 && slots.control === void 0 ? {
      ...state.splitAttrs.attributes.value,
      "data-autofocus": props.autofocus === true || void 0,
      ...attributes.value
    } : attributes.value;
    return h(state.tag.value, {
      ref: state.rootRef,
      class: [
        classes.value,
        attrs.class
      ],
      style: attrs.style,
      ...labelAttrs
    }, [
      slots.before !== void 0 ? h("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.before()) : null,
      h("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        h("div", {
          ref: state.controlRef,
          class: contentClass.value,
          tabindex: -1,
          ...state.controlEvents
        }, getContent()),
        shouldRenderBottom.value === true ? getBottom() : null
      ]),
      slots.after !== void 0 ? h("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.after()) : null
    ]);
  };
}
const NAMED_MASKS = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
};
const TOKENS = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleLowerCase() }
};
const KEYS = Object.keys(TOKENS);
KEYS.forEach((key) => {
  TOKENS[key].regex = new RegExp(TOKENS[key].pattern);
});
const tokenRegexMask = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + KEYS.join("") + "])|(.)", "g"), escRegex = /[.*+?^${}()|[\]\\]/g;
const MARKER = String.fromCharCode(1);
const useMaskProps = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function useMask(props, emit, emitValue, inputRef) {
  let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
  const hasMask = ref(null);
  const innerValue = ref(getInitialMaskedValue());
  function getIsTypeText() {
    return props.autogrow === true || ["textarea", "text", "search", "url", "tel", "password"].includes(props.type);
  }
  watch(() => props.type + props.autogrow, updateMaskInternals);
  watch(() => props.mask, (v) => {
    if (v !== void 0) {
      updateMaskValue(innerValue.value, true);
    } else {
      const val = unmaskValue(innerValue.value);
      updateMaskInternals();
      props.modelValue !== val && emit("update:modelValue", val);
    }
  });
  watch(() => props.fillMask + props.reverseFillMask, () => {
    hasMask.value === true && updateMaskValue(innerValue.value, true);
  });
  watch(() => props.unmaskedValue, () => {
    hasMask.value === true && updateMaskValue(innerValue.value);
  });
  function getInitialMaskedValue() {
    updateMaskInternals();
    if (hasMask.value === true) {
      const masked = maskValue(unmaskValue(props.modelValue));
      return props.fillMask !== false ? fillWithMask(masked) : masked;
    }
    return props.modelValue;
  }
  function getPaddedMaskMarked(size2) {
    if (size2 < maskMarked.length) {
      return maskMarked.slice(-size2);
    }
    let pad = "", localMaskMarked = maskMarked;
    const padPos = localMaskMarked.indexOf(MARKER);
    if (padPos !== -1) {
      for (let i = size2 - localMaskMarked.length; i > 0; i--) {
        pad += MARKER;
      }
      localMaskMarked = localMaskMarked.slice(0, padPos) + pad + localMaskMarked.slice(padPos);
    }
    return localMaskMarked;
  }
  function updateMaskInternals() {
    hasMask.value = props.mask !== void 0 && props.mask.length !== 0 && getIsTypeText();
    if (hasMask.value === false) {
      computedUnmask = void 0;
      maskMarked = "";
      maskReplaced = "";
      return;
    }
    const localComputedMask = NAMED_MASKS[props.mask] === void 0 ? props.mask : NAMED_MASKS[props.mask], fillChar = typeof props.fillMask === "string" && props.fillMask.length !== 0 ? props.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex, "\\$&"), unmask = [], extract = [], mask = [];
    let firstMatch = props.reverseFillMask === true, unmaskChar = "", negateChar = "";
    localComputedMask.replace(tokenRegexMask, (_, char1, esc, token, char2) => {
      if (token !== void 0) {
        const c = TOKENS[token];
        mask.push(c);
        negateChar = c.negate;
        if (firstMatch === true) {
          extract.push("(?:" + negateChar + "+)?(" + c.pattern + "+)?(?:" + negateChar + "+)?(" + c.pattern + "+)?");
          firstMatch = false;
        }
        extract.push("(?:" + negateChar + "+)?(" + c.pattern + ")?");
      } else if (esc !== void 0) {
        unmaskChar = "\\" + (esc === "\\" ? "" : esc);
        mask.push(esc);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      } else {
        const c = char1 !== void 0 ? char1 : char2;
        unmaskChar = c === "\\" ? "\\\\\\\\" : c.replace(escRegex, "\\\\$&");
        mask.push(c);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      }
    });
    const unmaskMatcher = new RegExp(
      "^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"
    ), extractLast = extract.length - 1, extractMatcher = extract.map((re, index) => {
      if (index === 0 && props.reverseFillMask === true) {
        return new RegExp("^" + fillCharEscaped + "*" + re);
      } else if (index === extractLast) {
        return new RegExp(
          "^" + re + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props.reverseFillMask === true ? "$" : fillCharEscaped + "*")
        );
      }
      return new RegExp("^" + re);
    });
    computedMask = mask;
    computedUnmask = (val) => {
      const unmaskMatch = unmaskMatcher.exec(props.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
      if (unmaskMatch !== null) {
        val = unmaskMatch.slice(1).join("");
      }
      const extractMatch = [], extractMatcherLength = extractMatcher.length;
      for (let i = 0, str = val; i < extractMatcherLength; i++) {
        const m = extractMatcher[i].exec(str);
        if (m === null) {
          break;
        }
        str = str.slice(m.shift().length);
        extractMatch.push(...m);
      }
      if (extractMatch.length !== 0) {
        return extractMatch.join("");
      }
      return val;
    };
    maskMarked = mask.map((v) => typeof v === "string" ? v : MARKER).join("");
    maskReplaced = maskMarked.split(MARKER).join(fillChar);
  }
  function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
    const inp = inputRef.value, end = inp.selectionEnd, endReverse = inp.value.length - end, unmasked = unmaskValue(rawVal);
    updateMaskInternalsFlag === true && updateMaskInternals();
    const preMasked = maskValue(unmasked), masked = props.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed = innerValue.value !== masked;
    inp.value !== masked && (inp.value = masked);
    changed === true && (innerValue.value = masked);
    document.activeElement === inp && nextTick(() => {
      if (masked === maskReplaced) {
        const cursor = props.reverseFillMask === true ? maskReplaced.length : 0;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (inputType === "insertFromPaste" && props.reverseFillMask !== true) {
        const maxEnd = inp.selectionEnd;
        let cursor = end - 1;
        for (let i = pastedTextStart; i <= cursor && i < maxEnd; i++) {
          if (maskMarked[i] !== MARKER) {
            cursor++;
          }
        }
        moveCursor.right(inp, cursor);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(inputType) !== -1) {
        const cursor = props.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (props.reverseFillMask === true) {
        if (changed === true) {
          const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
          if (cursor === 1 && end === 1) {
            inp.setSelectionRange(cursor, cursor, "forward");
          } else {
            moveCursor.rightReverse(inp, cursor);
          }
        } else {
          const cursor = masked.length - endReverse;
          inp.setSelectionRange(cursor, cursor, "backward");
        }
      } else {
        if (changed === true) {
          const cursor = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
          moveCursor.right(inp, cursor);
        } else {
          const cursor = end - 1;
          moveCursor.right(inp, cursor);
        }
      }
    });
    const val = props.unmaskedValue === true ? unmaskValue(masked) : masked;
    if (String(props.modelValue) !== val && (props.modelValue !== null || val !== "")) {
      emitValue(val, true);
    }
  }
  function moveCursorForPaste(inp, start, end) {
    const preMasked = maskValue(unmaskValue(inp.value));
    start = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
    pastedTextStart = start;
    inp.setSelectionRange(start, end, "forward");
  }
  const moveCursor = {
    left(inp, cursor) {
      const noMarkBefore = maskMarked.slice(cursor - 1).indexOf(MARKER) === -1;
      let i = Math.max(0, cursor - 1);
      for (; i >= 0; i--) {
        if (maskMarked[i] === MARKER) {
          cursor = i;
          noMarkBefore === true && cursor++;
          break;
        }
      }
      if (i < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) {
        return moveCursor.right(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    right(inp, cursor) {
      const limit = inp.value.length;
      let i = Math.min(limit, cursor + 1);
      for (; i <= limit; i++) {
        if (maskMarked[i] === MARKER) {
          cursor = i;
          break;
        } else if (maskMarked[i - 1] === MARKER) {
          cursor = i;
        }
      }
      if (i > limit && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) {
        return moveCursor.left(inp, limit);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    },
    leftReverse(inp, cursor) {
      const localMaskMarked = getPaddedMaskMarked(inp.value.length);
      let i = Math.max(0, cursor - 1);
      for (; i >= 0; i--) {
        if (localMaskMarked[i - 1] === MARKER) {
          cursor = i;
          break;
        } else if (localMaskMarked[i] === MARKER) {
          cursor = i;
          if (i === 0) {
            break;
          }
        }
      }
      if (i < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER) {
        return moveCursor.rightReverse(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    rightReverse(inp, cursor) {
      const limit = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit), noMarkBefore = localMaskMarked.slice(0, cursor + 1).indexOf(MARKER) === -1;
      let i = Math.min(limit, cursor + 1);
      for (; i <= limit; i++) {
        if (localMaskMarked[i - 1] === MARKER) {
          cursor = i;
          cursor > 0 && noMarkBefore === true && cursor--;
          break;
        }
      }
      if (i > limit && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER) {
        return moveCursor.leftReverse(inp, limit);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    }
  };
  function onMaskedClick(e) {
    emit("click", e);
    selectionAnchor = void 0;
  }
  function onMaskedKeydown(e) {
    emit("keydown", e);
    if (shouldIgnoreKey(e) === true || e.altKey === true) {
      return;
    }
    const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
    if (!e.shiftKey) {
      selectionAnchor = void 0;
    }
    if (e.keyCode === 37 || e.keyCode === 39) {
      if (e.shiftKey && selectionAnchor === void 0) {
        selectionAnchor = inp.selectionDirection === "forward" ? start : end;
      }
      const fn = moveCursor[(e.keyCode === 39 ? "right" : "left") + (props.reverseFillMask === true ? "Reverse" : "")];
      e.preventDefault();
      fn(inp, selectionAnchor === start ? end : start);
      if (e.shiftKey) {
        const cursor = inp.selectionStart;
        inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
      }
    } else if (e.keyCode === 8 && props.reverseFillMask !== true && start === end) {
      moveCursor.left(inp, start);
      inp.setSelectionRange(inp.selectionStart, end, "backward");
    } else if (e.keyCode === 46 && props.reverseFillMask === true && start === end) {
      moveCursor.rightReverse(inp, end);
      inp.setSelectionRange(start, inp.selectionEnd, "forward");
    }
  }
  function maskValue(val) {
    if (val === void 0 || val === null || val === "") {
      return "";
    }
    if (props.reverseFillMask === true) {
      return maskValueReverse(val);
    }
    const mask = computedMask;
    let valIndex = 0, output = "";
    for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
      const valChar = val[valIndex], maskDef = mask[maskIndex];
      if (typeof maskDef === "string") {
        output += maskDef;
        valChar === maskDef && valIndex++;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
        valIndex++;
      } else {
        return output;
      }
    }
    return output;
  }
  function maskValueReverse(val) {
    const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER);
    let valIndex = val.length - 1, output = "";
    for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--) {
      const maskDef = mask[maskIndex];
      let valChar = val[valIndex];
      if (typeof maskDef === "string") {
        output = maskDef + output;
        valChar === maskDef && valIndex--;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        do {
          output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
          valIndex--;
          valChar = val[valIndex];
        } while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
      } else {
        return output;
      }
    }
    return output;
  }
  function unmaskValue(val) {
    return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask("" + val) : val : computedUnmask(val);
  }
  function fillWithMask(val) {
    if (maskReplaced.length - val.length <= 0) {
      return val;
    }
    return props.reverseFillMask === true && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
  }
  return {
    innerValue,
    hasMask,
    moveCursorForPaste,
    updateMaskValue,
    onMaskedKeydown,
    onMaskedClick
  };
}
const useFormProps = {
  name: String
};
function useFormInputNameAttr(props) {
  return computed(() => props.name || props.for);
}
function useFileFormDomProps(props, typeGuard) {
  function getFormDomProps() {
    const model = props.modelValue;
    try {
      const dt = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      if (Object(model) === model) {
        ("length" in model ? Array.from(model) : [model]).forEach((file) => {
          dt.items.add(file);
        });
      }
      return {
        files: dt.files
      };
    } catch (e) {
      return {
        files: void 0
      };
    }
  }
  return computed(() => {
    if (props.type !== "file") {
      return;
    }
    return getFormDomProps();
  });
}
const isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
const isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
const isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
const isPlainText = /[a-z0-9_ -]$/i;
function useKeyComposition(onInput) {
  return function onComposition(e) {
    if (e.type === "compositionend" || e.type === "change") {
      if (e.target.qComposing !== true) return;
      e.target.qComposing = false;
      onInput(e);
    } else if (e.type === "compositionupdate" && e.target.qComposing !== true && typeof e.data === "string") {
      const isComposing = client.is.firefox === true ? isPlainText.test(e.data) === false : isJapanese.test(e.data) === true || isChinese.test(e.data) === true || isKorean.test(e.data) === true;
      if (isComposing === true) {
        e.target.qComposing = true;
      }
    }
  };
}
const QInput = createComponent({
  name: "QInput",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    ...useMaskProps,
    ...useFormProps,
    // override of useFieldProps > modelValue
    modelValue: [String, Number, FileList],
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(props, { emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const temp = {};
    let emitCachedValue = NaN, typedNumber, stopValueWatcher, emitTimer = null, emitValueFn;
    const inputRef = ref(null);
    const nameProp = useFormInputNameAttr(props);
    const {
      innerValue,
      hasMask,
      moveCursorForPaste,
      updateMaskValue,
      onMaskedKeydown,
      onMaskedClick
    } = useMask(props, emit, emitValue, inputRef);
    const formDomProps = useFileFormDomProps(
      props
    );
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const onComposition = useKeyComposition(onInput);
    const state = useFieldState({ changeEvent: true });
    const isTextarea = computed(
      () => props.type === "textarea" || props.autogrow === true
    );
    const isTypeText = computed(
      () => isTextarea.value === true || ["text", "search", "url", "tel", "password"].includes(props.type)
    );
    const onEvents = computed(() => {
      const evt = {
        ...state.splitAttrs.listeners.value,
        onInput,
        onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange,
        onBlur: onFinishEditing,
        onFocus: stop
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      if (hasMask.value === true) {
        evt.onKeydown = onMaskedKeydown;
        evt.onClick = onMaskedClick;
      }
      if (props.autogrow === true) {
        evt.onAnimationend = onAnimationend;
      }
      return evt;
    });
    const inputAttrs = computed(() => {
      const attrs2 = {
        tabindex: 0,
        "data-autofocus": props.autofocus === true || void 0,
        rows: props.type === "textarea" ? 6 : void 0,
        "aria-label": props.label,
        name: nameProp.value,
        ...state.splitAttrs.attributes.value,
        id: state.targetUid.value,
        maxlength: props.maxlength,
        disabled: props.disable === true,
        readonly: props.readonly === true
      };
      if (isTextarea.value === false) {
        attrs2.type = props.type;
      }
      if (props.autogrow === true) {
        attrs2.rows = 1;
      }
      return attrs2;
    });
    watch(() => props.type, () => {
      if (inputRef.value) {
        inputRef.value.value = props.modelValue;
      }
    });
    watch(() => props.modelValue, (v) => {
      if (hasMask.value === true) {
        if (stopValueWatcher === true) {
          stopValueWatcher = false;
          if (String(v) === emitCachedValue) {
            return;
          }
        }
        updateMaskValue(v);
      } else if (innerValue.value !== v) {
        innerValue.value = v;
        if (props.type === "number" && temp.hasOwnProperty("value") === true) {
          if (typedNumber === true) {
            typedNumber = false;
          } else {
            delete temp.value;
          }
        }
      }
      props.autogrow === true && nextTick(adjustHeight);
    });
    watch(() => props.autogrow, (val) => {
      if (val === true) {
        nextTick(adjustHeight);
      } else if (inputRef.value !== null && attrs.rows > 0) {
        inputRef.value.style.height = "auto";
      }
    });
    watch(() => props.dense, () => {
      props.autogrow === true && nextTick(adjustHeight);
    });
    function focus() {
      addFocusFn(() => {
        const el = document.activeElement;
        if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state.targetUid.value)) {
          inputRef.value.focus({ preventScroll: true });
        }
      });
    }
    function select() {
      inputRef.value !== null && inputRef.value.select();
    }
    function onPaste(e) {
      if (hasMask.value === true && props.reverseFillMask !== true) {
        const inp = e.target;
        moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }
      emit("paste", e);
    }
    function onInput(e) {
      if (!e || !e.target) {
        return;
      }
      if (props.type === "file") {
        emit("update:modelValue", e.target.files);
        return;
      }
      const val = e.target.value;
      if (e.target.qComposing === true) {
        temp.value = val;
        return;
      }
      if (hasMask.value === true) {
        updateMaskValue(val, false, e.inputType);
      } else {
        emitValue(val);
        if (isTypeText.value === true && e.target === document.activeElement) {
          const { selectionStart, selectionEnd } = e.target;
          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            nextTick(() => {
              if (e.target === document.activeElement && val.indexOf(e.target.value) === 0) {
                e.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      }
      props.autogrow === true && adjustHeight();
    }
    function onAnimationend(e) {
      emit("animationend", e);
      adjustHeight();
    }
    function emitValue(val, stopWatcher) {
      emitValueFn = () => {
        emitTimer = null;
        if (props.type !== "number" && temp.hasOwnProperty("value") === true) {
          delete temp.value;
        }
        if (props.modelValue !== val && emitCachedValue !== val) {
          emitCachedValue = val;
          stopWatcher === true && (stopValueWatcher = true);
          emit("update:modelValue", val);
          nextTick(() => {
            emitCachedValue === val && (emitCachedValue = NaN);
          });
        }
        emitValueFn = void 0;
      };
      if (props.type === "number") {
        typedNumber = true;
        temp.value = val;
      }
      if (props.debounce !== void 0) {
        emitTimer !== null && clearTimeout(emitTimer);
        temp.value = val;
        emitTimer = setTimeout(emitValueFn, props.debounce);
      } else {
        emitValueFn();
      }
    }
    function adjustHeight() {
      requestAnimationFrame(() => {
        const inp = inputRef.value;
        if (inp !== null) {
          const parentStyle = inp.parentNode.style;
          const { scrollTop } = inp;
          const { overflowY, maxHeight } = $q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
          const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
          changeOverflow === true && (inp.style.overflowY = "hidden");
          parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
          inp.style.height = "1px";
          inp.style.height = inp.scrollHeight + "px";
          changeOverflow === true && (inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden");
          parentStyle.marginBottom = "";
          inp.scrollTop = scrollTop;
        }
      });
    }
    function onChange(e) {
      onComposition(e);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      emit("change", e.target.value);
    }
    function onFinishEditing(e) {
      e !== void 0 && stop(e);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      typedNumber = false;
      stopValueWatcher = false;
      delete temp.value;
      props.type !== "file" && setTimeout(() => {
        if (inputRef.value !== null) {
          inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
        }
      });
    }
    function getCurValue() {
      return temp.hasOwnProperty("value") === true ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
    }
    onBeforeUnmount(() => {
      onFinishEditing();
    });
    onMounted(() => {
      props.autogrow === true && adjustHeight();
    });
    Object.assign(state, {
      innerValue,
      fieldClass: computed(
        () => `q-${isTextarea.value === true ? "textarea" : "input"}` + (props.autogrow === true ? " q-textarea--autogrow" : "")
      ),
      hasShadow: computed(
        () => props.type !== "file" && typeof props.shadowText === "string" && props.shadowText.length !== 0
      ),
      inputRef,
      emitValue,
      hasValue,
      floatingLabel: computed(
        () => hasValue.value === true && (props.type !== "number" || isNaN(innerValue.value) === false) || fieldValueIsFilled(props.displayValue)
      ),
      getControl: () => {
        return h(isTextarea.value === true ? "textarea" : "input", {
          ref: inputRef,
          class: [
            "q-field__native q-placeholder",
            props.inputClass
          ],
          style: props.inputStyle,
          ...inputAttrs.value,
          ...onEvents.value,
          ...props.type !== "file" ? { value: getCurValue() } : formDomProps.value
        });
      },
      getShadowControl: () => {
        return h("div", {
          class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value === true ? "" : " text-no-wrap")
        }, [
          h("span", { class: "invisible" }, getCurValue()),
          h("span", props.shadowText)
        ]);
      }
    });
    const renderFn = useField(state);
    Object.assign(proxy, {
      focus,
      select,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp(proxy, "nativeEl", () => inputRef.value);
    return renderFn;
  }
});
const _hoisted_1$8 = { key: 0 };
const lazyRules = false;
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "WsInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    dark: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "text"
    },
    optionalText: {
      type: String,
      default: ""
    },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const { isTheme: isTheme2 } = useTheming();
    const slots = useSlots();
    const props = __props;
    const emits = __emit;
    const qfield = ref(null);
    const onUpdate = (event) => {
      emits("update:modelValue", event);
    };
    const predefinedSlotNames = ["append"];
    const allSlotNames = computed(() => {
      const combinedSlots = [
        ...props.portalSlots,
        ...Object.keys(slots)
      ];
      return combinedSlots.filter((slotName) => !predefinedSlotNames.includes(slotName));
    });
    __expose({
      focus: () => {
        var _a;
        return (_a = qfield.value) == null ? void 0 : _a.focus();
      }
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createBlock(unref(QInput), {
        ref_key: "qfield",
        ref: qfield,
        class: normalizeClass(["ws-input ws-field", {
          responsive: __props.responsive,
          "ws-dark": __props.dark,
          "ws-has-value": __props.modelValue
        }]),
        error: props.error,
        standout: unref(isTheme2)(unref(Theme).ADMIN) ? void 0 : __props.dark ? "bg-dark text-white" : "bg-white ws-text-darker",
        "bg-color": unref(isTheme2)(unref(Theme).ADMIN) ? void 0 : __props.dark ? "dark" : "white",
        square: unref(isTheme2)(unref(Theme).ADMIN),
        outlined: "",
        "bottom-slots": "",
        "no-error-icon": "",
        type: __props.type,
        "lazy-rules": lazyRules,
        required: props.required,
        "model-value": props.modelValue,
        "onUpdate:modelValue": onUpdate
      }, createSlots({
        append: withCtx((scope) => [
          __props.optionalText && !__props.required ? (openBlock(), createElementBlock("div", _hoisted_1$8, toDisplayString(__props.optionalText), 1)) : createCommentVNode("", true),
          createVNode(_component_portal_slot, {
            slot: unref(slots).append,
            "component-id": _ctx.$attrs["component-id"],
            name: "append",
            scope
          }, null, 8, ["slot", "component-id", "scope"])
        ]),
        _: 2
      }, [
        renderList(allSlotNames.value, (slotName) => {
          return {
            name: slotName,
            fn: withCtx(() => [
              (openBlock(), createBlock(_component_portal_slot, {
                slot: unref(slots)[slotName],
                key: slotName,
                name: slotName,
                "component-id": _ctx.$attrs["component-id"]
              }, null, 8, ["slot", "name", "component-id"]))
            ])
          };
        })
      ]), 1032, ["class", "error", "standout", "bg-color", "square", "type", "required", "model-value"]);
    };
  }
});
const WsInput = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-7cdc9e16"]]);
const _hoisted_1$7 = { class: "ws-password-input ws-field" };
const _hoisted_2$5 = {
  key: 0,
  class: "password-toggle-visibility-wrapper"
};
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "WsPasswordInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    autocomplete: { type: String, default: "password" },
    hideIcon: { type: Boolean, default: false },
    expose: { type: Boolean },
    strength: { type: Boolean },
    strengthAbove: { type: Boolean },
    error: { type: Boolean }
  },
  emits: ["expose", "update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const exposed = ref(false);
    let exposeByClick = false;
    let touched = false;
    const emit = __emit;
    watch(() => props.expose, (expose) => {
      exposed.value = expose;
    });
    const onUpdate = (event) => {
      emit("update:modelValue", event);
    };
    function toggleExpose(isExposed) {
      {
        exposeByClick = !exposeByClick;
        exposed.value = exposeByClick;
      }
      emit("expose", exposed);
    }
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", _hoisted_1$7, [
        createVNode(WsInput, mergeProps({
          ref: "qfield",
          class: { append: !__props.hideIcon, exposed: exposed.value }
        }, _ctx.$attrs, {
          "data-test": "password-input",
          autocomplete: __props.autocomplete,
          type: exposed.value ? "text" : "password",
          spellcheck: "false",
          autocapitalize: "off",
          error: props.error,
          "model-value": props.modelValue,
          onBlur: _cache[1] || (_cache[1] = ($event) => {
            isRef(touched) ? touched.value = true : touched = true;
          }),
          "onUpdate:modelValue": onUpdate
        }), {
          append: withCtx(() => [
            props.modelValue && !__props.hideIcon ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
              createVNode(WsIcon, {
                name: exposed.value ? "hidden" : "view",
                class: "password-toggle-visibility",
                "data-test": "password-toggle-visibility",
                alt: "expose",
                onClick: _cache[0] || (_cache[0] = ($event) => toggleExpose())
              }, null, 8, ["name"]),
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots.default,
                "component-id": _ctx.$attrs["component-id"],
                name: "default"
              }, null, 8, ["slot", "component-id"])
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["class", "autocomplete", "type", "error", "model-value"])
      ]);
    };
  }
});
const WsPasswordInput = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["__scopeId", "data-v-360e4802"]]);
const defaultSizes = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
const QChip = createComponent({
  name: "QChip",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    modelValue: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "update:selected", "remove", "click"],
  setup(props, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = useDark(props, $q);
    const sizeStyle = useSize(props, defaultSizes);
    const hasLeftIcon = computed(() => props.selected === true || props.icon !== void 0);
    const leftIcon = computed(() => props.selected === true ? props.iconSelected || $q.iconSet.chip.selected : props.icon);
    const removeIcon = computed(() => props.iconRemove || $q.iconSet.chip.remove);
    const isClickable = computed(
      () => props.disable === false && (props.clickable === true || props.selected !== null)
    );
    const classes = computed(() => {
      const text = props.outline === true ? props.color || props.textColor : props.textColor;
      return "q-chip row inline no-wrap items-center" + (props.outline === false && props.color !== void 0 ? ` bg-${props.color}` : "") + (text ? ` text-${text} q-chip--colored` : "") + (props.disable === true ? " disabled" : "") + (props.dense === true ? " q-chip--dense" : "") + (props.outline === true ? " q-chip--outline" : "") + (props.selected === true ? " q-chip--selected" : "") + (isClickable.value === true ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props.square === true ? " q-chip--square" : "") + (isDark.value === true ? " q-chip--dark q-dark" : "");
    });
    const attributes = computed(() => {
      const chip = props.disable === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: props.tabindex || 0 };
      const remove = {
        ...chip,
        role: "button",
        "aria-hidden": "false",
        "aria-label": props.removeAriaLabel || $q.lang.label.remove
      };
      return { chip, remove };
    });
    function onKeyup2(e) {
      e.keyCode === 13 && onClick(e);
    }
    function onClick(e) {
      if (!props.disable) {
        emit("update:selected", !props.selected);
        emit("click", e);
      }
    }
    function onRemove(e) {
      if (e.keyCode === void 0 || e.keyCode === 13) {
        stopAndPrevent(e);
        if (props.disable === false) {
          emit("update:modelValue", false);
          emit("remove");
        }
      }
    }
    function getContent() {
      const child = [];
      isClickable.value === true && child.push(
        h("div", { class: "q-focus-helper" })
      );
      hasLeftIcon.value === true && child.push(
        h(QIcon, {
          class: "q-chip__icon q-chip__icon--left",
          name: leftIcon.value
        })
      );
      const label = props.label !== void 0 ? [h("div", { class: "ellipsis" }, [props.label])] : void 0;
      child.push(
        h("div", {
          class: "q-chip__content col row no-wrap items-center q-anchor--skip"
        }, hMergeSlotSafely(slots.default, label))
      );
      props.iconRight && child.push(
        h(QIcon, {
          class: "q-chip__icon q-chip__icon--right",
          name: props.iconRight
        })
      );
      props.removable === true && child.push(
        h(QIcon, {
          class: "q-chip__icon q-chip__icon--remove cursor-pointer",
          name: removeIcon.value,
          ...attributes.value.remove,
          onClick: onRemove,
          onKeyup: onRemove
        })
      );
      return child;
    }
    return () => {
      if (props.modelValue === false) return;
      const data = {
        class: classes.value,
        style: sizeStyle.value
      };
      isClickable.value === true && Object.assign(
        data,
        attributes.value.chip,
        { onClick, onKeyup: onKeyup2 }
      );
      return hDir(
        "div",
        data,
        getContent(),
        "ripple",
        props.ripple !== false && props.disable !== true,
        () => [[Ripple, props.ripple]]
      );
    };
  }
});
const QField = createComponent({
  name: "QField",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    tag: {
      type: String,
      default: "label"
    }
  },
  emits: useFieldEmits,
  setup() {
    return useField(
      useFieldState({ tagProp: true })
    );
  }
});
const getTrue = () => true;
function filterInvalidPath(path) {
  return typeof path === "string" && path !== "" && path !== "/" && path !== "#/";
}
function normalizeExitPath(path) {
  path.startsWith("#") === true && (path = path.substring(1));
  path.startsWith("/") === false && (path = "/" + path);
  path.endsWith("/") === true && (path = path.substring(0, path.length - 1));
  return "#" + path;
}
function getShouldExitFn(cfg) {
  if (cfg.backButtonExit === false) {
    return () => false;
  }
  if (cfg.backButtonExit === "*") {
    return getTrue;
  }
  const exitPaths = ["#/"];
  Array.isArray(cfg.backButtonExit) === true && exitPaths.push(
    ...cfg.backButtonExit.filter(filterInvalidPath).map(normalizeExitPath)
  );
  return () => exitPaths.includes(window.location.hash);
}
const History = {
  __history: [],
  add: noop,
  remove: noop,
  install({ $q }) {
    if (this.__installed === true) return;
    const { cordova, capacitor } = client.is;
    if (cordova !== true && capacitor !== true) {
      return;
    }
    const qConf = $q.config[cordova === true ? "cordova" : "capacitor"];
    if (qConf !== void 0 && qConf.backButton === false) {
      return;
    }
    if (
      // if we're on Capacitor mode
      capacitor === true && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)
    ) {
      return;
    }
    this.add = (entry) => {
      if (entry.condition === void 0) {
        entry.condition = getTrue;
      }
      this.__history.push(entry);
    };
    this.remove = (entry) => {
      const index = this.__history.indexOf(entry);
      if (index >= 0) {
        this.__history.splice(index, 1);
      }
    };
    const shouldExit = getShouldExitFn(
      Object.assign(
        { backButtonExit: true },
        qConf
      )
    );
    const backHandler = () => {
      if (this.__history.length) {
        const entry = this.__history[this.__history.length - 1];
        if (entry.condition() === true) {
          this.__history.pop();
          entry.handler();
        }
      } else if (shouldExit() === true) {
        navigator.app.exitApp();
      } else {
        window.history.back();
      }
    };
    if (cordova === true) {
      document.addEventListener("deviceready", () => {
        document.addEventListener("backbutton", backHandler, false);
      });
    } else {
      window.Capacitor.Plugins.App.addListener("backButton", backHandler);
    }
  }
};
function useHistory(showing, hide, hideOnRouteChange) {
  let historyEntry;
  function removeFromHistory() {
    if (historyEntry !== void 0) {
      History.remove(historyEntry);
      historyEntry = void 0;
    }
  }
  onBeforeUnmount(() => {
    showing.value === true && removeFromHistory();
  });
  return {
    removeFromHistory,
    addToHistory() {
      historyEntry = {
        condition: () => hideOnRouteChange.value === true,
        handler: hide
      };
      History.add(historyEntry);
    }
  };
}
let registered = 0, scrollPositionX, scrollPositionY, maxScrollTop, vpPendingUpdate = false, bodyLeft, bodyTop, href, closeTimer = null;
function onWheel(e) {
  if (shouldPreventScroll(e)) {
    stopAndPrevent(e);
  }
}
function shouldPreventScroll(e) {
  if (e.target === document.body || e.target.classList.contains("q-layout__backdrop")) {
    return true;
  }
  const path = getEventPath(e), shift = e.shiftKey && !e.deltaX, scrollY = !shift && Math.abs(e.deltaX) <= Math.abs(e.deltaY), delta = shift || scrollY ? e.deltaY : e.deltaX;
  for (let index = 0; index < path.length; index++) {
    const el = path[index];
    if (hasScrollbar(el, scrollY)) {
      return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
  }
  return true;
}
function onAppleScroll(e) {
  if (e.target === document) {
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
  }
}
function onAppleResize(evt) {
  if (vpPendingUpdate === true) {
    return;
  }
  vpPendingUpdate = true;
  requestAnimationFrame(() => {
    vpPendingUpdate = false;
    const { height } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
    if (maxScrollTop === void 0 || height !== window.innerHeight) {
      maxScrollTop = clientHeight - height;
      document.scrollingElement.scrollTop = scrollTop;
    }
    if (scrollTop > maxScrollTop) {
      document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
    }
  });
}
function apply(action) {
  const body = document.body, hasViewport = window.visualViewport !== void 0;
  if (action === "add") {
    const { overflowY, overflowX } = window.getComputedStyle(body);
    scrollPositionX = getHorizontalScrollPosition(window);
    scrollPositionY = getVerticalScrollPosition(window);
    bodyLeft = body.style.left;
    bodyTop = body.style.top;
    href = window.location.href;
    body.style.left = `-${scrollPositionX}px`;
    body.style.top = `-${scrollPositionY}px`;
    if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) {
      body.classList.add("q-body--force-scrollbar-x");
    }
    if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) {
      body.classList.add("q-body--force-scrollbar-y");
    }
    body.classList.add("q-body--prevent-scroll");
    document.qScrollPrevented = true;
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.scrollTo(0, 0);
        window.visualViewport.addEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.addEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
        window.scrollTo(0, 0);
      } else {
        window.addEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
  }
  if (client.is.desktop === true && client.is.mac === true) {
    window[`${action}EventListener`]("wheel", onWheel, listenOpts.notPassive);
  }
  if (action === "remove") {
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.visualViewport.removeEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.removeEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
      } else {
        window.removeEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
    body.classList.remove("q-body--prevent-scroll");
    body.classList.remove("q-body--force-scrollbar-x");
    body.classList.remove("q-body--force-scrollbar-y");
    document.qScrollPrevented = false;
    body.style.left = bodyLeft;
    body.style.top = bodyTop;
    if (window.location.href === href) {
      window.scrollTo(scrollPositionX, scrollPositionY);
    }
    maxScrollTop = void 0;
  }
}
function preventScroll(state) {
  let action = "add";
  if (state === true) {
    registered++;
    if (closeTimer !== null) {
      clearTimeout(closeTimer);
      closeTimer = null;
      return;
    }
    if (registered > 1) {
      return;
    }
  } else {
    if (registered === 0) {
      return;
    }
    registered--;
    if (registered > 0) {
      return;
    }
    action = "remove";
    if (client.is.ios === true && client.is.nativeMobile === true) {
      closeTimer !== null && clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        apply(action);
        closeTimer = null;
      }, 100);
      return;
    }
  }
  apply(action);
}
function usePreventScroll() {
  let currentState;
  return {
    preventBodyScroll(state) {
      if (state !== currentState && (currentState !== void 0 || state === true)) {
        currentState = state;
        preventScroll(state);
      }
    }
  };
}
let maximizedModals = 0;
const positionClass = {
  standard: "fixed-full flex-center",
  top: "fixed-top justify-center",
  bottom: "fixed-bottom justify-center",
  right: "fixed-right items-center",
  left: "fixed-left items-center"
};
const defaultTransitions = {
  standard: ["scale", "scale"],
  top: ["slide-down", "slide-up"],
  bottom: ["slide-up", "slide-down"],
  right: ["slide-left", "slide-right"],
  left: ["slide-right", "slide-left"]
};
const QDialog = createComponent({
  name: "QDialog",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps,
    ...useTransitionProps,
    transitionShow: String,
    // override useTransitionProps
    transitionHide: String,
    // override useTransitionProps
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    backdropFilter: String,
    position: {
      type: String,
      default: "standard",
      validator: (val) => ["standard", "top", "bottom", "left", "right"].includes(val)
    }
  },
  emits: [
    ...useModelToggleEmits,
    "shake",
    "click",
    "escapeKey"
  ],
  setup(props, { slots, emit, attrs }) {
    const vm = getCurrentInstance();
    const innerRef = ref(null);
    const showing = ref(false);
    const animating = ref(false);
    let shakeTimeout = null, refocusTarget = null, isMaximized, avoidAutoClose;
    const hideOnRouteChange = computed(
      () => props.persistent !== true && props.noRouteDismiss !== true && props.seamless !== true
    );
    const { preventBodyScroll } = usePreventScroll();
    const { registerTimeout } = useTimeout();
    const { registerTick, removeTick } = useTick();
    const { transitionProps, transitionStyle } = useTransition(
      props,
      () => defaultTransitions[props.position][0],
      () => defaultTransitions[props.position][1]
    );
    const backdropStyle = computed(() => transitionStyle.value + (props.backdropFilter !== void 0 ? `;backdrop-filter:${props.backdropFilter};-webkit-backdrop-filter:${props.backdropFilter}` : ""));
    const { showPortal, hidePortal, portalIsAccessible, renderPortal } = usePortal(
      vm,
      innerRef,
      renderPortalContent,
      "dialog"
    );
    const { hide } = useModelToggle({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide,
      processOnMount: true
    });
    const { addToHistory, removeFromHistory } = useHistory(showing, hide, hideOnRouteChange);
    const classes = computed(
      () => `q-dialog__inner flex no-pointer-events q-dialog__inner--${props.maximized === true ? "maximized" : "minimized"} q-dialog__inner--${props.position} ${positionClass[props.position]}` + (animating.value === true ? " q-dialog__inner--animating" : "") + (props.fullWidth === true ? " q-dialog__inner--fullwidth" : "") + (props.fullHeight === true ? " q-dialog__inner--fullheight" : "") + (props.square === true ? " q-dialog__inner--square" : "")
    );
    const useBackdrop = computed(() => showing.value === true && props.seamless !== true);
    const onEvents = computed(() => props.autoClose === true ? { onClick: onAutoClose } : {});
    const rootClasses = computed(() => [
      `q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value === true ? "modal" : "seamless"}`,
      attrs.class
    ]);
    watch(() => props.maximized, (state) => {
      showing.value === true && updateMaximized(state);
    });
    watch(useBackdrop, (val) => {
      preventBodyScroll(val);
      if (val === true) {
        addFocusout(onFocusChange);
        addEscapeKey(onEscapeKey);
      } else {
        removeFocusout(onFocusChange);
        removeEscapeKey(onEscapeKey);
      }
    });
    function handleShow(evt) {
      addToHistory();
      refocusTarget = props.noRefocus === false && document.activeElement !== null ? document.activeElement : null;
      updateMaximized(props.maximized);
      showPortal();
      animating.value = true;
      if (props.noFocus !== true) {
        document.activeElement !== null && document.activeElement.blur();
        registerTick(focus);
      } else {
        removeTick();
      }
      registerTimeout(() => {
        if (vm.proxy.$q.platform.is.ios === true) {
          if (props.seamless !== true && document.activeElement) {
            const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
            if (top > 0 && bottom > height / 2) {
              document.scrollingElement.scrollTop = Math.min(
                document.scrollingElement.scrollHeight - height,
                bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height / 2)
              );
            }
            document.activeElement.scrollIntoView();
          }
          avoidAutoClose = true;
          innerRef.value.click();
          avoidAutoClose = false;
        }
        showPortal(true);
        animating.value = false;
        emit("show", evt);
      }, props.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      removeFromHistory();
      cleanup(true);
      animating.value = true;
      hidePortal();
      if (refocusTarget !== null) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        animating.value = false;
        emit("hide", evt);
      }, props.transitionDuration);
    }
    function focus(selector) {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node === null) return;
        if (selector !== void 0) {
          const target2 = node.querySelector(selector);
          if (target2 !== null) {
            target2.focus({ preventScroll: true });
            return;
          }
        }
        if (node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function shake(focusTarget) {
      if (focusTarget && typeof focusTarget.focus === "function") {
        focusTarget.focus({ preventScroll: true });
      } else {
        focus();
      }
      emit("shake");
      const node = innerRef.value;
      if (node !== null) {
        node.classList.remove("q-animate--scale");
        node.classList.add("q-animate--scale");
        shakeTimeout !== null && clearTimeout(shakeTimeout);
        shakeTimeout = setTimeout(() => {
          shakeTimeout = null;
          if (innerRef.value !== null) {
            node.classList.remove("q-animate--scale");
            focus();
          }
        }, 170);
      }
    }
    function onEscapeKey() {
      if (props.seamless !== true) {
        if (props.persistent === true || props.noEscDismiss === true) {
          props.maximized !== true && props.noShake !== true && shake();
        } else {
          emit("escapeKey");
          hide();
        }
      }
    }
    function cleanup(hiding) {
      if (shakeTimeout !== null) {
        clearTimeout(shakeTimeout);
        shakeTimeout = null;
      }
      if (hiding === true || showing.value === true) {
        updateMaximized(false);
        if (props.seamless !== true) {
          preventBodyScroll(false);
          removeFocusout(onFocusChange);
          removeEscapeKey(onEscapeKey);
        }
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function updateMaximized(active) {
      if (active === true) {
        if (isMaximized !== true) {
          maximizedModals < 1 && document.body.classList.add("q-body--dialog");
          maximizedModals++;
          isMaximized = true;
        }
      } else if (isMaximized === true) {
        if (maximizedModals < 2) {
          document.body.classList.remove("q-body--dialog");
        }
        maximizedModals--;
        isMaximized = false;
      }
    }
    function onAutoClose(e) {
      if (avoidAutoClose !== true) {
        hide(e);
        emit("click", e);
      }
    }
    function onBackdropClick(e) {
      if (props.persistent !== true && props.noBackdropDismiss !== true) {
        hide(e);
      } else if (props.noShake !== true) {
        shake();
      }
    }
    function onFocusChange(evt) {
      if (props.allowFocusOutside !== true && portalIsAccessible.value === true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus('[tabindex]:not([tabindex="-1"])');
      }
    }
    Object.assign(vm.proxy, {
      // expose public methods
      focus,
      shake,
      // private but needed by QSelect
      __updateRefocusTarget(target2) {
        refocusTarget = target2 || null;
      }
    });
    onBeforeUnmount(cleanup);
    function renderPortalContent() {
      return h("div", {
        role: "dialog",
        "aria-modal": useBackdrop.value === true ? "true" : "false",
        ...attrs,
        class: rootClasses.value
      }, [
        h(Transition, {
          name: "q-transition--fade",
          appear: true
        }, () => useBackdrop.value === true ? h("div", {
          class: "q-dialog__backdrop fixed-full",
          style: backdropStyle.value,
          "aria-hidden": "true",
          tabindex: -1,
          onClick: onBackdropClick
        }) : null),
        h(
          Transition,
          transitionProps.value,
          () => showing.value === true ? h("div", {
            ref: innerRef,
            class: classes.value,
            style: transitionStyle.value,
            tabindex: -1,
            ...onEvents.value
          }, hSlot(slots.default)) : null
        )
      ]);
    }
    return renderPortal;
  }
});
let rtlHasScrollBug = false;
{
  const scroller = document.createElement("div");
  scroller.setAttribute("dir", "rtl");
  Object.assign(scroller.style, {
    width: "1px",
    height: "1px",
    overflow: "auto"
  });
  const spacer = document.createElement("div");
  Object.assign(spacer.style, {
    width: "1000px",
    height: "1px"
  });
  document.body.appendChild(scroller);
  scroller.appendChild(spacer);
  scroller.scrollLeft = -1e3;
  rtlHasScrollBug = scroller.scrollLeft >= 0;
  scroller.remove();
}
const aggBucketSize = 1e3;
const scrollToEdges = [
  "start",
  "center",
  "end",
  "start-force",
  "center-force",
  "end-force"
];
const filterProto = Array.prototype.filter;
const setOverflowAnchor = window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop : function(contentEl, index) {
  if (contentEl === null) {
    return;
  }
  if (contentEl._qOverflowAnimationFrame !== void 0) {
    cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
  }
  contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (contentEl === null) {
      return;
    }
    contentEl._qOverflowAnimationFrame = void 0;
    const children = contentEl.children || [];
    filterProto.call(children, (el2) => el2.dataset && el2.dataset.qVsAnchor !== void 0).forEach((el2) => {
      delete el2.dataset.qVsAnchor;
    });
    const el = children[index];
    if (el && el.dataset) {
      el.dataset.qVsAnchor = "";
    }
  });
};
function sumFn(acc, h2) {
  return acc + h2;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal === true ? "offsetWidth" : "offsetHeight", details = {
    scrollStart: 0,
    scrollViewSize: -stickyStart - stickyEnd,
    scrollMaxSize: 0,
    offsetStart: -stickyStart,
    offsetEnd: -stickyEnd
  };
  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += document.documentElement.clientWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }
    details.scrollMaxSize = parentCalc.scrollWidth;
    if (rtl === true) {
      details.scrollStart = (rtlHasScrollBug === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += document.documentElement.clientHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }
    details.scrollMaxSize = parentCalc.scrollHeight;
  }
  if (beforeRef !== null) {
    for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }
  if (afterRef !== null) {
    for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetEnd += el[propElSize];
      }
    }
  }
  if (child !== parent) {
    const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }
    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }
  return details;
}
function setScroll(parent, scroll, horizontal, rtl) {
  if (scroll === "end") {
    scroll = (parent === window ? document.body : parent)[horizontal === true ? "scrollWidth" : "scrollHeight"];
  }
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (rtlHasScrollBug === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
      }
      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (rtlHasScrollBug === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }
    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}
function sumSize(sizeAgg, size2, from, to) {
  if (from >= to) {
    return 0;
  }
  const lastTo = size2.length, fromAgg = Math.floor(from / aggBucketSize), toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
  let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
  if (from % aggBucketSize !== 0) {
    total -= size2.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
  }
  if (to % aggBucketSize !== 0 && to !== lastTo) {
    total -= size2.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
  }
  return total;
}
const commonVirtScrollProps = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: 10
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
const useVirtualScrollProps = {
  virtualScrollHorizontal: Boolean,
  onVirtualScroll: Function,
  ...commonVirtScrollProps
};
function useVirtualScroll({
  virtualScrollLength,
  getVirtualScrollTarget,
  getVirtualScrollEl,
  virtualScrollItemSizeComputed
  // optional
}) {
  const vm = getCurrentInstance();
  const { props, emit, proxy } = vm;
  const { $q } = proxy;
  let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
  const virtualScrollPaddingBefore = ref(0);
  const virtualScrollPaddingAfter = ref(0);
  const virtualScrollSliceSizeComputed = ref({});
  const beforeRef = ref(null);
  const afterRef = ref(null);
  const contentRef = ref(null);
  const virtualScrollSliceRange = ref({ from: 0, to: 0 });
  const colspanAttr = computed(() => props.tableColspan !== void 0 ? props.tableColspan : 100);
  if (virtualScrollItemSizeComputed === void 0) {
    virtualScrollItemSizeComputed = computed(() => props.virtualScrollItemSize);
  }
  const needsReset = computed(() => virtualScrollItemSizeComputed.value + ";" + props.virtualScrollHorizontal);
  const needsSliceRecalc = computed(
    () => needsReset.value + ";" + props.virtualScrollSliceRatioBefore + ";" + props.virtualScrollSliceRatioAfter
  );
  watch(needsSliceRecalc, () => {
    setVirtualScrollSize();
  });
  watch(needsReset, reset);
  function reset() {
    localResetVirtualScroll(prevToIndex, true);
  }
  function refresh(toIndex) {
    localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
  }
  function scrollTo(toIndex, edge) {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props.virtualScrollHorizontal,
      $q.lang.rtl,
      props.virtualScrollStickySizeStart,
      props.virtualScrollStickySizeEnd
    );
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      Math.min(virtualScrollLength.value - 1, Math.max(0, parseInt(toIndex, 10) || 0)),
      0,
      scrollToEdges.indexOf(edge) !== -1 ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start"
    );
  }
  function localOnVirtualScrollEvt() {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props.virtualScrollHorizontal,
      $q.lang.rtl,
      props.virtualScrollStickySizeStart,
      props.virtualScrollStickySizeEnd
    ), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
    if (prevScrollStart === scrollDetails.scrollStart) {
      return;
    }
    if (scrollDetails.scrollMaxSize <= 0) {
      setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
      return;
    }
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
    const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
    if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
      setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        listLastIndex,
        scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn, 0)
      );
      return;
    }
    let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset = listOffset;
    if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
      listOffset -= virtualScrollPaddingBefore.value;
      toIndex = virtualScrollSliceRange.value.from;
      offset = listOffset;
    } else {
      for (let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
        listOffset -= virtualScrollSizesAgg[j];
        toIndex += aggBucketSize;
      }
    }
    while (listOffset > 0 && toIndex < listLastIndex) {
      listOffset -= virtualScrollSizes[toIndex];
      if (listOffset > -scrollDetails.scrollViewSize) {
        toIndex++;
        offset = listOffset;
      } else {
        offset = virtualScrollSizes[toIndex] + listOffset;
      }
    }
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      toIndex,
      offset
    );
  }
  function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset, align) {
    const alignForce = typeof align === "string" && align.indexOf("-force") !== -1;
    const alignEnd = alignForce === true ? align.replace("-force", "") : align;
    const alignRange = alignEnd !== void 0 ? alignEnd : "start";
    let from = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to = from + virtualScrollSliceSizeComputed.value.total;
    if (to > virtualScrollLength.value) {
      to = virtualScrollLength.value;
      from = Math.max(0, to - virtualScrollSliceSizeComputed.value.total);
    }
    prevScrollStart = scrollDetails.scrollStart;
    const rangeChanged = from !== virtualScrollSliceRange.value.from || to !== virtualScrollSliceRange.value.to;
    if (rangeChanged === false && alignEnd === void 0) {
      emitScroll(toIndex);
      return;
    }
    const { activeElement } = document;
    const contentEl = contentRef.value;
    if (rangeChanged === true && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
      contentEl.addEventListener("focusout", onBlurRefocusFn);
      setTimeout(() => {
        contentEl !== null && contentEl.removeEventListener("focusout", onBlurRefocusFn);
      });
    }
    setOverflowAnchor(contentEl, toIndex - from);
    const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;
    if (rangeChanged === true) {
      const tempTo = to >= virtualScrollSliceRange.value.from && from <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to;
      virtualScrollSliceRange.value = { from, to: tempTo };
      virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, from);
      virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
      requestAnimationFrame(() => {
        if (virtualScrollSliceRange.value.to !== to && prevScrollStart === scrollDetails.scrollStart) {
          virtualScrollSliceRange.value = { from: virtualScrollSliceRange.value.from, to };
          virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
        }
      });
    }
    requestAnimationFrame(() => {
      if (prevScrollStart !== scrollDetails.scrollStart) {
        return;
      }
      if (rangeChanged === true) {
        updateVirtualScrollSizes(from);
      }
      const sizeAfter = virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
      let scrollPosition = posStart + offset;
      if (alignEnd !== void 0) {
        const sizeDiff = sizeAfter - sizeBefore;
        const scrollStart = scrollDetails.scrollStart + sizeDiff;
        scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
      }
      prevScrollStart = scrollPosition;
      setScroll(
        scrollEl,
        scrollPosition,
        props.virtualScrollHorizontal,
        $q.lang.rtl
      );
      emitScroll(toIndex);
    });
  }
  function updateVirtualScrollSizes(from) {
    const contentEl = contentRef.value;
    if (contentEl) {
      const children = filterProto.call(
        contentEl.children,
        (el) => el.classList && el.classList.contains("q-virtual-scroll--skip") === false
      ), childrenLength = children.length, sizeFn = props.virtualScrollHorizontal === true ? (el) => el.getBoundingClientRect().width : (el) => el.offsetHeight;
      let index = from, size2, diff;
      for (let i = 0; i < childrenLength; ) {
        size2 = sizeFn(children[i]);
        i++;
        while (i < childrenLength && children[i].classList.contains("q-virtual-scroll--with-prev") === true) {
          size2 += sizeFn(children[i]);
          i++;
        }
        diff = size2 - virtualScrollSizes[index];
        if (diff !== 0) {
          virtualScrollSizes[index] += diff;
          virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
        }
        index++;
      }
    }
  }
  function onBlurRefocusFn() {
    contentRef.value !== null && contentRef.value !== void 0 && contentRef.value.focus();
  }
  function localResetVirtualScroll(toIndex, fullReset) {
    const defaultSize = 1 * virtualScrollItemSizeComputed.value;
    if (fullReset === true || Array.isArray(virtualScrollSizes) === false) {
      virtualScrollSizes = [];
    }
    const oldVirtualScrollSizesLength = virtualScrollSizes.length;
    virtualScrollSizes.length = virtualScrollLength.value;
    for (let i = virtualScrollLength.value - 1; i >= oldVirtualScrollSizesLength; i--) {
      virtualScrollSizes[i] = defaultSize;
    }
    const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize);
    virtualScrollSizesAgg = [];
    for (let j = 0; j <= jMax; j++) {
      let size2 = 0;
      const iMax = Math.min((j + 1) * aggBucketSize, virtualScrollLength.value);
      for (let i = j * aggBucketSize; i < iMax; i++) {
        size2 += virtualScrollSizes[i];
      }
      virtualScrollSizesAgg.push(size2);
    }
    prevToIndex = -1;
    prevScrollStart = void 0;
    virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
    virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
    if (toIndex >= 0) {
      updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
      nextTick(() => {
        scrollTo(toIndex);
      });
    } else {
      onVirtualScrollEvt();
    }
  }
  function setVirtualScrollSize(scrollViewSize) {
    if (scrollViewSize === void 0 && typeof window !== "undefined") {
      const scrollEl = getVirtualScrollTarget();
      if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
        scrollViewSize = getScrollDetails(
          scrollEl,
          getVirtualScrollEl(),
          beforeRef.value,
          afterRef.value,
          props.virtualScrollHorizontal,
          $q.lang.rtl,
          props.virtualScrollStickySizeStart,
          props.virtualScrollStickySizeEnd
        ).scrollViewSize;
      }
    }
    localScrollViewSize = scrollViewSize;
    const virtualScrollSliceRatioBefore = parseFloat(props.virtualScrollSliceRatioBefore) || 0;
    const virtualScrollSliceRatioAfter = parseFloat(props.virtualScrollSliceRatioAfter) || 0;
    const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
    const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
    const baseSize = Math.max(
      1,
      view,
      Math.ceil((props.virtualScrollSliceSize > 0 ? props.virtualScrollSliceSize : 10) / multiplier)
    );
    virtualScrollSliceSizeComputed.value = {
      total: Math.ceil(baseSize * multiplier),
      start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
      center: Math.ceil(baseSize * (0.5 + virtualScrollSliceRatioBefore)),
      end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
      view
    };
  }
  function padVirtualScroll(tag, content) {
    const paddingSize = props.virtualScrollHorizontal === true ? "width" : "height";
    const style = {
      ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px"
    };
    return [
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef,
        style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style }
      }),
      h(tag, {
        class: "q-virtual-scroll__content",
        key: "content",
        ref: contentRef,
        tabindex: -1
      }, content.flat()),
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef,
        style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style }
      })
    ];
  }
  function emitScroll(index) {
    if (prevToIndex !== index) {
      props.onVirtualScroll !== void 0 && emit("virtualScroll", {
        index,
        from: virtualScrollSliceRange.value.from,
        to: virtualScrollSliceRange.value.to - 1,
        direction: index < prevToIndex ? "decrease" : "increase",
        ref: proxy
      });
      prevToIndex = index;
    }
  }
  setVirtualScrollSize();
  const onVirtualScrollEvt = debounce(
    localOnVirtualScrollEvt,
    $q.platform.is.ios === true ? 120 : 35
  );
  onBeforeMount(() => {
    setVirtualScrollSize();
  });
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    if (shouldActivate !== true) return;
    const scrollEl = getVirtualScrollTarget();
    if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
      setScroll(
        scrollEl,
        prevScrollStart,
        props.virtualScrollHorizontal,
        $q.lang.rtl
      );
    } else {
      scrollTo(prevToIndex);
    }
  });
  onBeforeUnmount(() => {
    onVirtualScrollEvt.cancel();
  });
  Object.assign(proxy, { scrollTo, reset, refresh });
  return {
    virtualScrollSliceRange,
    virtualScrollSliceSizeComputed,
    setVirtualScrollSize,
    onVirtualScrollEvt,
    localResetVirtualScroll,
    padVirtualScroll,
    scrollTo,
    reset,
    refresh
  };
}
function isDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a !== null && b !== null && typeof a === "object" && typeof b === "object") {
    if (a.constructor !== b.constructor) {
      return false;
    }
    let length, i;
    if (a.constructor === Array) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (i = length; i-- !== 0; ) {
        if (isDeepEqual(a[i], b[i]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (a.constructor === Map) {
      if (a.size !== b.size) {
        return false;
      }
      let iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (b.has(i.value[0]) !== true) {
          return false;
        }
        i = iter.next();
      }
      iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (isDeepEqual(i.value[1], b.get(i.value[0])) !== true) {
          return false;
        }
        i = iter.next();
      }
      return true;
    }
    if (a.constructor === Set) {
      if (a.size !== b.size) {
        return false;
      }
      const iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (b.has(i.value[0]) !== true) {
          return false;
        }
        i = iter.next();
      }
      return true;
    }
    if (a.buffer != null && a.buffer.constructor === ArrayBuffer) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (i = length; i-- !== 0; ) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    if (a.constructor === RegExp) {
      return a.source === b.source && a.flags === b.flags;
    }
    if (a.valueOf !== Object.prototype.valueOf) {
      return a.valueOf() === b.valueOf();
    }
    if (a.toString !== Object.prototype.toString) {
      return a.toString() === b.toString();
    }
    const keys = Object.keys(a).filter((key) => a[key] !== void 0);
    length = keys.length;
    if (length !== Object.keys(b).filter((key) => b[key] !== void 0).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (isDeepEqual(a[key], b[key]) !== true) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function isObject(v) {
  return v !== null && typeof v === "object" && Array.isArray(v) !== true;
}
function normalizeToInterval(v, min, max) {
  if (max <= min) {
    return min;
  }
  const size2 = max - min + 1;
  let index = min + (v - min) % size2;
  if (index < min) {
    index = size2 + index;
  }
  return index === 0 ? 0 : index;
}
const validateNewValueMode = (v) => ["add", "add-unique", "toggle"].includes(v);
const reEscapeList = ".*+?^${}()|[]\\";
const fieldPropsList = Object.keys(useFieldProps);
function getPropValueFn(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
const QSelect = createComponent({
  name: "QSelect",
  inheritAttrs: false,
  props: {
    ...useVirtualScrollProps,
    ...useFormProps,
    ...useFieldProps,
    // override of useFieldProps > modelValue
    modelValue: {
      required: true
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueHtml: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsHtml: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    popupNoRouteDismiss: Boolean,
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: validateNewValueMode
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    disableTabSelection: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: {},
    transitionHide: {},
    transitionDuration: {},
    behavior: {
      type: String,
      validator: (v) => ["default", "menu", "dialog"].includes(v),
      default: "default"
    },
    // override of useVirtualScrollProps > virtualScrollItemSize (no default)
    virtualScrollItemSize: useVirtualScrollProps.virtualScrollItemSize.type,
    onNewValue: Function,
    onFilter: Function
  },
  emits: [
    ...useFieldEmits,
    "add",
    "remove",
    "inputValue",
    "keyup",
    "keypress",
    "keydown",
    "popupShow",
    "popupHide",
    "filterAbort"
  ],
  setup(props, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menu = ref(false);
    const dialog = ref(false);
    const optionIndex = ref(-1);
    const inputValue = ref("");
    const dialogFieldFocused = ref(false);
    const innerLoadingIndicator = ref(false);
    let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
    const inputRef = ref(null);
    const targetRef = ref(null);
    const menuRef = ref(null);
    const dialogRef = ref(null);
    const menuContentRef = ref(null);
    const nameProp = useFormInputNameAttr(props);
    const onComposition = useKeyComposition(onInput);
    const virtualScrollLength = computed(() => Array.isArray(props.options) ? props.options.length : 0);
    const virtualScrollItemSizeComputed = computed(() => props.virtualScrollItemSize === void 0 ? props.optionsDense === true ? 24 : 48 : props.virtualScrollItemSize);
    const {
      virtualScrollSliceRange,
      virtualScrollSliceSizeComputed,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt,
      scrollTo,
      setVirtualScrollSize
    } = useVirtualScroll({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl,
      virtualScrollItemSizeComputed
    });
    const state = useFieldState();
    const innerValue = computed(() => {
      const mapNull = props.mapOptions === true && props.multiple !== true, val = props.modelValue !== void 0 && (props.modelValue !== null || mapNull === true) ? props.multiple === true && Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue] : [];
      if (props.mapOptions === true && Array.isArray(props.options) === true) {
        const cache2 = props.mapOptions === true && innerValueCache !== void 0 ? innerValueCache : [];
        const values = val.map((v) => getOption(v, cache2));
        return props.modelValue === null && mapNull === true ? values.filter((v) => v !== null) : values;
      }
      return val;
    });
    const innerFieldProps = computed(() => {
      const acc = {};
      fieldPropsList.forEach((key) => {
        const val = props[key];
        if (val !== void 0) {
          acc[key] = val;
        }
      });
      return acc;
    });
    const isOptionsDark = computed(() => props.optionsDark === null ? state.isDark.value : props.optionsDark);
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const computedInputClass = computed(() => {
      let cls = "q-field__input q-placeholder col";
      if (props.hideSelected === true || innerValue.value.length === 0) {
        return [cls, props.inputClass];
      }
      cls += " q-field__input--padding";
      return props.inputClass === void 0 ? cls : [cls, props.inputClass];
    });
    const menuContentClass = computed(
      () => (props.virtualScrollHorizontal === true ? "q-virtual-scroll--horizontal" : "") + (props.popupContentClass ? " " + props.popupContentClass : "")
    );
    const noOptions = computed(() => virtualScrollLength.value === 0);
    const selectedString = computed(
      () => innerValue.value.map((opt) => getOptionLabel.value(opt)).join(", ")
    );
    const ariaCurrentValue = computed(() => props.displayValue !== void 0 ? props.displayValue : selectedString.value);
    const needsHtmlFn = computed(() => props.optionsHtml === true ? () => true : (opt) => opt !== void 0 && opt !== null && opt.html === true);
    const valueAsHtml = computed(() => props.displayValueHtml === true || props.displayValue === void 0 && (props.optionsHtml === true || innerValue.value.some(needsHtmlFn.value)));
    const tabindex = computed(() => state.focused.value === true ? props.tabindex : -1);
    const comboboxAttrs = computed(() => {
      const attrs = {
        tabindex: props.tabindex,
        role: "combobox",
        "aria-label": props.label,
        "aria-readonly": props.readonly === true ? "true" : "false",
        "aria-autocomplete": props.useInput === true ? "list" : "none",
        "aria-expanded": menu.value === true ? "true" : "false",
        "aria-controls": `${state.targetUid.value}_lb`
      };
      if (optionIndex.value >= 0) {
        attrs["aria-activedescendant"] = `${state.targetUid.value}_${optionIndex.value}`;
      }
      return attrs;
    });
    const listboxAttrs = computed(() => ({
      id: `${state.targetUid.value}_lb`,
      role: "listbox",
      "aria-multiselectable": props.multiple === true ? "true" : "false"
    }));
    const selectedScope = computed(() => {
      return innerValue.value.map((opt, i) => ({
        index: i,
        opt,
        html: needsHtmlFn.value(opt),
        selected: true,
        removeAtIndex: removeAtIndexAndFocus,
        toggleOption,
        tabindex: tabindex.value
      }));
    });
    const optionScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const { from, to } = virtualScrollSliceRange.value;
      return props.options.slice(from, to).map((opt, i) => {
        const disable = isOptionDisabled.value(opt) === true;
        const active = isOptionSelected(opt) === true;
        const index = from + i;
        const itemProps = {
          clickable: true,
          active,
          activeClass: computedOptionsSelectedClass.value,
          manualFocus: true,
          focused: false,
          disable,
          tabindex: -1,
          dense: props.optionsDense,
          dark: isOptionsDark.value,
          role: "option",
          "aria-selected": active === true ? "true" : "false",
          id: `${state.targetUid.value}_${index}`,
          onClick: () => {
            toggleOption(opt);
          }
        };
        if (disable !== true) {
          optionIndex.value === index && (itemProps.focused = true);
          if ($q.platform.is.desktop === true) {
            itemProps.onMousemove = () => {
              menu.value === true && setOptionIndex(index);
            };
          }
        }
        return {
          index,
          opt,
          html: needsHtmlFn.value(opt),
          label: getOptionLabel.value(opt),
          selected: itemProps.active,
          focused: itemProps.focused,
          toggleOption,
          setOptionIndex,
          itemProps
        };
      });
    });
    const dropdownArrowIcon = computed(() => props.dropdownIcon !== void 0 ? props.dropdownIcon : $q.iconSet.arrow.dropdown);
    const squaredMenu = computed(
      () => props.optionsCover === false && props.outlined !== true && props.standout !== true && props.borderless !== true && props.rounded !== true
    );
    const computedOptionsSelectedClass = computed(() => props.optionsSelectedClass !== void 0 ? props.optionsSelectedClass : props.color !== void 0 ? `text-${props.color}` : "");
    const getOptionValue = computed(() => getPropValueFn(props.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn(props.optionLabel, "label"));
    const isOptionDisabled = computed(() => getPropValueFn(props.optionDisable, "disable"));
    const innerOptionsValue = computed(() => innerValue.value.map(getOptionValue.value));
    const inputControlEvents = computed(() => {
      const evt = {
        onInput,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: onComposition,
        onKeydown: onTargetKeydown,
        onKeyup: onTargetAutocomplete,
        onKeypress: onTargetKeypress,
        onFocus: selectInputText,
        onClick(e) {
          hasDialog === true && stop(e);
        }
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      return evt;
    });
    watch(innerValue, (val) => {
      innerValueCache = val;
      if (props.useInput === true && props.fillInput === true && props.multiple !== true && state.innerLoading.value !== true && (dialog.value !== true && menu.value !== true || hasValue.value !== true)) {
        userInputValue !== true && resetInputValue();
        if (dialog.value === true || menu.value === true) {
          filter("");
        }
      }
    }, { immediate: true });
    watch(() => props.fillInput, resetInputValue);
    watch(menu, updateMenu);
    watch(virtualScrollLength, rerenderMenu);
    function getEmittingOptionValue(opt) {
      return props.emitValue === true ? getOptionValue.value(opt) : opt;
    }
    function removeAtIndex(index) {
      if (index !== -1 && index < innerValue.value.length) {
        if (props.multiple === true) {
          const model = props.modelValue.slice();
          emit("remove", { index, value: model.splice(index, 1)[0] });
          emit("update:modelValue", model);
        } else {
          emit("update:modelValue", null);
        }
      }
    }
    function removeAtIndexAndFocus(index) {
      removeAtIndex(index);
      state.focus();
    }
    function add(opt, unique) {
      const val = getEmittingOptionValue(opt);
      if (props.multiple !== true) {
        props.fillInput === true && updateInputValue(
          getOptionLabel.value(opt),
          true,
          true
        );
        emit("update:modelValue", val);
        return;
      }
      if (innerValue.value.length === 0) {
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props.multiple === true ? [val] : val);
        return;
      }
      if (unique === true && isOptionSelected(opt) === true) {
        return;
      }
      if (props.maxValues !== void 0 && props.modelValue.length >= props.maxValues) {
        return;
      }
      const model = props.modelValue.slice();
      emit("add", { index: model.length, value: val });
      model.push(val);
      emit("update:modelValue", model);
    }
    function toggleOption(opt, keepOpen) {
      if (state.editable.value !== true || opt === void 0 || isOptionDisabled.value(opt) === true) {
        return;
      }
      const optValue = getOptionValue.value(opt);
      if (props.multiple !== true) {
        if (keepOpen !== true) {
          updateInputValue(
            props.fillInput === true ? getOptionLabel.value(opt) : "",
            true,
            true
          );
          hidePopup();
        }
        targetRef.value !== null && targetRef.value.focus();
        if (innerValue.value.length === 0 || isDeepEqual(getOptionValue.value(innerValue.value[0]), optValue) !== true) {
          emit("update:modelValue", props.emitValue === true ? optValue : opt);
        }
        return;
      }
      (hasDialog !== true || dialogFieldFocused.value === true) && state.focus();
      selectInputText();
      if (innerValue.value.length === 0) {
        const val = props.emitValue === true ? optValue : opt;
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props.multiple === true ? [val] : val);
        return;
      }
      const model = props.modelValue.slice(), index = innerOptionsValue.value.findIndex((v) => isDeepEqual(v, optValue));
      if (index !== -1) {
        emit("remove", { index, value: model.splice(index, 1)[0] });
      } else {
        if (props.maxValues !== void 0 && model.length >= props.maxValues) {
          return;
        }
        const val = props.emitValue === true ? optValue : opt;
        emit("add", { index: model.length, value: val });
        model.push(val);
      }
      emit("update:modelValue", model);
    }
    function setOptionIndex(index) {
      if ($q.platform.is.desktop !== true) return;
      const val = index !== -1 && index < virtualScrollLength.value ? index : -1;
      if (optionIndex.value !== val) {
        optionIndex.value = val;
      }
    }
    function moveOptionSelection(offset = 1, skipInputValue) {
      if (menu.value === true) {
        let index = optionIndex.value;
        do {
          index = normalizeToInterval(
            index + offset,
            -1,
            virtualScrollLength.value - 1
          );
        } while (index !== -1 && index !== optionIndex.value && isOptionDisabled.value(props.options[index]) === true);
        if (optionIndex.value !== index) {
          setOptionIndex(index);
          scrollTo(index);
          if (skipInputValue !== true && props.useInput === true && props.fillInput === true) {
            setInputValue(
              index >= 0 ? getOptionLabel.value(props.options[index]) : defaultInputValue,
              true
            );
          }
        }
      }
    }
    function getOption(value, valueCache) {
      const fn = (opt) => isDeepEqual(getOptionValue.value(opt), value);
      return props.options.find(fn) || valueCache.find(fn) || value;
    }
    function isOptionSelected(opt) {
      const val = getOptionValue.value(opt);
      return innerOptionsValue.value.find((v) => isDeepEqual(v, val)) !== void 0;
    }
    function selectInputText(e) {
      if (props.useInput === true && targetRef.value !== null && (e === void 0 || targetRef.value === e.target && e.target.value === selectedString.value)) {
        targetRef.value.select();
      }
    }
    function onTargetKeyup(e) {
      if (isKeyCode(e, 27) === true && menu.value === true) {
        stop(e);
        hidePopup();
        resetInputValue();
      }
      emit("keyup", e);
    }
    function onTargetAutocomplete(e) {
      const { value } = e.target;
      if (e.keyCode !== void 0) {
        onTargetKeyup(e);
        return;
      }
      e.target.value = "";
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      resetInputValue();
      if (typeof value === "string" && value.length !== 0) {
        const needle = value.toLocaleLowerCase();
        const findFn = (extractFn) => {
          const option = props.options.find((opt) => String(extractFn.value(opt)).toLocaleLowerCase() === needle);
          if (option === void 0) return false;
          if (innerValue.value.indexOf(option) === -1) {
            toggleOption(option);
          } else {
            hidePopup();
          }
          return true;
        };
        const fillFn = (afterFilter) => {
          if (findFn(getOptionValue) !== true && afterFilter !== true && findFn(getOptionLabel) !== true) {
            filter(value, true, () => fillFn(true));
          }
        };
        fillFn();
      } else {
        state.clearValue(e);
      }
    }
    function onTargetKeypress(e) {
      emit("keypress", e);
    }
    function onTargetKeydown(e) {
      emit("keydown", e);
      if (shouldIgnoreKey(e) === true) {
        return;
      }
      const newValueModeValid = inputValue.value.length !== 0 && (props.newValueMode !== void 0 || props.onNewValue !== void 0);
      const tabShouldSelect = e.shiftKey !== true && props.disableTabSelection !== true && props.multiple !== true && (optionIndex.value !== -1 || newValueModeValid === true);
      if (e.keyCode === 27) {
        prevent(e);
        return;
      }
      if (e.keyCode === 9 && tabShouldSelect === false) {
        closeMenu();
        return;
      }
      if (e.target === void 0 || e.target.id !== state.targetUid.value || state.editable.value !== true) return;
      if (e.keyCode === 40 && state.innerLoading.value !== true && menu.value === false) {
        stopAndPrevent(e);
        showPopup();
        return;
      }
      if (e.keyCode === 8 && (props.useChips === true || props.clearable === true) && props.hideSelected !== true && inputValue.value.length === 0) {
        if (props.multiple === true && Array.isArray(props.modelValue) === true) {
          removeAtIndex(props.modelValue.length - 1);
        } else if (props.multiple !== true && props.modelValue !== null) {
          emit("update:modelValue", null);
        }
        return;
      }
      if ((e.keyCode === 35 || e.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
        stopAndPrevent(e);
        optionIndex.value = -1;
        moveOptionSelection(e.keyCode === 36 ? 1 : -1, props.multiple);
      }
      if ((e.keyCode === 33 || e.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
        stopAndPrevent(e);
        optionIndex.value = Math.max(
          -1,
          Math.min(
            virtualScrollLength.value,
            optionIndex.value + (e.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view
          )
        );
        moveOptionSelection(e.keyCode === 33 ? 1 : -1, props.multiple);
      }
      if (e.keyCode === 38 || e.keyCode === 40) {
        stopAndPrevent(e);
        moveOptionSelection(e.keyCode === 38 ? -1 : 1, props.multiple);
      }
      const optionsLength = virtualScrollLength.value;
      if (searchBuffer === void 0 || searchBufferExp < Date.now()) {
        searchBuffer = "";
      }
      if (optionsLength > 0 && props.useInput !== true && e.key !== void 0 && e.key.length === 1 && e.altKey === false && e.ctrlKey === false && e.metaKey === false && (e.keyCode !== 32 || searchBuffer.length !== 0)) {
        menu.value !== true && showPopup(e);
        const char = e.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
        searchBufferExp = Date.now() + 1500;
        if (keyRepeat === false) {
          stopAndPrevent(e);
          searchBuffer += char;
        }
        const searchRe = new RegExp("^" + searchBuffer.split("").map((l) => reEscapeList.indexOf(l) !== -1 ? "\\" + l : l).join(".*"), "i");
        let index = optionIndex.value;
        if (keyRepeat === true || index < 0 || searchRe.test(getOptionLabel.value(props.options[index])) !== true) {
          do {
            index = normalizeToInterval(index + 1, -1, optionsLength - 1);
          } while (index !== optionIndex.value && (isOptionDisabled.value(props.options[index]) === true || searchRe.test(getOptionLabel.value(props.options[index])) !== true));
        }
        if (optionIndex.value !== index) {
          nextTick(() => {
            setOptionIndex(index);
            scrollTo(index);
            if (index >= 0 && props.useInput === true && props.fillInput === true) {
              setInputValue(getOptionLabel.value(props.options[index]), true);
            }
          });
        }
        return;
      }
      if (e.keyCode !== 13 && (e.keyCode !== 32 || props.useInput === true || searchBuffer !== "") && (e.keyCode !== 9 || tabShouldSelect === false)) return;
      e.keyCode !== 9 && stopAndPrevent(e);
      if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
        toggleOption(props.options[optionIndex.value]);
        return;
      }
      if (newValueModeValid === true) {
        const done = (val, mode) => {
          if (mode) {
            if (validateNewValueMode(mode) !== true) {
              return;
            }
          } else {
            mode = props.newValueMode;
          }
          updateInputValue("", props.multiple !== true, true);
          if (val === void 0 || val === null) {
            return;
          }
          const fn = mode === "toggle" ? toggleOption : add;
          fn(val, mode === "add-unique");
          if (props.multiple !== true) {
            targetRef.value !== null && targetRef.value.focus();
            hidePopup();
          }
        };
        if (props.onNewValue !== void 0) {
          emit("newValue", inputValue.value, done);
        } else {
          done(inputValue.value);
        }
        if (props.multiple !== true) {
          return;
        }
      }
      if (menu.value === true) {
        closeMenu();
      } else if (state.innerLoading.value !== true) {
        showPopup();
      }
    }
    function getVirtualScrollEl() {
      return hasDialog === true ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
    }
    function getVirtualScrollTarget() {
      return getVirtualScrollEl();
    }
    function getSelection() {
      if (props.hideSelected === true) {
        return [];
      }
      if (slots["selected-item"] !== void 0) {
        return selectedScope.value.map((scope) => slots["selected-item"](scope)).slice();
      }
      if (slots.selected !== void 0) {
        return [].concat(slots.selected());
      }
      if (props.useChips === true) {
        return selectedScope.value.map((scope, i) => h(QChip, {
          key: "option-" + i,
          removable: state.editable.value === true && isOptionDisabled.value(scope.opt) !== true,
          dense: true,
          textColor: props.color,
          tabindex: tabindex.value,
          onRemove() {
            scope.removeAtIndex(i);
          }
        }, () => h("span", {
          class: "ellipsis",
          [scope.html === true ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
        })));
      }
      return [
        h("span", {
          [valueAsHtml.value === true ? "innerHTML" : "textContent"]: ariaCurrentValue.value
        })
      ];
    }
    function getAllOptions() {
      if (noOptions.value === true) {
        return slots["no-option"] !== void 0 ? slots["no-option"]({ inputValue: inputValue.value }) : void 0;
      }
      const fn = slots.option !== void 0 ? slots.option : (scope) => {
        return h(QItem, {
          key: scope.index,
          ...scope.itemProps
        }, () => {
          return h(
            QItemSection,
            () => h(
              QItemLabel,
              () => h("span", {
                [scope.html === true ? "innerHTML" : "textContent"]: scope.label
              })
            )
          );
        });
      };
      let options = padVirtualScroll("div", optionScope.value.map(fn));
      if (slots["before-options"] !== void 0) {
        options = slots["before-options"]().concat(options);
      }
      return hMergeSlot(slots["after-options"], options);
    }
    function getInput(fromDialog, isTarget) {
      const attrs = isTarget === true ? { ...comboboxAttrs.value, ...state.splitAttrs.attributes.value } : void 0;
      const data = {
        ref: isTarget === true ? targetRef : void 0,
        key: "i_t",
        class: computedInputClass.value,
        style: props.inputStyle,
        value: inputValue.value !== void 0 ? inputValue.value : "",
        // required for Android in order to show ENTER key when in form
        type: "search",
        ...attrs,
        id: isTarget === true ? state.targetUid.value : void 0,
        maxlength: props.maxlength,
        autocomplete: props.autocomplete,
        "data-autofocus": fromDialog === true || props.autofocus === true || void 0,
        disabled: props.disable === true,
        readonly: props.readonly === true,
        ...inputControlEvents.value
      };
      if (fromDialog !== true && hasDialog === true) {
        if (Array.isArray(data.class) === true) {
          data.class = [...data.class, "no-pointer-events"];
        } else {
          data.class += " no-pointer-events";
        }
      }
      return h("input", data);
    }
    function onInput(e) {
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      if (e && e.target && e.target.qComposing === true) {
        return;
      }
      setInputValue(e.target.value || "");
      userInputValue = true;
      defaultInputValue = inputValue.value;
      if (state.focused.value !== true && (hasDialog !== true || dialogFieldFocused.value === true)) {
        state.focus();
      }
      if (props.onFilter !== void 0) {
        filterTimer = setTimeout(() => {
          filterTimer = null;
          filter(inputValue.value);
        }, props.inputDebounce);
      }
    }
    function setInputValue(val, emitImmediately) {
      if (inputValue.value !== val) {
        inputValue.value = val;
        if (emitImmediately === true || props.inputDebounce === 0 || props.inputDebounce === "0") {
          emit("inputValue", val);
        } else {
          inputValueTimer = setTimeout(() => {
            inputValueTimer = null;
            emit("inputValue", val);
          }, props.inputDebounce);
        }
      }
    }
    function updateInputValue(val, noFiltering, internal) {
      userInputValue = internal !== true;
      if (props.useInput === true) {
        setInputValue(val, true);
        if (noFiltering === true || internal !== true) {
          defaultInputValue = val;
        }
        noFiltering !== true && filter(val);
      }
    }
    function filter(val, keepClosed, afterUpdateFn) {
      if (props.onFilter === void 0 || keepClosed !== true && state.focused.value !== true) {
        return;
      }
      if (state.innerLoading.value === true) {
        emit("filterAbort");
      } else {
        state.innerLoading.value = true;
        innerLoadingIndicator.value = true;
      }
      if (val !== "" && props.multiple !== true && innerValue.value.length !== 0 && userInputValue !== true && val === getOptionLabel.value(innerValue.value[0])) {
        val = "";
      }
      const localFilterId = setTimeout(() => {
        menu.value === true && (menu.value = false);
      }, 10);
      filterId !== null && clearTimeout(filterId);
      filterId = localFilterId;
      emit(
        "filter",
        val,
        (fn, afterFn) => {
          if ((keepClosed === true || state.focused.value === true) && filterId === localFilterId) {
            clearTimeout(filterId);
            typeof fn === "function" && fn();
            innerLoadingIndicator.value = false;
            nextTick(() => {
              state.innerLoading.value = false;
              if (state.editable.value === true) {
                if (keepClosed === true) {
                  menu.value === true && hidePopup();
                } else if (menu.value === true) {
                  updateMenu(true);
                } else {
                  menu.value = true;
                }
              }
              typeof afterFn === "function" && nextTick(() => {
                afterFn(proxy);
              });
              typeof afterUpdateFn === "function" && nextTick(() => {
                afterUpdateFn(proxy);
              });
            });
          }
        },
        () => {
          if (state.focused.value === true && filterId === localFilterId) {
            clearTimeout(filterId);
            state.innerLoading.value = false;
            innerLoadingIndicator.value = false;
          }
          menu.value === true && (menu.value = false);
        }
      );
    }
    function getMenu() {
      return h(QMenu, {
        ref: menuRef,
        class: menuContentClass.value,
        style: props.popupContentStyle,
        modelValue: menu.value,
        fit: props.menuShrink !== true,
        cover: props.optionsCover === true && noOptions.value !== true && props.useInput !== true,
        anchor: props.menuAnchor,
        self: props.menuSelf,
        offset: props.menuOffset,
        dark: isOptionsDark.value,
        noParentEvent: true,
        noRefocus: true,
        noFocus: true,
        noRouteDismiss: props.popupNoRouteDismiss,
        square: squaredMenu.value,
        transitionShow: props.transitionShow,
        transitionHide: props.transitionHide,
        transitionDuration: props.transitionDuration,
        separateClosePopup: true,
        ...listboxAttrs.value,
        onScrollPassive: onVirtualScrollEvt,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onMenuBeforeHide,
        onShow: onMenuShow
      }, getAllOptions);
    }
    function onMenuBeforeHide(e) {
      onControlPopupHide(e);
      closeMenu();
    }
    function onMenuShow() {
      setVirtualScrollSize();
    }
    function onDialogFieldFocus(e) {
      stop(e);
      targetRef.value !== null && targetRef.value.focus();
      dialogFieldFocused.value = true;
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    }
    function onDialogFieldBlur(e) {
      stop(e);
      nextTick(() => {
        dialogFieldFocused.value = false;
      });
    }
    function getDialog() {
      const content = [
        h(QField, {
          class: `col-auto ${state.fieldClass.value}`,
          ...innerFieldProps.value,
          for: state.targetUid.value,
          dark: isOptionsDark.value,
          square: true,
          loading: innerLoadingIndicator.value,
          itemAligned: false,
          filled: true,
          stackLabel: inputValue.value.length !== 0,
          ...state.splitAttrs.listeners.value,
          onFocus: onDialogFieldFocus,
          onBlur: onDialogFieldBlur
        }, {
          ...slots,
          rawControl: () => state.getControl(true),
          before: void 0,
          after: void 0
        })
      ];
      menu.value === true && content.push(
        h("div", {
          ref: menuContentRef,
          class: menuContentClass.value + " scroll",
          style: props.popupContentStyle,
          ...listboxAttrs.value,
          onClick: prevent,
          onScrollPassive: onVirtualScrollEvt
        }, getAllOptions())
      );
      return h(QDialog, {
        ref: dialogRef,
        modelValue: dialog.value,
        position: props.useInput === true ? "top" : void 0,
        transitionShow: transitionShowComputed,
        transitionHide: props.transitionHide,
        transitionDuration: props.transitionDuration,
        noRouteDismiss: props.popupNoRouteDismiss,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onDialogBeforeHide,
        onHide: onDialogHide,
        onShow: onDialogShow
      }, () => h("div", {
        class: "q-select__dialog" + (isOptionsDark.value === true ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value === true ? " q-select__dialog--focused" : "")
      }, content));
    }
    function onDialogBeforeHide(e) {
      onControlPopupHide(e);
      if (dialogRef.value !== null) {
        dialogRef.value.__updateRefocusTarget(
          state.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")
        );
      }
      state.focused.value = false;
    }
    function onDialogHide(e) {
      hidePopup();
      state.focused.value === false && emit("blur", e);
      resetInputValue();
    }
    function onDialogShow() {
      const el = document.activeElement;
      if ((el === null || el.id !== state.targetUid.value) && targetRef.value !== null && targetRef.value !== el) {
        targetRef.value.focus();
      }
      setVirtualScrollSize();
    }
    function closeMenu() {
      if (dialog.value === true) {
        return;
      }
      optionIndex.value = -1;
      if (menu.value === true) {
        menu.value = false;
      }
      if (state.focused.value === false) {
        if (filterId !== null) {
          clearTimeout(filterId);
          filterId = null;
        }
        if (state.innerLoading.value === true) {
          emit("filterAbort");
          state.innerLoading.value = false;
          innerLoadingIndicator.value = false;
        }
      }
    }
    function showPopup(e) {
      if (state.editable.value !== true) {
        return;
      }
      if (hasDialog === true) {
        state.onControlFocusin(e);
        dialog.value = true;
        nextTick(() => {
          state.focus();
        });
      } else {
        state.focus();
      }
      if (props.onFilter !== void 0) {
        filter(inputValue.value);
      } else if (noOptions.value !== true || slots["no-option"] !== void 0) {
        menu.value = true;
      }
    }
    function hidePopup() {
      dialog.value = false;
      closeMenu();
    }
    function resetInputValue() {
      props.useInput === true && updateInputValue(
        props.multiple !== true && props.fillInput === true && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "",
        true,
        true
      );
    }
    function updateMenu(show) {
      let optionIndex2 = -1;
      if (show === true) {
        if (innerValue.value.length !== 0) {
          const val = getOptionValue.value(innerValue.value[0]);
          optionIndex2 = props.options.findIndex((v) => isDeepEqual(getOptionValue.value(v), val));
        }
        localResetVirtualScroll(optionIndex2);
      }
      setOptionIndex(optionIndex2);
    }
    function rerenderMenu(newLength, oldLength) {
      if (menu.value === true && state.innerLoading.value === false) {
        localResetVirtualScroll(-1, true);
        nextTick(() => {
          if (menu.value === true && state.innerLoading.value === false) {
            if (newLength > oldLength) {
              localResetVirtualScroll();
            } else {
              updateMenu(true);
            }
          }
        });
      }
    }
    function updateMenuPosition() {
      if (dialog.value === false && menuRef.value !== null) {
        menuRef.value.updatePosition();
      }
    }
    function onControlPopupShow(e) {
      e !== void 0 && stop(e);
      emit("popupShow", e);
      state.hasPopupOpen = true;
      state.onControlFocusin(e);
    }
    function onControlPopupHide(e) {
      e !== void 0 && stop(e);
      emit("popupHide", e);
      state.hasPopupOpen = false;
      state.onControlFocusout(e);
    }
    function updatePreState() {
      hasDialog = $q.platform.is.mobile !== true && props.behavior !== "dialog" ? false : props.behavior !== "menu" && (props.useInput === true ? slots["no-option"] !== void 0 || props.onFilter !== void 0 || noOptions.value === false : true);
      transitionShowComputed = $q.platform.is.ios === true && hasDialog === true && props.useInput === true ? "fade" : props.transitionShow;
    }
    onBeforeUpdate(updatePreState);
    onUpdated(updateMenuPosition);
    updatePreState();
    onBeforeUnmount(() => {
      filterTimer !== null && clearTimeout(filterTimer);
      inputValueTimer !== null && clearTimeout(inputValueTimer);
    });
    Object.assign(proxy, {
      showPopup,
      hidePopup,
      removeAtIndex,
      add,
      toggleOption,
      getOptionIndex: () => optionIndex.value,
      setOptionIndex,
      moveOptionSelection,
      filter,
      updateMenuPosition,
      updateInputValue,
      isOptionSelected,
      getEmittingOptionValue,
      isOptionDisabled: (...args) => isOptionDisabled.value.apply(null, args) === true,
      getOptionValue: (...args) => getOptionValue.value.apply(null, args),
      getOptionLabel: (...args) => getOptionLabel.value.apply(null, args)
    });
    Object.assign(state, {
      innerValue,
      fieldClass: computed(
        () => `q-select q-field--auto-height q-select--with${props.useInput !== true ? "out" : ""}-input q-select--with${props.useChips !== true ? "out" : ""}-chips q-select--${props.multiple === true ? "multiple" : "single"}`
      ),
      inputRef,
      targetRef,
      hasValue,
      showPopup,
      floatingLabel: computed(
        () => props.hideSelected !== true && hasValue.value === true || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled(props.displayValue)
      ),
      getControlChild: () => {
        if (state.editable.value !== false && (dialog.value === true || noOptions.value !== true || slots["no-option"] !== void 0)) {
          return hasDialog === true ? getDialog() : getMenu();
        } else if (state.hasPopupOpen === true) {
          state.hasPopupOpen = false;
        }
      },
      controlEvents: {
        onFocusin(e) {
          state.onControlFocusin(e);
        },
        onFocusout(e) {
          state.onControlFocusout(e, () => {
            resetInputValue();
            closeMenu();
          });
        },
        onClick(e) {
          prevent(e);
          if (hasDialog !== true && menu.value === true) {
            closeMenu();
            targetRef.value !== null && targetRef.value.focus();
            return;
          }
          showPopup(e);
        }
      },
      getControl: (fromDialog) => {
        const child = getSelection();
        const isTarget = fromDialog === true || dialog.value !== true || hasDialog !== true;
        if (props.useInput === true) {
          child.push(getInput(fromDialog, isTarget));
        } else if (state.editable.value === true) {
          const attrs2 = isTarget === true ? comboboxAttrs.value : void 0;
          child.push(
            h("input", {
              ref: isTarget === true ? targetRef : void 0,
              key: "d_t",
              class: "q-select__focus-target",
              id: isTarget === true ? state.targetUid.value : void 0,
              value: ariaCurrentValue.value,
              readonly: true,
              "data-autofocus": fromDialog === true || props.autofocus === true || void 0,
              ...attrs2,
              onKeydown: onTargetKeydown,
              onKeyup: onTargetKeyup,
              onKeypress: onTargetKeypress
            })
          );
          if (isTarget === true && typeof props.autocomplete === "string" && props.autocomplete.length !== 0) {
            child.push(
              h("input", {
                class: "q-select__autocomplete-input",
                autocomplete: props.autocomplete,
                tabindex: -1,
                onKeyup: onTargetAutocomplete
              })
            );
          }
        }
        if (nameProp.value !== void 0 && props.disable !== true && innerOptionsValue.value.length !== 0) {
          const opts = innerOptionsValue.value.map((value) => h("option", { value, selected: true }));
          child.push(
            h("select", {
              class: "hidden",
              name: nameProp.value,
              multiple: props.multiple
            }, opts)
          );
        }
        const attrs = props.useInput === true || isTarget !== true ? void 0 : state.splitAttrs.attributes.value;
        return h("div", {
          class: "q-field__native row items-center",
          ...attrs,
          ...state.splitAttrs.listeners.value
        }, child);
      },
      getInnerAppend: () => props.loading !== true && innerLoadingIndicator.value !== true && props.hideDropdownIcon !== true ? [
        h(QIcon, {
          class: "q-select__dropdown-icon" + (menu.value === true ? " rotate-180" : ""),
          name: dropdownArrowIcon.value
        })
      ] : null
    });
    return useField(state);
  }
});
const _hoisted_1$6 = { class: "ws-select ws-field wrapper" };
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "WsSelect",
  props: {
    value: { type: [String, Number], default: null },
    options: { type: Array, required: true },
    allowCustomValue: Boolean,
    withInput: Boolean,
    useInput: Boolean,
    reduceOptionsByQuery: Boolean,
    openOptionsOnFocus: Boolean,
    dark: Boolean,
    errorDesign: Boolean,
    multiple: Boolean,
    bgColor: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    messagesOverflow: Boolean,
    icon: {
      type: String,
      default: "arrow_down"
    },
    name: {
      type: String,
      default: void 0
    },
    emitValue: Boolean,
    widePaddings: Boolean,
    customDisplayValue: { type: [String, Number], default: null },
    portalSlots: {
      type: Array,
      default: null
    },
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: [
    // eslint-disable-next-line sonarjs/no-duplicate-string
    "update:model-value",
    "new-value",
    "input",
    "filter",
    "focus",
    "blur",
    "keydown.enter"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const attrs = useAttrs();
    const slots = useSlots();
    const selectedValue = ref(props.modelValue);
    const query = ref("");
    const filteredOptions = ref([]);
    const timeoutRef = ref(null);
    const messages = ref([]);
    const qFieldRef = ref(null);
    const openDropdown = () => {
      var _a, _b;
      (_b = (_a = qFieldRef.value) == null ? void 0 : _a.showPopup) == null ? void 0 : _b.call(_a);
    };
    const updateSelectedValue = (value) => {
      selectedValue.value = value;
      emit("update:model-value", value);
      emit("input", value);
    };
    const displayValue = computed(() => {
      var _a, _b, _c, _d, _e;
      try {
        if (props.multiple === true && props.value) {
          return props.value;
        } else {
          return (_b = (_a = props.options) == null ? void 0 : _a.find(
            (option) => {
              var _a2, _b2, _c2, _d2;
              return ((_a2 = option.value) == null ? void 0 : _a2.toString()) === (((_c2 = (_b2 = selectedValue.value) == null ? void 0 : _b2.value) == null ? void 0 : _c2.toString()) || ((_d2 = selectedValue.value) == null ? void 0 : _d2.toString()));
            }
          )) == null ? void 0 : _b.label;
        }
      } catch {
        return ((_c = selectedValue.value) == null ? void 0 : _c.label) || ((_e = (_d = selectedValue.value) == null ? void 0 : _d.value) == null ? void 0 : _e.toString()) || selectedValue.value;
      }
    });
    const filterOptions = (val, update2) => {
      query.value = val;
      update2(() => {
        updateOptions(val);
      });
    };
    const updateOptions = (query2 = ((_a) => (_a = query2.value) == null ? void 0 : _a.toString())() || "") => {
      var _a2;
      if (query2 !== "" && props.reduceOptionsByQuery) {
        query2 = query2.toLowerCase();
        filteredOptions.value = (_a2 = props.options) == null ? void 0 : _a2.filter((option) => {
          if (typeof option === "string") {
            return option.toLowerCase().includes(query2);
          } else if (option == null ? void 0 : option.label) {
            return option.label.toLowerCase().includes(query2);
          }
        });
      } else {
        filteredOptions.value = props.options;
      }
    };
    const createValue = (val, done) => {
      if (props.multiple && val.length > 0 && !filteredOptions.value.includes(val)) {
        done(val, "add-unique");
      }
    };
    const sendValue = () => {
      if (selectedValue.value !== null && props.allowCustomValue) {
        emit("input", selectedValue.value);
      }
    };
    const handleEnter = () => {
      if (props.allowCustomValue) {
        emit("new-value", selectedValue.value);
      }
    };
    const onInputValueChange = (value) => {
      query.value = value;
      if (props.allowCustomValue && !props.multiple) {
        selectedValue.value = query.value;
      }
    };
    const onFocus = () => {
      emit("focus");
      if (props.openOptionsOnFocus) {
        timeoutRef.value = setTimeout(() => {
          openDropdown();
        }, 300);
      }
    };
    const onFocusOut = () => {
      sendValue();
    };
    __expose({
      showPopup: () => {
        var _a;
        return (_a = qFieldRef.value) == null ? void 0 : _a.showPopup();
      },
      focus: () => {
        var _a;
        return (_a = qFieldRef.value) == null ? void 0 : _a.focus();
      },
      hidePopup: () => {
        var _a;
        return (_a = qFieldRef.value) == null ? void 0 : _a.hidePopup();
      }
    });
    onMounted(() => {
      filteredOptions.value = props.options;
      if (props.multiple && props.value) {
        const stringToArray = filteredOptions.value.toString().split(",").map((val) => val.trim());
        const selectedOptions = stringToArray.map((val) => {
          var _a;
          return (_a = filteredOptions.value) == null ? void 0 : _a.find((option) => {
            var _a2;
            return ((_a2 = option.value) == null ? void 0 : _a2.toString()) === (val == null ? void 0 : val.toString());
          });
        }).filter(Boolean);
        selectedValue.value = selectedOptions;
      } else if (props.value && !props.multiple) {
        const selectedOption = filteredOptions.value.find((option) => {
          var _a, _b;
          return ((_a = option.value) == null ? void 0 : _a.toString()) === ((_b = props.value) == null ? void 0 : _b.toString());
        });
        if (selectedOption) {
          selectedValue.value = selectedOption;
        }
      }
      if (!props.label && !props.value && filteredOptions.value.length > 0) {
        selectedValue.value = filteredOptions.value[0];
        emit("update:model-value", selectedValue.value);
        emit("input", selectedValue.value);
      }
    });
    onBeforeUnmount(() => {
      clearTimeout(timeoutRef.value);
    });
    const emphasiseQuery2 = (option) => {
      if (!query.value) {
        return option;
      }
      const escapedQuery = escapeRegExp(query.value.trim());
      const regex = new RegExp(`(${escapedQuery})`, "gi");
      return option.replace(regex, '<span class="highlight">$1</span>');
    };
    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    const predefinedSlotNames = computed(() => {
      const baseSlotNames = ["append", "option", "customDisplay"];
      return props.multiple ? [...baseSlotNames, "selected-item"] : baseSlotNames;
    });
    const isCustomDisplay = computed(() => {
      var _a;
      return ((_a = props.portalSlots) == null ? void 0 : _a.includes("customDisplay")) || false;
    });
    const allSlotNames = computed(() => {
      const combinedSlots = [
        ...Array.isArray(props.portalSlots) ? props.portalSlots : [],
        ...Object.keys(slots)
      ];
      return combinedSlots.filter((slotName) => !predefinedSlotNames.value.includes(slotName));
    });
    watch(() => props.modelValue, (newVal) => {
      selectedValue.value = newVal;
    }, { immediate: true });
    watch(() => props.options, (newVal) => {
      filteredOptions.value = newVal;
    }, { immediate: true });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", _hoisted_1$6, [
        createVNode(_component_portal_slot, {
          slot: unref(slots).customDisplay,
          "component-id": _ctx.$attrs["component-id"],
          name: "customDisplay",
          "selected-value": displayValue.value,
          "open-dropdown": openDropdown,
          "raw-selected-value": selectedValue.value
        }, null, 8, ["slot", "component-id", "selected-value", "raw-selected-value"]),
        createVNode(QSelect, mergeProps({
          ref_key: "qFieldRef",
          ref: qFieldRef
        }, unref(attrs), {
          "model-value": selectedValue.value,
          options: filteredOptions.value,
          class: ["ws-select-inner", {
            "ws-select-chips": unref(attrs)["use-chips"] === "",
            "ws-select-empty": !selectedValue.value || unref(get)(selectedValue.value, "length") === 0,
            "ws-dark": __props.dark,
            "q-field--error": __props.errorDesign,
            "messages-overflow": __props.messagesOverflow,
            "custom-display": isCustomDisplay.value
          }],
          "display-value": displayValue.value,
          "popup-content-class": (unref(attrs)["popup-content-class"] || "") + " ws-select-content wsk-root wsk-app wsk-portal ws-typography" + (__props.widePaddings ? " wide-paddings" : ""),
          "bg-color": __props.bgColor || (__props.dark ? "dark" : "white"),
          standout: __props.dark ? "bg-dark text-white" : "bg-white ws-text-darker",
          dark: __props.dark,
          label: __props.label,
          multiple: __props.multiple,
          outlined: "",
          "use-chips": __props.multiple,
          "no-error-icon": "",
          "use-input": __props.allowCustomValue || __props.reduceOptionsByQuery || __props.withInput || __props.useInput,
          "fill-input": __props.allowCustomValue && !__props.multiple,
          "hide-selected": __props.allowCustomValue && !__props.multiple,
          "input-debounce": __props.reduceOptionsByQuery ? 300 : void 0,
          "lazy-rules": "",
          "transition-show": "jump-down",
          "transition-hide": "jump-up",
          "bottom-slots": "",
          error: !!messages.value.length,
          "error-message": messages.value.length && (messages.value[0].translation || _ctx.$t(messages.value[0].translationKey, messages.value[0].values)) || "",
          behavior: "menu",
          "hide-dropdown-icon": "",
          "emit-value": __props.emitValue,
          onFilter: filterOptions,
          onNewValue: createValue,
          onFocus,
          onBlur: onFocusOut,
          "onUpdate:modelValue": updateSelectedValue,
          onInputValue: onInputValueChange,
          onKeydown: withKeys(handleEnter, ["enter"])
        }), createSlots({
          option: withCtx((scope) => [
            createVNode(_component_portal_slot, {
              slot: _ctx.$slots.option,
              "component-id": _ctx.$attrs["component-id"],
              name: "option",
              scope
            }, {
              default: withCtx(() => [
                createVNode(QItem, mergeProps(scope.itemProps, {
                  onClick: ($event) => scope.toggleOption(scope.opt)
                }), {
                  default: withCtx(() => [
                    __props.multiple ? (openBlock(), createBlock(QItemSection, {
                      key: 0,
                      side: "",
                      class: "q-mr-sm"
                    }, {
                      default: withCtx(() => [
                        scope.selected ? (openBlock(), createBlock(WsIcon, {
                          key: 0,
                          name: "select",
                          height: 16
                        })) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)) : createCommentVNode("", true),
                    scope.opt.icon ? (openBlock(), createBlock(QItemSection, {
                      key: 1,
                      side: ""
                    }, {
                      default: withCtx(() => [
                        createVNode(WsIcon, {
                          name: scope.opt.icon,
                          height: 16
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1024)) : createCommentVNode("", true),
                    createVNode(QItemSection, null, {
                      default: withCtx(() => [
                        createVNode(QItemLabel, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(typeof scope.opt === "string" ? scope.opt : scope.opt.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1040, ["onClick"])
              ]),
              _: 2
            }, 1032, ["slot", "component-id", "scope"])
          ]),
          _: 2
        }, [
          __props.icon ? {
            name: "append",
            fn: withCtx(() => [
              createVNode(_component_portal_slot, {
                slot: unref(slots).append,
                "component-id": _ctx.$attrs["component-id"],
                name: "append"
              }, {
                default: withCtx(() => [
                  createVNode(WsIcon, { name: __props.icon }, null, 8, ["name"])
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ]),
            key: "0"
          } : void 0,
          __props.multiple ? {
            name: "selected-item",
            fn: withCtx((scope) => [
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots["selected-item"],
                "component-id": _ctx.$attrs["component-id"],
                name: "selected-item",
                scope
              }, {
                default: withCtx(() => [
                  createVNode(QChip, {
                    dense: "",
                    onRemove: ($event) => scope.removeAtIndex(scope.index)
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(scope.opt.label) + " ", 1),
                      createVNode(WsIcon, {
                        name: "close",
                        size: 17.5,
                        onClick: withModifiers(($event) => scope.removeAtIndex(scope.index), ["stop"])
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 2
              }, 1032, ["slot", "component-id", "scope"])
            ]),
            key: "1"
          } : void 0,
          renderList(allSlotNames.value, (slotName) => {
            return {
              name: slotName,
              fn: withCtx((scope) => [
                (openBlock(), createBlock(_component_portal_slot, mergeProps({
                  slot: unref(slots)[slotName],
                  key: slotName,
                  name: slotName,
                  "component-id": _ctx.$attrs["component-id"]
                }, { ...scope, emphasiseQuery: emphasiseQuery2 }), null, 16, ["slot", "name", "component-id"]))
              ])
            };
          })
        ]), 1040, ["model-value", "options", "display-value", "class", "popup-content-class", "bg-color", "standout", "dark", "label", "multiple", "use-chips", "use-input", "fill-input", "hide-selected", "input-debounce", "error", "error-message", "emit-value"])
      ]);
    };
  }
});
const WsSelect = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-cfd7084b"]]);
const insetMap = {
  true: "inset",
  item: "item-inset",
  "item-thumbnail": "item-thumbnail-inset"
};
const margins = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
};
const QSeparator = createComponent({
  name: "QSeparator",
  props: {
    ...useDarkProps,
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  setup(props) {
    const vm = getCurrentInstance();
    const isDark = useDark(props, vm.proxy.$q);
    const orientation = computed(() => props.vertical === true ? "vertical" : "horizontal");
    const orientClass = computed(() => ` q-separator--${orientation.value}`);
    const insetClass = computed(() => props.inset !== false ? `${orientClass.value}-${insetMap[props.inset]}` : "");
    const classes = computed(
      () => `q-separator${orientClass.value}${insetClass.value}` + (props.color !== void 0 ? ` bg-${props.color}` : "") + (isDark.value === true ? " q-separator--dark" : "")
    );
    const style = computed(() => {
      const acc = {};
      if (props.size !== void 0) {
        acc[props.vertical === true ? "width" : "height"] = props.size;
      }
      if (props.spaced !== false) {
        const size2 = props.spaced === true ? `${margins.md}px` : props.spaced in margins ? `${margins[props.spaced]}px` : props.spaced;
        const dir = props.vertical === true ? ["Left", "Right"] : ["Top", "Bottom"];
        acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size2;
      }
      return acc;
    });
    return () => h("hr", {
      class: classes.value,
      style: style.value,
      "aria-orientation": orientation.value
    });
  }
});
const phonePrefixes = [
  {
    id: "af",
    country: "Afghanistan (‫افغانستان‬‎)",
    code: "+93"
  },
  {
    id: "al",
    country: "Albania (Shqipëri)",
    code: "+355"
  },
  {
    id: "dz",
    country: "Algeria (‫الجزائر‬‎)",
    code: "+213"
  },
  {
    id: "as",
    country: "American Samoa",
    code: "+1684"
  },
  {
    id: "ad",
    country: "Andorra",
    code: "+376"
  },
  {
    id: "ao",
    country: "Angola",
    code: "+244"
  },
  {
    id: "ai",
    country: "Anguilla",
    code: "+1264"
  },
  {
    id: "ag",
    country: "Antigua and Barbuda",
    code: "+1268"
  },
  {
    id: "ar",
    country: "Argentina",
    code: "+54"
  },
  {
    id: "am",
    country: "Armenia (Հայաստան)",
    code: "+374"
  },
  {
    id: "aw",
    country: "Aruba",
    code: "+297"
  },
  {
    id: "au",
    country: "Australia",
    code: "+61"
  },
  {
    id: "at",
    country: "Austria (Österreich)",
    code: "+43"
  },
  {
    id: "az",
    country: "Azerbaijan (Azərbaycan)",
    code: "+994"
  },
  {
    id: "bs",
    country: "Bahamas",
    code: "+1242"
  },
  {
    id: "bh",
    country: "Bahrain (‫البحرين‬‎)",
    code: "+973"
  },
  {
    id: "bd",
    country: "Bangladesh (বাংলাদেশ)",
    code: "+880"
  },
  {
    id: "bb",
    country: "Barbados",
    code: "+1246"
  },
  {
    id: "by",
    country: "Belarus (Беларусь)",
    code: "+375"
  },
  {
    id: "be",
    country: "Belgium (België)",
    code: "+32"
  },
  {
    id: "bz",
    country: "Belize",
    code: "+501"
  },
  {
    id: "bj",
    country: "Benin (Bénin)",
    code: "+229"
  },
  {
    id: "bm",
    country: "Bermuda",
    code: "+1441"
  },
  {
    id: "bt",
    country: "Bhutan (འབྲུག)",
    code: "+975"
  },
  {
    id: "bo",
    country: "Bolivia",
    code: "+591"
  },
  {
    id: "ba",
    country: "Bosnia and Herzegovina (Босна и Херцеговина)",
    code: "+387"
  },
  {
    id: "bw",
    country: "Botswana",
    code: "+267"
  },
  {
    id: "br",
    country: "Brazil (Brasil)",
    code: "+55"
  },
  {
    id: "io",
    country: "British Indian Ocean Territory",
    code: "+246"
  },
  {
    id: "vg",
    country: "British Virgin Islands",
    code: "+1284"
  },
  {
    id: "bn",
    country: "Brunei",
    code: "+673"
  },
  {
    id: "bg",
    country: "Bulgaria (България)",
    code: "+359"
  },
  {
    id: "bf",
    country: "Burkina Faso",
    code: "+226"
  },
  {
    id: "bi",
    country: "Burundi (Uburundi)",
    code: "+257"
  },
  {
    id: "kh",
    country: "Cambodia (កម្ពុជា)",
    code: "+855"
  },
  {
    id: "cm",
    country: "Cameroon (Cameroun)",
    code: "+237"
  },
  {
    id: "ca",
    country: "Canada",
    code: "+1"
  },
  {
    id: "cv",
    country: "Cape Verde (Kabu Verdi)",
    code: "+238"
  },
  {
    id: "bq",
    country: "Caribbean Netherlands",
    code: "+599"
  },
  {
    id: "ky",
    country: "Cayman Islands",
    code: "+1345"
  },
  {
    id: "cf",
    country: "Central African Republic (République centrafricaine)",
    code: "+236"
  },
  {
    id: "td",
    country: "Chad (Tchad)",
    code: "+235"
  },
  {
    id: "cl",
    country: "Chile",
    code: "+56"
  },
  {
    id: "cn",
    country: "China (中国)",
    code: "+86"
  },
  {
    id: "cx",
    country: "Christmas Island",
    code: "+61"
  },
  {
    id: "cc",
    country: "Cocos (Keeling) Islands",
    code: "+61"
  },
  {
    id: "co",
    country: "Colombia",
    code: "+57"
  },
  {
    id: "km",
    country: "Comoros (‫جزر القمر‬‎)",
    code: "+269"
  },
  {
    id: "cd",
    country: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    code: "+243"
  },
  {
    id: "cg",
    country: "Congo (Republic) (Congo-Brazzaville)",
    code: "+242"
  },
  {
    id: "ck",
    country: "Cook Islands",
    code: "+682"
  },
  {
    id: "cr",
    country: "Costa Rica",
    code: "+506"
  },
  {
    id: "ci",
    country: "Côte d’Ivoire",
    code: "+225"
  },
  {
    id: "hr",
    country: "Croatia (Hrvatska)",
    code: "+385"
  },
  {
    id: "cu",
    country: "Cuba",
    code: "+53"
  },
  {
    id: "cw",
    country: "Curaçao",
    code: "+599"
  },
  {
    id: "cy",
    country: "Cyprus (Κύπρος)",
    code: "+357"
  },
  {
    id: "cz",
    country: "Czech Republic (Česká republika)",
    code: "+420"
  },
  {
    id: "dk",
    country: "Denmark (Danmark)",
    code: "+45"
  },
  {
    id: "dj",
    country: "Djibouti",
    code: "+253"
  },
  {
    id: "dm",
    country: "Dominica",
    code: "+1767"
  },
  {
    id: "do",
    country: "Dominican Republic (República Dominicana)",
    code: "+1"
  },
  {
    id: "ec",
    country: "Ecuador",
    code: "+593"
  },
  {
    id: "eg",
    country: "Egypt (‫مصر‬‎)",
    code: "+20"
  },
  {
    id: "sv",
    country: "El Salvador",
    code: "+503"
  },
  {
    id: "gq",
    country: "Equatorial Guinea (Guinea Ecuatorial)",
    code: "+240"
  },
  {
    id: "er",
    country: "Eritrea",
    code: "+291"
  },
  {
    id: "ee",
    country: "Estonia (Eesti)",
    code: "+372"
  },
  {
    id: "et",
    country: "Ethiopia",
    code: "+251"
  },
  {
    id: "fk",
    country: "Falkland Islands (Islas Malvinas)",
    code: "+500"
  },
  {
    id: "fo",
    country: "Faroe Islands (Føroyar)",
    code: "+298"
  },
  {
    id: "fj",
    country: "Fiji",
    code: "+679"
  },
  {
    id: "fi",
    country: "Finland (Suomi)",
    code: "+358"
  },
  {
    id: "fr",
    country: "France",
    code: "+33"
  },
  {
    id: "gf",
    country: "French Guiana (Guyane française)",
    code: "+594"
  },
  {
    id: "pf",
    country: "French Polynesia (Polynésie française)",
    code: "+689"
  },
  {
    id: "ga",
    country: "Gabon",
    code: "+241"
  },
  {
    id: "gm",
    country: "Gambia",
    code: "+220"
  },
  {
    id: "ge",
    country: "Georgia (საქართველო)",
    code: "+995"
  },
  {
    id: "de",
    country: "Germany (Deutschland)",
    code: "+49"
  },
  {
    id: "gh",
    country: "Ghana (Gaana)",
    code: "+233"
  },
  {
    id: "gi",
    country: "Gibraltar",
    code: "+350"
  },
  {
    id: "gr",
    country: "Greece (Ελλάδα)",
    code: "+30"
  },
  {
    id: "gl",
    country: "Greenland (Kalaallit Nunaat)",
    code: "+299"
  },
  {
    id: "gd",
    country: "Grenada",
    code: "+1473"
  },
  {
    id: "gp",
    country: "Guadeloupe",
    code: "+590"
  },
  {
    id: "gu",
    country: "Guam",
    code: "+1671"
  },
  {
    id: "gt",
    country: "Guatemala",
    code: "+502"
  },
  {
    id: "gg",
    country: "Guernsey",
    code: "+44"
  },
  {
    id: "gn",
    country: "Guinea (Guinée)",
    code: "+224"
  },
  {
    id: "gw",
    country: "Guinea-Bissau (Guiné Bissau)",
    code: "+245"
  },
  {
    id: "gy",
    country: "Guyana",
    code: "+592"
  },
  {
    id: "ht",
    country: "Haiti",
    code: "+509"
  },
  {
    id: "hn",
    country: "Honduras",
    code: "+504"
  },
  {
    id: "hk",
    country: "Hong Kong (香港)",
    code: "+852"
  },
  {
    id: "hu",
    country: "Hungary (Magyarország)",
    code: "+36"
  },
  {
    id: "is",
    country: "Iceland (Ísland)",
    code: "+354"
  },
  {
    id: "in",
    country: "India (भारत)",
    code: "+91"
  },
  {
    id: "id",
    country: "Indonesia",
    code: "+62"
  },
  {
    id: "ir",
    country: "Iran (‫ایران‬‎)",
    code: "+98"
  },
  {
    id: "iq",
    country: "Iraq (‫العراق‬‎)",
    code: "+964"
  },
  {
    id: "ie",
    country: "Ireland",
    code: "+353"
  },
  {
    id: "im",
    country: "Isle of Man",
    code: "+44"
  },
  {
    id: "il",
    country: "Israel (‫ישראל‬‎)",
    code: "+972"
  },
  {
    id: "it",
    country: "Italy (Italia)",
    code: "+39"
  },
  {
    id: "jm",
    country: "Jamaica",
    code: "+1876"
  },
  {
    id: "jp",
    country: "Japan (日本)",
    code: "+81"
  },
  {
    id: "je",
    country: "Jersey",
    code: "+44"
  },
  {
    id: "jo",
    country: "Jordan (‫الأردن‬‎)",
    code: "+962"
  },
  {
    id: "kz",
    country: "Kazakhstan (Казахстан)",
    code: "+7"
  },
  {
    id: "ke",
    country: "Kenya",
    code: "+254"
  },
  {
    id: "ki",
    country: "Kiribati",
    code: "+686"
  },
  {
    id: "xk",
    country: "Kosovo",
    code: "+383"
  },
  {
    id: "kw",
    country: "Kuwait (‫الكويت‬‎)",
    code: "+965"
  },
  {
    id: "kg",
    country: "Kyrgyzstan (Кыргызстан)",
    code: "+996"
  },
  {
    id: "la",
    country: "Laos (ລາວ)",
    code: "+856"
  },
  {
    id: "lv",
    country: "Latvia (Latvija)",
    code: "+371"
  },
  {
    id: "lb",
    country: "Lebanon (‫لبنان‬‎)",
    code: "+961"
  },
  {
    id: "ls",
    country: "Lesotho",
    code: "+266"
  },
  {
    id: "lr",
    country: "Liberia",
    code: "+231"
  },
  {
    id: "ly",
    country: "Libya (‫ليبيا‬‎)",
    code: "+218"
  },
  {
    id: "li",
    country: "Liechtenstein",
    code: "+423"
  },
  {
    id: "lt",
    country: "Lithuania (Lietuva)",
    code: "+370"
  },
  {
    id: "lu",
    country: "Luxembourg",
    code: "+352"
  },
  {
    id: "mo",
    country: "Macau (澳門)",
    code: "+853"
  },
  {
    id: "mk",
    country: "Macedonia (FYROM) (Македонија)",
    code: "+389"
  },
  {
    id: "mg",
    country: "Madagascar (Madagasikara)",
    code: "+261"
  },
  {
    id: "mw",
    country: "Malawi",
    code: "+265"
  },
  {
    id: "my",
    country: "Malaysia",
    code: "+60"
  },
  {
    id: "mv",
    country: "Maldives",
    code: "+960"
  },
  {
    id: "ml",
    country: "Mali",
    code: "+223"
  },
  {
    id: "mt",
    country: "Malta",
    code: "+356"
  },
  {
    id: "mh",
    country: "Marshall Islands",
    code: "+692"
  },
  {
    id: "mq",
    country: "Martinique",
    code: "+596"
  },
  {
    id: "mr",
    country: "Mauritania (‫موريتانيا‬‎)",
    code: "+222"
  },
  {
    id: "mu",
    country: "Mauritius (Moris)",
    code: "+230"
  },
  {
    id: "yt",
    country: "Mayotte",
    code: "+262"
  },
  {
    id: "mx",
    country: "Mexico (México)",
    code: "+52"
  },
  {
    id: "fm",
    country: "Micronesia",
    code: "+691"
  },
  {
    id: "md",
    country: "Moldova (Republica Moldova)",
    code: "+373"
  },
  {
    id: "mc",
    country: "Monaco",
    code: "+377"
  },
  {
    id: "mn",
    country: "Mongolia (Монгол)",
    code: "+976"
  },
  {
    id: "me",
    country: "Montenegro (Crna Gora)",
    code: "+382"
  },
  {
    id: "ms",
    country: "Montserrat",
    code: "+1664"
  },
  {
    id: "ma",
    country: "Morocco (‫المغرب‬‎)",
    code: "+212"
  },
  {
    id: "mz",
    country: "Mozambique (Moçambique)",
    code: "+258"
  },
  {
    id: "mm",
    country: "Myanmar (Burma) (မြန်မာ)",
    code: "+95"
  },
  {
    id: "na",
    country: "Namibia (Namibië)",
    code: "+264"
  },
  {
    id: "nr",
    country: "Nauru",
    code: "+674"
  },
  {
    id: "np",
    country: "Nepal (नेपाल)",
    code: "+977"
  },
  {
    id: "nl",
    country: "Netherlands (Nederland)",
    code: "+31"
  },
  {
    id: "nc",
    country: "New Caledonia (Nouvelle-Calédonie)",
    code: "+687"
  },
  {
    id: "nz",
    country: "New Zealand",
    code: "+64"
  },
  {
    id: "ni",
    country: "Nicaragua",
    code: "+505"
  },
  {
    id: "ne",
    country: "Niger (Nijar)",
    code: "+227"
  },
  {
    id: "ng",
    country: "Nigeria",
    code: "+234"
  },
  {
    id: "nu",
    country: "Niue",
    code: "+683"
  },
  {
    id: "nf",
    country: "Norfolk Island",
    code: "+672"
  },
  {
    id: "kp",
    country: "North Korea (조선 민주주의 인민 공화국)",
    code: "+850"
  },
  {
    id: "mp",
    country: "Northern Mariana Islands",
    code: "+1670"
  },
  {
    id: "no",
    country: "Norway (Norge)",
    code: "+47"
  },
  {
    id: "om",
    country: "Oman (‫عُمان‬‎)",
    code: "+968"
  },
  {
    id: "pk",
    country: "Pakistan (‫پاکستان‬‎)",
    code: "+92"
  },
  {
    id: "pw",
    country: "Palau",
    code: "+680"
  },
  {
    id: "ps",
    country: "Palestine (‫فلسطين‬‎)",
    code: "+970"
  },
  {
    id: "pa",
    country: "Panama (Panamá)",
    code: "+507"
  },
  {
    id: "pg",
    country: "Papua New Guinea",
    code: "+675"
  },
  {
    id: "py",
    country: "Paraguay",
    code: "+595"
  },
  {
    id: "pe",
    country: "Peru (Perú)",
    code: "+51"
  },
  {
    id: "ph",
    country: "Philippines",
    code: "+63"
  },
  {
    id: "pl",
    country: "Poland (Polska)",
    code: "+48"
  },
  {
    id: "pt",
    country: "Portugal",
    code: "+351"
  },
  {
    id: "pr",
    country: "Puerto Rico",
    code: "+1"
  },
  {
    id: "qa",
    country: "Qatar (‫قطر‬‎)",
    code: "+974"
  },
  {
    id: "re",
    country: "Réunion (La Réunion)",
    code: "+262"
  },
  {
    id: "ro",
    country: "Romania (România)",
    code: "+40"
  },
  {
    id: "ru",
    country: "Russia (Россия)",
    code: "+7"
  },
  {
    id: "rw",
    country: "Rwanda",
    code: "+250"
  },
  {
    id: "bl",
    country: "Saint Barthélemy",
    code: "+590"
  },
  {
    id: "sh",
    country: "Saint Helena",
    code: "+290"
  },
  {
    id: "kn",
    country: "Saint Kitts and Nevis",
    code: "+1869"
  },
  {
    id: "lc",
    country: "Saint Lucia",
    code: "+1758"
  },
  {
    id: "mf",
    country: "Saint Martin (Saint-Martin (partie française))",
    code: "+590"
  },
  {
    id: "pm",
    country: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    code: "+508"
  },
  {
    id: "vc",
    country: "Saint Vincent and the Grenadines",
    code: "+1784"
  },
  {
    id: "ws",
    country: "Samoa",
    code: "+685"
  },
  {
    id: "sm",
    country: "San Marino",
    code: "+378"
  },
  {
    id: "st",
    country: "São Tomé and Príncipe (São Tomé e Príncipe)",
    code: "+239"
  },
  {
    id: "sa",
    country: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    code: "+966"
  },
  {
    id: "sn",
    country: "Senegal (Sénégal)",
    code: "+221"
  },
  {
    id: "rs",
    country: "Serbia (Србија)",
    code: "+381"
  },
  {
    id: "sc",
    country: "Seychelles",
    code: "+248"
  },
  {
    id: "sl",
    country: "Sierra Leone",
    code: "+232"
  },
  {
    id: "sg",
    country: "Singapore",
    code: "+65"
  },
  {
    id: "sx",
    country: "Sint Maarten",
    code: "+1721"
  },
  {
    id: "sk",
    country: "Slovakia (Slovensko)",
    code: "+421"
  },
  {
    id: "si",
    country: "Slovenia (Slovenija)",
    code: "+386"
  },
  {
    id: "sb",
    country: "Solomon Islands",
    code: "+677"
  },
  {
    id: "so",
    country: "Somalia (Soomaaliya)",
    code: "+252"
  },
  {
    id: "za",
    country: "South Africa",
    code: "+27"
  },
  {
    id: "kr",
    country: "South Korea (대한민국)",
    code: "+82"
  },
  {
    id: "ss",
    country: "South Sudan (‫جنوب السودان‬‎)",
    code: "+211"
  },
  {
    id: "es",
    country: "Spain (España)",
    code: "+34"
  },
  {
    id: "lk",
    country: "Sri Lanka (ශ්‍රී ලංකාව)",
    code: "+94"
  },
  {
    id: "sd",
    country: "Sudan (‫السودان‬‎)",
    code: "+249"
  },
  {
    id: "sr",
    country: "Suriname",
    code: "+597"
  },
  {
    id: "sj",
    country: "Svalbard and Jan Mayen",
    code: "+47"
  },
  {
    id: "sz",
    country: "Swaziland",
    code: "+268"
  },
  {
    id: "se",
    country: "Sweden (Sverige)",
    code: "+46"
  },
  {
    id: "ch",
    country: "Switzerland (Schweiz)",
    code: "+41"
  },
  {
    id: "sy",
    country: "Syria (‫سوريا‬‎)",
    code: "+963"
  },
  {
    id: "tw",
    country: "Taiwan (台灣)",
    code: "+886"
  },
  {
    id: "tj",
    country: "Tajikistan",
    code: "+992"
  },
  {
    id: "tz",
    country: "Tanzania",
    code: "+255"
  },
  {
    id: "th",
    country: "Thailand (ไทย)",
    code: "+66"
  },
  {
    id: "tl",
    country: "Timor-Leste",
    code: "+670"
  },
  {
    id: "tg",
    country: "Togo",
    code: "+228"
  },
  {
    id: "tk",
    country: "Tokelau",
    code: "+690"
  },
  {
    id: "to",
    country: "Tonga",
    code: "+676"
  },
  {
    id: "tt",
    country: "Trinidad and Tobago",
    code: "+1868"
  },
  {
    id: "tn",
    country: "Tunisia (‫تونس‬‎)",
    code: "+216"
  },
  {
    id: "tr",
    country: "Turkey (Türkiye)",
    code: "+90"
  },
  {
    id: "tm",
    country: "Turkmenistan",
    code: "+993"
  },
  {
    id: "tc",
    country: "Turks and Caicos Islands",
    code: "+1649"
  },
  {
    id: "tv",
    country: "Tuvalu",
    code: "+688"
  },
  {
    id: "vi",
    country: "U.S. Virgin Islands",
    code: "+1340"
  },
  {
    id: "ug",
    country: "Uganda",
    code: "+256"
  },
  {
    id: "ua",
    country: "Ukraine (Україна)",
    code: "+380"
  },
  {
    id: "ae",
    country: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    code: "+971"
  },
  {
    id: "gb",
    country: "United Kingdom",
    code: "+44"
  },
  {
    id: "us",
    country: "United States",
    code: "+1"
  },
  {
    id: "uy",
    country: "Uruguay",
    code: "+598"
  },
  {
    id: "uz",
    country: "Uzbekistan (Oʻzbekiston)",
    code: "+998"
  },
  {
    id: "vu",
    country: "Vanuatu",
    code: "+678"
  },
  {
    id: "va",
    country: "Vatican City (Città del Vaticano)",
    code: "+39"
  },
  {
    id: "ve",
    country: "Venezuela",
    code: "+58"
  },
  {
    id: "vn",
    country: "Vietnam (Việt Nam)",
    code: "+84"
  },
  {
    id: "wf",
    country: "Wallis and Futuna (Wallis-et-Futuna)",
    code: "+681"
  },
  {
    id: "eh",
    country: "Western Sahara (‫الصحراء الغربية‬‎)",
    code: "+212"
  },
  {
    id: "ye",
    country: "Yemen (‫اليمن‬‎)",
    code: "+967"
  },
  {
    id: "zm",
    country: "Zambia",
    code: "+260"
  },
  {
    id: "zw",
    country: "Zimbabwe",
    code: "+263"
  },
  {
    id: "ax",
    country: "Åland Islands",
    code: "+358"
  }
];
const _hoisted_1$5 = { class: "ws-phone-input ws-field" };
const _hoisted_2$4 = {
  key: 0,
  class: "q-field__bottom ws-phone-input__bottom"
};
const _hoisted_3$3 = { class: "q-field__messages ws-phone-input__messages" };
const UPDATE_MODEL_VALUE = "update:modelValue";
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "WsPhoneInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    restrict: {
      type: String,
      default: "0-9 +"
    },
    optionalText: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "input"],
  setup(__props, { emit: __emit }) {
    const preferredPrefixes = {
      HU: ["SK", "CZ", "SE"],
      SK: ["CZ", "HU", "SE"],
      CZ: ["SK", "HU", "SE"],
      SE: ["NO", "DE", "FI"]
    };
    const props = __props;
    const emits = __emit;
    const slots = useSlots();
    const attrs = useAttrs();
    const { t } = useI18n();
    const options = computed(
      () => phonePrefixes.map((prefix2) => ({
        ...prefix2,
        label: `${prefix2.country} (${prefix2.id})`.toLowerCase()
      }))
    );
    const phoneNumber = ref(props.modelValue);
    const prefix = ref(options.value[0]);
    const numOfSuggested = ref(0);
    const suggestedAdded = ref(false);
    const fullValue = ref("");
    const preferredOptions = ref([]);
    const input = ref(null);
    const select = ref(null);
    const hasMessage = ref(false);
    const message = ref("");
    const isSelectOpen = ref(false);
    const onUpdate = (event) => {
      emits(UPDATE_MODEL_VALUE, event);
    };
    const findPrefixByCountry = (country) => {
      const id = country.toLowerCase();
      return options.value.find((prefix2) => prefix2.id === id);
    };
    const addPreferred = (countries) => {
      countries.forEach((country) => {
        const countryPrefix = findPrefixByCountry(country);
        if (countryPrefix) {
          preferredOptions.value.push(countryPrefix);
        }
      });
      return preferredOptions;
    };
    const presetPrefixes = () => {
      const countryId = config$1.companyCountry;
      if (!props.modelValue) {
        prefix.value = findPrefixByCountry(countryId) || options.value[0];
      }
      const countries = preferredPrefixes[countryId] || [];
      if (!suggestedAdded.value) {
        addPreferred(countries);
        preferredOptions.value.unshift(prefix.value);
      }
      numOfSuggested.value = countries.length + 1;
      suggestedAdded.value = true;
    };
    const sortedOptions = computed(() => {
      const preferredCountries = preferredOptions.value.map((option) => option.country);
      const filteredOptions = options.value.filter((option) => !preferredCountries.includes(option.country));
      return [...preferredOptions.value, ...filteredOptions];
    });
    const cleanPhoneNumber = (number) => {
      return number.replace(/^00/, "+").replace(/(\s|\.|-)/g, "");
    };
    const extractPrefixFromNumber = (number) => {
      if (number.startsWith("+")) {
        return getPrefixFromNumber(number);
      }
      return null;
    };
    const getPrefixFromNumber = (value) => {
      const foundIndex = phonePrefixes.findIndex(
        (prefix2) => value.startsWith(prefix2.code)
      );
      return foundIndex > -1 ? phonePrefixes[foundIndex] : null;
    };
    const validate = () => {
      const isValid = phoneNumber.value.match(/^[0-9]+$/) !== null;
      hasMessage.value = !isValid;
      message.value = isValid ? "" : t("uikit:ws_input.invalid_phone_number");
    };
    const updatePhoneNumber = debounce$1(() => {
      var _a, _b, _c;
      let newNumber = cleanPhoneNumber(phoneNumber.value);
      const newPrefix = extractPrefixFromNumber(newNumber);
      if (newPrefix) {
        prefix.value = newPrefix;
        newNumber = newNumber.replace(newPrefix.code, "");
      }
      phoneNumber.value = newNumber;
      validate();
      (_b = (_a = input.value) == null ? void 0 : _a.$el) == null ? void 0 : _b.focus();
      if (hasMessage.value) {
        return;
      }
      const newFullValue = phoneNumber.value ? `${(_c = prefix.value) == null ? void 0 : _c.code} ${phoneNumber.value}` : "";
      if (fullValue.value !== newFullValue) {
        fullValue.value = newFullValue;
        emits(UPDATE_MODEL_VALUE, fullValue.value);
      }
    }, 100);
    const handleEnterInPhoneInput = () => {
      if (select.value) {
        select.value.showPopup();
      }
    };
    const isEmptyMobileInput = computed(() => !phoneNumber.value || phoneNumber.value.length === 0);
    const showErrorIfNeeded = () => {
      if (!isSelectOpen.value && isEmptyMobileInput.value) {
        hasMessage.value = true;
        message.value = t("phone_missing");
      }
    };
    const onInputBlur = () => {
      setTimeout(showErrorIfNeeded, 200);
    };
    const onPopupHide = () => {
      setTimeout(() => {
        isSelectOpen.value = false;
      }, 200);
    };
    const onPopupShow = () => {
      nextTick(() => {
        var _a, _b;
        (_a = select.value) == null ? void 0 : _a.focus();
        (_b = document.activeElement) == null ? void 0 : _b.blur();
        isSelectOpen.value = true;
      });
    };
    const onSelectOption = () => {
      nextTick(() => {
        var _a, _b;
        (_a = select.value) == null ? void 0 : _a.hidePopup();
        (_b = input.value) == null ? void 0 : _b.focus();
      });
    };
    onMounted(() => {
      presetPrefixes();
    });
    watch(
      [() => props.modelValue, phoneNumber, prefix],
      () => {
        if (phoneNumber.value) {
          updatePhoneNumber();
        }
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$5, [
        createVNode(WsInput, mergeProps({
          ref_key: "input",
          ref: input
        }, unref(attrs), {
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event) => phoneNumber.value = $event),
            onUpdate
          ],
          error: hasMessage.value,
          "hide-bottom-space": "",
          autocomplete: "tel-national",
          restrict: __props.restrict,
          class: "with-phone-prefix-select",
          onBlur: onInputBlur
        }), createSlots({
          prepend: withCtx(() => [
            prefix.value ? (openBlock(), createBlock(WsSelect, {
              key: 0,
              ref_key: "select",
              ref: select,
              modelValue: prefix.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => prefix.value = $event),
                onSelectOption
              ],
              options: sortedOptions.value,
              class: "ws-phone-prefix-select",
              "popup-content-class": "ws-phone-prefix-select-content",
              "option-value": "code",
              "option-label": "id",
              "option-description": "description",
              "transition-show": "jump-down",
              "transition-hide": "jump-up",
              "hide-bottom-space": "",
              autocomplete: "tel-country-code",
              tabindex: "0",
              onKeydown: withKeys(handleEnterInPhoneInput, ["enter"]),
              onPopupShow,
              onPopupHide
            }, {
              "selected-item": withCtx((scope) => [
                (openBlock(), createBlock(WsCountryFlag, {
                  key: scope.opt.id,
                  country: scope.opt.id,
                  class: "q-mr-sm"
                }, null, 8, ["country"])),
                createTextVNode(" " + toDisplayString(scope.opt.code), 1)
              ]),
              option: withCtx(({ scope }) => [
                scope.index === numOfSuggested.value ? (openBlock(), createBlock(QSeparator, { key: 0 })) : createCommentVNode("", true),
                createVNode(QItem, mergeProps(scope.itemProps, toHandlers(scope.itemEvents)), {
                  default: withCtx(() => [
                    createVNode(QItemSection, { avatar: "" }, {
                      default: withCtx(() => [
                        (openBlock(), createBlock(WsCountryFlag, {
                          key: scope.opt.id,
                          country: scope.opt.id
                        }, null, 8, ["country"]))
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(QItemSection, null, {
                      default: withCtx(() => [
                        createVNode(QItemLabel, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(scope.opt.code), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(QItemLabel, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(scope.opt.country), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, [
          renderList(unref(slots), (slot, name) => {
            return {
              name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(scope)), void 0, true)
              ])
            };
          })
        ]), 1040, ["modelValue", "error", "restrict"]),
        message.value ? (openBlock(), createElementBlock("div", _hoisted_2$4, [
          createElementVNode("div", _hoisted_3$3, toDisplayString(message.value), 1)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const WsPhoneInput = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-97bc9290"]]);
const _hoisted_1$4 = { class: "ws-radio__input-wrapper" };
const _hoisted_2$3 = ["id", "name", "value", "checked", "disabled"];
const _hoisted_3$2 = { class: "ws-radio__label" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
  key: 0,
  class: "ws-radio__description"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "WsRadio",
  props: {
    modelValue: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    val: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    value: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: (props) => props.large ? "lg" : "md"
    },
    color: {
      type: String,
      default: "green"
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: void 0
    },
    path: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["input", "dirty", "update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const slots = useSlots();
    const emit = __emit;
    const messages = ref([]);
    const { subscribeMessage } = useMessages();
    subscribeMessage(props.path, (message) => {
      messages.value.push({
        ...message.payload,
        text: message.value || message.payload.text
      });
    });
    const formDataOverride = inject("formDataOverride", null);
    const isTrue = computed(() => toRaw(props.modelValue) === toRaw(props.val));
    const onChange = () => {
      if (formDataOverride) {
        formDataOverride[props.name] = props.val;
      }
      emit("input", props.val);
      emit("update:modelValue", props.val);
      emit("dirty", props.val);
    };
    return (_ctx, _cache) => {
      var _a;
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("label", mergeProps({
        class: ["ws-radio", [
          __props.disable ? "disabled" : "active",
          isTrue.value ? "ws-radio--checked" : "",
          "ws-radio--color-" + __props.color,
          "ws-radio--size-" + __props.size
        ]]
      }, _ctx.$attrs), [
        createElementVNode("span", _hoisted_1$4, [
          createElementVNode("input", {
            id: __props.id,
            type: "radio",
            class: "ws-radio__native",
            name: __props.name,
            value: __props.val,
            checked: isTrue.value,
            disabled: __props.disable,
            onChange
          }, null, 40, _hoisted_2$3)
        ]),
        createElementVNode("span", _hoisted_3$2, [
          createVNode(_component_portal_slot, {
            slot: unref(slots)["default"],
            key: "default",
            name: "default",
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"]),
          createVNode(_component_portal_slot, {
            slot: unref(slots)["label"],
            key: "label",
            name: "label",
            "component-id": _ctx.$attrs["component-id"]
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.label), 1)
            ]),
            _: 1
          }, 8, ["slot", "component-id"]),
          __props.tooltip ? (openBlock(), createElementBlock("span", _hoisted_4, [
            createVNode(WsIcon, {
              name: "info",
              class: "text-ws-navy-80"
            }),
            createVNode(_sfc_main$B, null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.tooltip), 1)
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true)
        ]),
        ((_a = __props.portalSlots) == null ? void 0 : _a.includes("description")) ? (openBlock(), createElementBlock("span", _hoisted_5, [
          createVNode(_component_portal_slot, {
            slot: unref(slots)["description"],
            key: "description",
            name: "description",
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
var WsRadioColors = /* @__PURE__ */ ((WsRadioColors2) => {
  WsRadioColors2["BLUE"] = "blue";
  WsRadioColors2["GREEN"] = "green";
  return WsRadioColors2;
})(WsRadioColors || {});
const WsRadioColors$1 = WsRadioColors;
const _hoisted_1$3 = { class: "ws-placeholder-loader q-pa-sm" };
const _hoisted_2$2 = {
  key: 0,
  class: "title text-ws-navy-100 text-center q-mb-sm"
};
const _hoisted_3$1 = {
  key: 1,
  class: "subtitle text-ws-navy-80 text-center q-mb-none"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "WsPlaceholderLoader",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    subtitle: {
      type: String,
      required: false,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_ws_spinner = resolveComponent("ws-spinner");
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        createVNode(_component_ws_spinner, {
          color: "blue",
          width: "40px",
          style: { "margin-bottom": "12px" }
        }),
        __props.title ? (openBlock(), createElementBlock("p", _hoisted_2$2, toDisplayString(__props.title), 1)) : createCommentVNode("", true),
        __props.subtitle ? (openBlock(), createElementBlock("p", _hoisted_3$1, toDisplayString(__props.subtitle), 1)) : createCommentVNode("", true)
      ]);
    };
  }
});
const WsPlaceholderLoader = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-6f29e2a9"]]);
const _hoisted_1$2 = ["innerHTML"];
const _hoisted_2$1 = { class: "list" };
const _hoisted_3 = ["innerHTML"];
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "WsSelectOptionWithList",
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["ws-select-option-with-list", { "border q-px-md q-py-sm": __props.border }])
      }, [
        createElementVNode("p", {
          class: "title",
          innerHTML: unref(xss)(__props.option.label)
        }, null, 8, _hoisted_1$2),
        createElementVNode("ul", _hoisted_2$1, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.option.items, (item) => {
            return openBlock(), createElementBlock("li", {
              key: item,
              innerHTML: unref(xss)(item)
            }, null, 8, _hoisted_3);
          }), 128))
        ])
      ], 2);
    };
  }
});
const WsSelectOptionWithList = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-a2bc9e91"]]);
const _hoisted_1$1 = { class: "heading q-mb-sm" };
const _hoisted_2 = { class: "description" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "WsEmptyMarkupTable",
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", mergeProps({ class: "ws-empty-markup-table text-center q-px-lg q-py-xl" }, _ctx.$attrs), [
        createElementVNode("p", _hoisted_1$1, [
          createVNode(_component_portal_slot, {
            slot: unref(slots).heading,
            "component-id": _ctx.$attrs["component-id"],
            name: "heading"
          }, null, 8, ["slot", "component-id"])
        ]),
        createElementVNode("p", _hoisted_2, [
          createVNode(_component_portal_slot, {
            slot: unref(slots).description,
            "component-id": _ctx.$attrs["component-id"],
            name: "description"
          }, null, 8, ["slot", "component-id"])
        ]),
        createVNode(_component_portal_slot, {
          slot: unref(slots).actions,
          "component-id": _ctx.$attrs["component-id"],
          name: "actions"
        }, null, 8, ["slot", "component-id"])
      ], 16);
    };
  }
});
const WsEmptyMarkupTable = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-a07d76ca"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "WsMarkupTable",
  props: {
    noSidePadding: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", mergeProps({
        class: ["ws-markup-table", { "ws-markup-table--no-side-padding": __props.noSidePadding }]
      }, _ctx.$attrs), [
        createVNode(_component_portal_slot, {
          slot: unref(slots).default,
          "component-id": _ctx.$attrs["component-id"]
        }, null, 8, ["slot", "component-id"])
      ], 16);
    };
  }
});
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "WsTag",
  props: {
    bg: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const slots = useSlots();
    const attrs = useAttrs();
    const props = __props;
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("div", mergeProps(unref(attrs), {
        class: ["ws-tag", [
          props.bg ? "bg-" + props.bg : "",
          props.color ? "text-" + props.color : "",
          props.type ? "badge-type-" + props.type : ""
        ]]
      }), [
        createVNode(_component_portal_slot, {
          slot: unref(slots).default,
          "component-id": _ctx.$attrs["component-id"]
        }, null, 8, ["slot", "component-id"])
      ], 16);
    };
  }
});
const WsTag = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["__scopeId", "data-v-fc0bcded"]]);
var Type = /* @__PURE__ */ ((Type2) => {
  Type2["danger"] = "danger";
  Type2["base"] = "base";
  Type2["positive"] = "positive";
  Type2["neutral"] = "neutral";
  Type2["alert"] = "alert";
  Type2["dark"] = "dark";
  Type2["basic"] = "basic";
  Type2["advanced"] = "advanced";
  Type2["premium"] = "premium";
  return Type2;
})(Type || {});
const WsTagEnum = {
  Type
};
function fallback(text) {
  const area = document.createElement("textarea");
  area.value = text;
  area.contentEditable = "true";
  area.style.position = "fixed";
  const fn = () => {
  };
  addFocusout(fn);
  document.body.appendChild(area);
  area.focus();
  area.select();
  const res = document.execCommand("copy");
  area.remove();
  removeFocusout(fn);
  return res;
}
function copyToClipboard(text) {
  return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(text) : new Promise((resolve, reject) => {
    const res = fallback(text);
    if (res) {
      resolve(true);
    } else {
      reject(res);
    }
  });
}
const _hoisted_1 = { class: "ws-copy__content" };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "WsCopy",
  props: {
    modelValue: { type: String, default: "" },
    fullWidth: { type: Boolean, default: false }
  },
  setup(__props) {
    var _a;
    const props = __props;
    const attrs = useAttrs();
    const slots = useSlots();
    const copied = ref(false);
    const showTooltip = ref(false);
    let timeoutRef = null;
    let copiedTimeoutRef = null;
    const hasDefaultSlot = !!(slots.default || ((_a = attrs.portalSlots) == null ? void 0 : _a.includes("default")));
    const copy = async () => {
      let copyValue = props.modelValue;
      if (!copyValue) {
        copyValue = get(slots, "default[0].elm.data", "");
      }
      copyToClipboard(copyValue).then(() => {
        copied.value = true;
        showTooltip.value = true;
        timeoutRef = setTimeout(() => {
          showTooltip.value = false;
        }, 5e3);
        copiedTimeoutRef = setTimeout(() => {
          copied.value = false;
        }, 6e3);
      }).catch((e) => {
        console.error(e);
      });
    };
    const toggleTooltip = (value) => {
      if (copied.value) {
        return;
      }
      showTooltip.value = value;
    };
    onBeforeUnmount(() => {
      clearTimeout(timeoutRef);
      clearTimeout(copiedTimeoutRef);
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return hasDefaultSlot ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["ws-copy", { "ws-copy--full-width": __props.fullWidth }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(_component_portal_slot, {
            slot: unref(slots).default,
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ]),
        createElementVNode("button", {
          class: "ws-copy__button",
          "data-test": "button",
          onClick: copy,
          onFocus: _cache[0] || (_cache[0] = ($event) => toggleTooltip(true)),
          onFocusout: _cache[1] || (_cache[1] = ($event) => toggleTooltip(false)),
          onMouseenter: _cache[2] || (_cache[2] = ($event) => toggleTooltip(true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event) => toggleTooltip(false))
        }, [
          createVNode(WsIcon, {
            name: copied.value ? "success" : "copy",
            width: 16,
            height: 16
          }, null, 8, ["name"]),
          createVNode(_sfc_main$B, {
            ref: "tooltip",
            "model-value": showTooltip.value,
            offset: [8, 8],
            anchor: "bottom right",
            self: "top right"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(copied.value ? _ctx.$t("uikit:copy.saved_in_clipboard") : _ctx.$t("uikit:copy.copy")), 1)
            ]),
            _: 1
          }, 8, ["model-value"])
        ], 32)
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const WsCopy = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-66903428"]]);
function useQuasar() {
  return inject(quasarKey);
}
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "WsButtonDropdown",
  props: {
    a11yHideFocusElSel: {
      type: String,
      required: false,
      default: null
    },
    a11yLastItemFocusElSel: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: {
    "hide": (evt) => evt instanceof Event,
    "input": (evt) => evt instanceof Event,
    "show": (evt) => evt instanceof Event,
    "before-hide": (evt) => evt instanceof Event,
    "before-show": (evt) => evt instanceof Event,
    "click": (evt) => evt instanceof Event
  },
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const attrs = useAttrs();
    const slots = useSlots();
    const quasar = useQuasar();
    const quasarDropdownEl = ref(null);
    const dropdownIcon = computed(() => {
      var _a, _b;
      if (typeof attrs["dropdown-icon"] !== "undefined") {
        return attrs["dropdown-icon"];
      }
      if ((_b = (_a = quasar == null ? void 0 : quasar.iconSet) == null ? void 0 : _a.arrow) == null ? void 0 : _b.down) {
        return quasar.iconSet.arrow.down;
      }
      return "none";
    });
    const focusOnElement = (selector) => {
      if (typeof selector === "undefined") {
        return;
      }
      const element = document.querySelector(
        `${selector} button[role="button"]`
      );
      if (!element) {
        return;
      }
      element.focus({ focusVisible: true });
    };
    const onHide = (event) => {
      if (typeof event === "undefined") {
        return;
      }
      emit("hide", event);
      if (!(event instanceof FocusEvent)) {
        return;
      }
      focusOnElement(props.a11yHideFocusElSel);
    };
    const onKeyDown = (event) => {
      if (event.key === "Tab" && !event.shiftKey) {
        const focusableElements = '.button-dropdown__list a, .button-dropdown__list [tabindex]:not([tabindex="-1"])';
        const elements = document.querySelectorAll(focusableElements);
        const lastElement = elements[elements.length - 1];
        if (document.activeElement === lastElement) {
          event.preventDefault();
          if (quasarDropdownEl.value) {
            quasarDropdownEl.value.hide();
          }
          focusOnElement(props.a11yLastItemFocusElSel);
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createBlock(QBtnDropdown, mergeProps({
        ref_key: "quasarDropdownEl",
        ref: quasarDropdownEl,
        "component-id": unref(attrs)["component-id"]
      }, unref(attrs), {
        "dropdown-icon": dropdownIcon.value,
        "close-on-iframe-click": "",
        onHide,
        onInput: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("input", $event)),
        onShow: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("show", $event)),
        onBeforeHide: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("before-hide", $event)),
        onBeforeShow: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("before-show", $event)),
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("click", $event))
      }), {
        label: withCtx(() => [
          createVNode(_component_portal_slot, {
            slot: unref(slots).label,
            "component-id": unref(attrs)["component-id"],
            name: "label"
          }, null, 8, ["slot", "component-id"])
        ]),
        loading: withCtx(() => [
          createVNode(_component_portal_slot, {
            slot: unref(slots).loading,
            "component-id": unref(attrs)["component-id"],
            name: "loading"
          }, null, 8, ["slot", "component-id"])
        ]),
        default: withCtx(() => [
          createElementVNode("button", {
            class: "button-dropdown__list remove-button-defaults",
            onKeydown: _cache[0] || (_cache[0] = ($event) => onKeyDown($event))
          }, [
            createVNode(_component_portal_slot, {
              slot: unref(slots).default,
              "component-id": unref(attrs)["component-id"],
              name: "default"
            }, null, 8, ["slot", "component-id"])
          ], 32)
        ]),
        _: 1
      }, 16, ["component-id", "dropdown-icon"]);
    };
  }
});
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WsPlacesInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    secondaryInfo: {
      type: String,
      default: ""
    }
  },
  emits: ["input", "address"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const attrs = useAttrs();
    const props = __props;
    const optionSelected = ref("");
    const searchResults = ref([]);
    const query = ref("");
    let latestCall = null;
    let userSelectedAddress = false;
    let queryWithoutNumbers = "";
    let queryNumberParts = "";
    const { getPlacePredictions, getPlaceAddress, askForLocation } = useGoogleAPI();
    const hasNumber = (val) => {
      return /[0-9]/.test(val);
    };
    const filter = (v, update2) => {
      update2();
    };
    const onSelectedChanged = (selected) => {
      if (!selected || !searchResults.value) {
        return;
      }
      const selectedOption = searchResults.value.find(
        (result) => result.description === selected
      );
      if (selectedOption) {
        getAddress(selectedOption);
      }
    };
    const handleNoSelected = () => {
      if (userSelectedAddress) {
        return;
      }
      if (latestCall) {
        latestCall.then((results) => {
          const description = get(results, "[0].description");
          onSelectedChanged(description);
        });
      }
    };
    askForLocation();
    const options = computed(() => {
      var _a;
      if ((_a = searchResults.value) == null ? void 0 : _a.length) {
        return searchResults.value.map(
          (result) => result == null ? void 0 : result.description
        );
      }
      return [];
    });
    watch(
      () => props.value,
      (value) => {
        if (optionSelected.value !== value) {
          optionSelected.value = value;
        }
      },
      { immediate: true }
    );
    watch(
      query,
      (input) => {
        var _a;
        emit("input", input);
        if (query.value.length < 2) {
          userSelectedAddress = false;
        }
        if (!query.value) {
          query.value = "";
          queryWithoutNumbers = "";
          queryNumberParts = "";
          searchResults.value = [];
          return;
        }
        if ((_a = searchResults.value) == null ? void 0 : _a.some((result) => result.description === input)) {
          return;
        }
        queryWithoutNumbers = input.split(" ").filter((part) => !hasNumber(part) ? part : void 0).join(" ") + " ";
        queryNumberParts = input.split(" ").filter((part) => hasNumber(part) ? part : void 0).join(" ");
        query.value = input;
        innerGetPredictions();
      }
    );
    const getAddress = throttle$1(
      (optObj) => {
        getPlaceAddress(optObj.place_id).then((data) => {
          data.query = query.value;
          data.queryWithoutNumbers = queryWithoutNumbers;
          data.queryNumberParts = queryNumberParts;
          userSelectedAddress = true;
          emit("address", data);
        });
      },
      100,
      { trailing: true }
    );
    const innerGetPredictions = throttle$1(
      () => {
        if (!queryWithoutNumbers) {
          return;
        }
        const query2 = `${props.secondaryInfo}, ${queryWithoutNumbers}`;
        latestCall = Promise.all([
          getPlacePredictions(query2, "geocode"),
          getPlacePredictions(queryWithoutNumbers, "(regions)")
        ]).then((results) => {
          results = results[0].concat(results[1]);
          searchResults.value = results.map((result) => {
            const secondary = get(result, "structured_formatting.secondary_text");
            const parts = result.description.split(",").concat(secondary.split(",")).map((part) => {
              var _a;
              return (_a = part.trim) == null ? void 0 : _a.call(part);
            });
            result.ws_label = uniq(parts).join(", ");
            return result;
          });
          return searchResults;
        }).catch((e) => {
          console.log("Error while fetching predictions", e);
          searchResults.value = [];
        });
      },
      100,
      { trailing: true }
    );
    watch(
      optionSelected,
      onSelectedChanged
    );
    return (_ctx, _cache) => {
      const _component_ws_select = resolveComponent("ws-select");
      return openBlock(), createBlock(_component_ws_select, mergeProps({
        ref: "qfield",
        value: optionSelected.value,
        class: "ws-places-input ws-field",
        "data-test": "ws-places-input"
      }, unref(attrs), {
        "with-input": "",
        "allow-custom-value": "",
        restrict: " 0-9A-Za-z\\u00C0-\\u024F'\\-\\./",
        options: options.value,
        path: __props.path,
        autocomplete: "off",
        "portal-slots": ["option", "no-option"],
        onInput: _cache[0] || (_cache[0] = ($event) => optionSelected.value = $event),
        onInputValue: _cache[1] || (_cache[1] = ($event) => query.value = $event),
        onBlur: handleNoSelected,
        onFilter: filter
      }), createSlots({
        option: withCtx(({ scope }) => [
          createVNode(QItem, mergeProps({ class: "ws-places-input-item" }, scope.itemProps), {
            default: withCtx(() => [
              createVNode(QItemSection, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(get)(searchResults.value, `[${scope.index}].ws_label`) || scope.opt), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040)
        ]),
        _: 2
      }, [
        query.value ? {
          name: "no-option",
          fn: withCtx(() => [
            createVNode(QItem, { class: "ws-places-input-item" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.$t("uikit:ws_places_input.no_results")), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["value", "options", "path"]);
    };
  }
});
const WsPlacesInput = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-73dfd470"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsGoogleAutocomplete",
  props: {
    throttleDelay: {
      type: Number,
      default: 1e3
    }
  },
  emits: ["address-selected"],
  setup(__props, { emit: __emit }) {
    const attrs = useAttrs();
    const props = __props;
    const emit = __emit;
    const loadingResults = ref(false);
    const results = ref([]);
    const onInputChange = throttle$1(async (event) => {
      if (typeof event !== "string") {
        return;
      }
      loadingResults.value = true;
      try {
        results.value = await useGoogleAPI().getPlacePredictions(event, "geocode");
      } catch (e) {
        results.value = [];
      } finally {
        loadingResults.value = false;
      }
    }, props.throttleDelay);
    const onInput = async (event) => {
      loadingResults.value = true;
      const address = await useGoogleAPI().getPlaceAddress(event.place_id);
      emit("address-selected", address);
      loadingResults.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(WsSelect, mergeProps(unref(attrs), {
        options: results.value,
        "with-input": "",
        "allow-custom-value": "",
        loading: loadingResults.value,
        "option-label": (item) => item.description,
        onInputValue: _cache[0] || (_cache[0] = ($event) => unref(onInputChange)($event)),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => onInput($event))
      }), {
        option: withCtx(({ scope }) => [
          createVNode(QItem, normalizeProps(guardReactiveProps(scope.itemProps)), {
            default: withCtx(() => [
              createVNode(QItemSection, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(scope.opt.description), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040)
        ]),
        "no-option": withCtx(() => [
          createVNode(QItem, null, {
            default: withCtx(() => [
              createVNode(QItemSection, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$t("uikit:ws_google_autocomplete.no_results")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["options", "loading", "option-label"]);
    };
  }
});
const SIZE_LIST = ["sm", "md", "lg", "xl"];
const { passive } = listenOpts;
const Screen = createReactivePlugin({
  width: 0,
  height: 0,
  name: "xs",
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false
}, {
  setSizes: noop,
  setDebounce: noop,
  install({ $q, onSSRHydrated }) {
    $q.screen = this;
    if (this.__installed === true) {
      if ($q.config.screen !== void 0) {
        if ($q.config.screen.bodyClasses === false) {
          document.body.classList.remove(`screen--${this.name}`);
        } else {
          this.__update(true);
        }
      }
      return;
    }
    const { visualViewport } = window;
    const target2 = visualViewport || window;
    const scrollingElement = document.scrollingElement || document.documentElement;
    const getSize = visualViewport === void 0 || client.is.mobile === true ? () => [
      Math.max(window.innerWidth, scrollingElement.clientWidth),
      Math.max(window.innerHeight, scrollingElement.clientHeight)
    ] : () => [
      visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth,
      visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight
    ];
    const classes = $q.config.screen !== void 0 && $q.config.screen.bodyClasses === true;
    this.__update = (force) => {
      const [w, h2] = getSize();
      if (h2 !== this.height) {
        this.height = h2;
      }
      if (w !== this.width) {
        this.width = w;
      } else if (force !== true) {
        return;
      }
      let s = this.sizes;
      this.gt.xs = w >= s.sm;
      this.gt.sm = w >= s.md;
      this.gt.md = w >= s.lg;
      this.gt.lg = w >= s.xl;
      this.lt.sm = w < s.sm;
      this.lt.md = w < s.md;
      this.lt.lg = w < s.lg;
      this.lt.xl = w < s.xl;
      this.xs = this.lt.sm;
      this.sm = this.gt.xs === true && this.lt.md === true;
      this.md = this.gt.sm === true && this.lt.lg === true;
      this.lg = this.gt.md === true && this.lt.xl === true;
      this.xl = this.gt.lg;
      s = this.xs === true && "xs" || this.sm === true && "sm" || this.md === true && "md" || this.lg === true && "lg" || "xl";
      if (s !== this.name) {
        if (classes === true) {
          document.body.classList.remove(`screen--${this.name}`);
          document.body.classList.add(`screen--${s}`);
        }
        this.name = s;
      }
    };
    let updateEvt, updateSizes = {}, updateDebounce = 16;
    this.setSizes = (sizes) => {
      SIZE_LIST.forEach((name) => {
        if (sizes[name] !== void 0) {
          updateSizes[name] = sizes[name];
        }
      });
    };
    this.setDebounce = (deb) => {
      updateDebounce = deb;
    };
    const start = () => {
      const style = getComputedStyle(document.body);
      if (style.getPropertyValue("--q-size-sm")) {
        SIZE_LIST.forEach((name) => {
          this.sizes[name] = parseInt(style.getPropertyValue(`--q-size-${name}`), 10);
        });
      }
      this.setSizes = (sizes) => {
        SIZE_LIST.forEach((name) => {
          if (sizes[name]) {
            this.sizes[name] = sizes[name];
          }
        });
        this.__update(true);
      };
      this.setDebounce = (delay) => {
        updateEvt !== void 0 && target2.removeEventListener("resize", updateEvt, passive);
        updateEvt = delay > 0 ? debounce(this.__update, delay) : this.__update;
        target2.addEventListener("resize", updateEvt, passive);
      };
      this.setDebounce(updateDebounce);
      if (Object.keys(updateSizes).length !== 0) {
        this.setSizes(updateSizes);
        updateSizes = void 0;
      } else {
        this.__update();
      }
      classes === true && this.name === "xs" && document.body.classList.add("screen--xs");
    };
    if (isRuntimeSsrPreHydration.value === true) {
      onSSRHydrated.push(start);
    } else {
      start();
    }
  }
});
const Plugin$2 = createReactivePlugin({
  isActive: false,
  mode: false
}, {
  __media: void 0,
  set(val) {
    Plugin$2.mode = val;
    if (val === "auto") {
      if (Plugin$2.__media === void 0) {
        Plugin$2.__media = window.matchMedia("(prefers-color-scheme: dark)");
        Plugin$2.__updateMedia = () => {
          Plugin$2.set("auto");
        };
        Plugin$2.__media.addListener(Plugin$2.__updateMedia);
      }
      val = Plugin$2.__media.matches;
    } else if (Plugin$2.__media !== void 0) {
      Plugin$2.__media.removeListener(Plugin$2.__updateMedia);
      Plugin$2.__media = void 0;
    }
    Plugin$2.isActive = val === true;
    document.body.classList.remove(`body--${val === true ? "light" : "dark"}`);
    document.body.classList.add(`body--${val === true ? "dark" : "light"}`);
  },
  toggle() {
    {
      Plugin$2.set(Plugin$2.isActive === false);
    }
  },
  install({ $q, ssrContext }) {
    const { dark } = $q.config;
    $q.dark = this;
    if (this.__installed !== true) {
      this.set(dark !== void 0 ? dark : false);
    }
  }
});
function setCssVar(propName, value, element = document.body) {
  if (typeof propName !== "string") {
    throw new TypeError("Expected a string as propName");
  }
  if (typeof value !== "string") {
    throw new TypeError("Expected a string as value");
  }
  if (!(element instanceof Element)) {
    throw new TypeError("Expected a DOM element");
  }
  element.style.setProperty(`--q-${propName}`, value);
}
function getMobilePlatform(is) {
  if (is.ios === true) return "ios";
  if (is.android === true) return "android";
}
function getBodyClasses({ is, has, within }, cfg) {
  const cls = [
    is.desktop === true ? "desktop" : "mobile",
    `${has.touch === false ? "no-" : ""}touch`
  ];
  if (is.mobile === true) {
    const mobile = getMobilePlatform(is);
    mobile !== void 0 && cls.push("platform-" + mobile);
  }
  if (is.nativeMobile === true) {
    const type = is.nativeMobileWrapper;
    cls.push(type);
    cls.push("native-mobile");
    if (is.ios === true && (cfg[type] === void 0 || cfg[type].iosStatusBarPadding !== false)) {
      cls.push("q-ios-padding");
    }
  } else if (is.electron === true) {
    cls.push("electron");
  } else if (is.bex === true) {
    cls.push("bex");
  }
  within.iframe === true && cls.push("within-iframe");
  return cls;
}
function applyClientSsrCorrections() {
  const { is } = client;
  const classes = document.body.className;
  const classList = new Set(classes.replace(/ {2}/g, " ").split(" "));
  if (is.nativeMobile !== true && is.electron !== true && is.bex !== true) {
    if (is.desktop === true) {
      classList.delete("mobile");
      classList.delete("platform-ios");
      classList.delete("platform-android");
      classList.add("desktop");
    } else if (is.mobile === true) {
      classList.delete("desktop");
      classList.add("mobile");
      classList.delete("platform-ios");
      classList.delete("platform-android");
      const mobile = getMobilePlatform(is);
      if (mobile !== void 0) {
        classList.add(`platform-${mobile}`);
      }
    }
  }
  if (client.has.touch === true) {
    classList.delete("no-touch");
    classList.add("touch");
  }
  if (client.within.iframe === true) {
    classList.add("within-iframe");
  }
  const newCls = Array.from(classList).join(" ");
  if (classes !== newCls) {
    document.body.className = newCls;
  }
}
function setColors(brand) {
  for (const color in brand) {
    setCssVar(color, brand[color]);
  }
}
const Body = {
  install(opts) {
    if (this.__installed === true) return;
    if (isRuntimeSsrPreHydration.value === true) {
      applyClientSsrCorrections();
    } else {
      const { $q } = opts;
      $q.config.brand !== void 0 && setColors($q.config.brand);
      const cls = getBodyClasses(client, $q.config);
      document.body.classList.add.apply(document.body.classList, cls);
    }
    if (client.is.ios === true) {
      document.body.addEventListener("touchstart", noop);
    }
    window.addEventListener("keydown", onKeyDownComposition, true);
  }
};
const defaultLang = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (label) => label ? `Expand "${label}"` : "Expand",
    collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: "days"
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (start, end, total) => start + "-" + end + " of " + total,
    columns: "Columns"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function getLocale() {
  const val = Array.isArray(navigator.languages) === true && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof val === "string") {
    return val.split(/[-_]/).map((v, i) => i === 0 ? v.toLowerCase() : i > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
  }
}
const Plugin$1 = createReactivePlugin({
  __qLang: {}
}, {
  // props: object
  // __langConfig: object
  getLocale,
  set(langObject = defaultLang, ssrContext) {
    const lang = {
      ...langObject,
      rtl: langObject.rtl === true,
      getLocale
    };
    {
      lang.set = Plugin$1.set;
      if (Plugin$1.__langConfig === void 0 || Plugin$1.__langConfig.noHtmlAttrs !== true) {
        const el = document.documentElement;
        el.setAttribute("dir", lang.rtl === true ? "rtl" : "ltr");
        el.setAttribute("lang", lang.isoName);
      }
      Object.assign(Plugin$1.__qLang, lang);
    }
  },
  install({ $q, lang, ssrContext }) {
    {
      $q.lang = Plugin$1.__qLang;
      Plugin$1.__langConfig = $q.config.lang;
      if (this.__installed === true) {
        lang !== void 0 && this.set(lang);
      } else {
        this.props = new Proxy(this.__qLang, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set" && key !== "getLocale");
          }
        });
        this.set(lang || defaultLang);
      }
    }
  }
});
const materialIcons = {
  name: "material-icons",
  type: {
    positive: "check_circle",
    negative: "warning",
    info: "info",
    warning: "priority_high"
  },
  arrow: {
    up: "arrow_upward",
    right: "arrow_forward",
    down: "arrow_downward",
    left: "arrow_back",
    dropdown: "arrow_drop_down"
  },
  chevron: {
    left: "chevron_left",
    right: "chevron_right"
  },
  colorPicker: {
    spectrum: "gradient",
    tune: "tune",
    palette: "style"
  },
  pullToRefresh: {
    icon: "refresh"
  },
  carousel: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down",
    navigationIcon: "lens"
  },
  chip: {
    remove: "cancel",
    selected: "check"
  },
  datetime: {
    arrowLeft: "chevron_left",
    arrowRight: "chevron_right",
    now: "access_time",
    today: "today"
  },
  editor: {
    bold: "format_bold",
    italic: "format_italic",
    strikethrough: "strikethrough_s",
    underline: "format_underlined",
    unorderedList: "format_list_bulleted",
    orderedList: "format_list_numbered",
    subscript: "vertical_align_bottom",
    superscript: "vertical_align_top",
    hyperlink: "link",
    toggleFullscreen: "fullscreen",
    quote: "format_quote",
    left: "format_align_left",
    center: "format_align_center",
    right: "format_align_right",
    justify: "format_align_justify",
    print: "print",
    outdent: "format_indent_decrease",
    indent: "format_indent_increase",
    removeFormat: "format_clear",
    formatting: "text_format",
    fontSize: "format_size",
    align: "format_align_left",
    hr: "remove",
    undo: "undo",
    redo: "redo",
    heading: "format_size",
    code: "code",
    size: "format_size",
    font: "font_download",
    viewSource: "code"
  },
  expansionItem: {
    icon: "keyboard_arrow_down",
    denseIcon: "arrow_drop_down"
  },
  fab: {
    icon: "add",
    activeIcon: "close"
  },
  field: {
    clear: "cancel",
    error: "error"
  },
  pagination: {
    first: "first_page",
    prev: "keyboard_arrow_left",
    next: "keyboard_arrow_right",
    last: "last_page"
  },
  rating: {
    icon: "grade"
  },
  stepper: {
    done: "check",
    active: "edit",
    error: "warning"
  },
  tabs: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down"
  },
  table: {
    arrowUp: "arrow_upward",
    warning: "warning",
    firstPage: "first_page",
    prevPage: "chevron_left",
    nextPage: "chevron_right",
    lastPage: "last_page"
  },
  tree: {
    icon: "play_arrow"
  },
  uploader: {
    done: "done",
    clear: "clear",
    add: "add_box",
    upload: "cloud_upload",
    removeQueue: "clear_all",
    removeUploaded: "done_all"
  }
};
const Plugin = createReactivePlugin({
  iconMapFn: null,
  __qIconSet: {}
}, {
  // props: object
  set(setObject, ssrContext) {
    const def = { ...setObject };
    {
      def.set = Plugin.set;
      Object.assign(Plugin.__qIconSet, def);
    }
  },
  install({ $q, iconSet: iconSet2, ssrContext }) {
    {
      if ($q.config.iconMapFn !== void 0) {
        this.iconMapFn = $q.config.iconMapFn;
      }
      $q.iconSet = this.__qIconSet;
      injectProp($q, "iconMapFn", () => this.iconMapFn, (val) => {
        this.iconMapFn = val;
      });
      if (this.__installed === true) {
        iconSet2 !== void 0 && this.set(iconSet2);
      } else {
        this.props = new Proxy(this.__qIconSet, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set");
          }
        });
        this.set(iconSet2 || materialIcons);
      }
    }
  }
});
const autoInstalledPlugins = [
  Platform,
  Body,
  Plugin$2,
  Screen,
  History,
  Plugin$1,
  Plugin
];
function installPlugins(pluginOpts, pluginList) {
  pluginList.forEach((Plugin2) => {
    Plugin2.install(pluginOpts);
    Plugin2.__installed = true;
  });
}
function prepareApp(app2, uiOpts, pluginOpts) {
  app2.config.globalProperties.$q = pluginOpts.$q;
  app2.provide(quasarKey, pluginOpts.$q);
  installPlugins(pluginOpts, autoInstalledPlugins);
  uiOpts.components !== void 0 && Object.values(uiOpts.components).forEach((c) => {
    if (isObject(c) === true && c.name !== void 0) {
      app2.component(c.name, c);
    }
  });
  uiOpts.directives !== void 0 && Object.values(uiOpts.directives).forEach((d) => {
    if (isObject(d) === true && d.name !== void 0) {
      app2.directive(d.name, d);
    }
  });
  uiOpts.plugins !== void 0 && installPlugins(
    pluginOpts,
    Object.values(uiOpts.plugins).filter(
      (p) => typeof p.install === "function" && autoInstalledPlugins.includes(p) === false
    )
  );
  if (isRuntimeSsrPreHydration.value === true) {
    pluginOpts.$q.onSSRHydrated = () => {
      pluginOpts.onSSRHydrated.forEach((fn) => {
        fn();
      });
      pluginOpts.$q.onSSRHydrated = () => {
      };
    };
  }
}
const installQuasar = function(parentApp, opts = {}) {
  const $q = { version: "2.17.4" };
  if (globalConfigIsFrozen === false) {
    if (opts.config !== void 0) {
      Object.assign(globalConfig, opts.config);
    }
    $q.config = { ...globalConfig };
    freezeGlobalConfig();
  } else {
    $q.config = opts.config || {};
  }
  prepareApp(parentApp, opts, {
    parentApp,
    $q,
    lang: opts.lang,
    iconSet: opts.iconSet,
    onSSRHydrated: []
  });
};
const Quasar = {
  name: "Quasar",
  version: "2.17.4",
  install: installQuasar,
  // TODO: remove in Qv3 (should only be used through the plugin)
  // We provide a deprecated fallback here
  lang: Plugin$1,
  // TODO: remove in Qv3 (should only be used through the plugin)
  // We provide a deprecated fallback here
  iconSet: Plugin
};
const WsAnalyticsDirective = {
  updated: bind,
  created: bind
};
function bind(el, binding) {
  var _a;
  if (!window.ws_analytics || !binding.value) {
    return null;
  }
  if (!el.getAttribute("data-tracking")) {
    el.setAttribute("data-tracking", binding.value);
  }
  if ((_a = window.ws_analytics.stored) == null ? void 0 : _a[binding.value]) {
    Object.keys(window.ws_analytics.stored[binding.value]).forEach((key) => {
      el.addEventListener(key, window.ws_analytics.stored[binding.value][key]);
    });
    delete window.ws_analytics.stored[binding.value];
  }
}
const WsAutofocusDirective = {
  mounted: function(el, binding) {
    const elementToFocus = typeof binding.value === "string" ? el.querySelector(binding.value) : el;
    if (!elementToFocus) {
      return;
    }
    elementToFocus.setAttribute("tabindex", "0");
    elementToFocus.focus();
  }
};
const version = "6.6.7";
const app = createApp(() => h(HyperApp));
const setupComponents = async (config2) => {
  if (version !== config2.servicesVersion) {
    throw new Error(`Services package version mismatch. 
          Expected: ${version}, got: ${config2.servicesVersion}`);
  }
  prepareUikitWrapper(config2);
  setupPortalSlot(window._WS_COMPONENTS_PACKAGE_TARGET);
  app.component("PortalSlot", PortalSlot);
  app.directive("ws-analytics", WsAnalyticsDirective);
  app.directive("ws-autofocus", WsAutofocusDirective);
  app.use(VueTippy, {
    component: "tippy"
  });
  setupMessages({ translate: config2.i18next.t });
  setupTheming();
  setupTranslationPlugin(config2);
  app.use(Quasar, { config: { lang: { noHtmlAttrs: true } } });
  app.mount(config2.mountTarget || "#uikit-app");
  setupQuasarIconSet();
};
const iconSet = Quasar.iconSet;
const setCustomIcon = async (iconName, path) => {
  var _a;
  const icon = await loadIcon(iconName);
  const svg = decodeURIComponent(icon.replace("data:image/svg+xml,", ""));
  const quasarFormat = (_a = svg.match(/d=['"](.*?)['"]/)) == null ? void 0 : _a[1];
  set(iconSet, path, quasarFormat);
};
async function setupQuasarIconSet() {
  await setCustomIcon("arrow_down", "arrow.down");
  Quasar.iconSet.set(iconSet);
}
function prepareUikitWrapper(config2) {
  if (!config2.mountTarget) {
    const uikitEl = document.createElement("div");
    uikitEl.setAttribute("id", "uikit-app");
    document.querySelector("body").appendChild(uikitEl);
  }
}
app.use(themingPlugin);
function setupTranslationPlugin(config2) {
  document.documentElement.lang = config2.i18next.language;
  if (config2.i18next) {
    app.use(I18NextVue, {
      i18next: config2.i18next,
      rerenderOn: ["languageChanged"]
    });
  }
}
function setupTheming() {
  const { theme } = useTheming();
  setupLoader(() => theme.value);
}
export {
  TestItem,
  _sfc_main$q as WsBack,
  WsButton,
  _sfc_main$2 as WsButtonDropdown,
  WsButtonEnum,
  WsCarySpinner,
  WsCopy,
  WsCountryFlag,
  WsDelimiter,
  WsEllipsisShortener,
  WsEmptyMarkupTable,
  WsExpandableText,
  _sfc_main as WsGoogleAutocomplete,
  WsHelpSection,
  WsHorizontalDivider,
  _sfc_main$y as WsHtml,
  WsIcon,
  WsInput,
  _sfc_main$i as WsLabelLink,
  WsLinearProgress,
  WsLoginAside,
  WsLoginCard,
  _sfc_main$5 as WsMarkupTable,
  WsPasswordInput,
  WsPhoneInput,
  WsPlaceholderLoader,
  WsPlacesInput,
  WsPriceBadge,
  WsPriceBadgeEnum,
  WsQrCode,
  _sfc_main$9 as WsRadio,
  WsRadioColors$1 as WsRadioEnum,
  WsSelect,
  WsSelectLanguage,
  WsSelectOptionWithList,
  WsSpinner,
  SpinnerType$1 as WsSpinnerEnum,
  WsStateBanner,
  WsStateBannerEnum,
  WsTag,
  WsTagEnum,
  WsTimeline,
  _sfc_main$g as WsTimelineStep,
  WsTimelineStepEnum,
  _sfc_main$B as WsTooltip,
  WsTwoFactorAuthenticationInput,
  WsTwoFactorAuthenticationInputEnum,
  WsUsersList,
  app,
  setupComponents,
  uikitRenderer
};
//# sourceMappingURL=core.es.js.map
